<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div :class="['widget-one-layer', Number(opensafe) === 0 ? 'opensafe' : '', isNews ? 'widget-one-layer-news' : '']" :style="ruleListChildType==3?'width: 100%;padding:0;':''">
    <el-row
      :gutter="40"
      type="flex"
      style="flex-wrap: wrap;"
      :class="[
        'widget-one-layer-row', 
        layout == 14 || layout == 12 ? 'col4' : '', 
        isPhonelayout ? 'phonelayout-t' : '', 
        tipsize === 16 ? 'label-zh' : '',
        isFiexdCanvas ? 'fiexd-canvas' : ''
      ]"
    >
      <slot></slot>
      <template v-for="(item,index) in ruleListChild">
        <!-- 定位控件 -->
        <el-col
          :span="24"
          v-if="item.type=='location'"
          v-show="getHide(item)"
          :key="item.id"
          :style="getLabelBack(item, index)"
          class="container-wrap"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="item.title"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >            
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="tool-location">
              <location :isView="item.per == 1 && !getUpcontroll(item) ? false : true" :config="item" :value="formdata[item.title + '_' + item.type]" @getLocationVal="getLocationVal" />
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 容器控件 -->
        <el-col
          :span="24"
          v-if="item.type=='container'"
          v-show="onAssVisiblel(item,index) && getHide(item)"
          :key="item.id"
          :style="getLabelBack(item, index)"
          class="container-wrap"
        >
          <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div v-if="getLabelName(item)" class="container-title ellipsis">{{getLabelName(item)}}</div>
            <div class="container-cont">
              <div class="con-row" v-for="itemSub in item.containerList" :key="itemSub + '2'">
                <template v-for="itemInner in getConterList(itemSub)">
                  <!-- 文本 -->
                  <div v-if="ruleListChild[itemInner].type=='text'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])"
                    >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div class="on-show" v-if="ruleListChild[itemInner].onShow">
                        <div class="on-show-show"
                              v-show="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]"
                              @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])">
                          <i class="iconfont icon-dakaiyanjing" />
                          {{ruleListChild[itemInner].placeholder}}
                        </div>
                        <i class="iconfont icon-guanbiyanjing on-show-close"
                            @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])" />
                      </div>
                      <div :class="[
                        classFun(item, formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type],formdata),
                        'input-details',
                        ruleListChild[itemInner].queryOnly && ruleListChild[itemInner].dataconfig && ruleListChild[itemInner].dataconfig.setUpValue && ruleListChild[itemInner].dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
                      ]">
                        <template v-if="ruleListChild[itemInner].per && ruleListChild[itemInner].per === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <span v-if="ruleListChild[itemInner].format && ruleListChild[itemInner].format.value !== 'routine' && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && !isNaN(sliceEncrypt(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type],ruleListChild[itemInner].encrypt))" class="right-block-text" :style="[{paddingTop: '8px', paddingBottom: '8px', lineHeight: '24px'}, ruleListChild[itemInner].format && ruleListChild[itemInner].format.markedRed && (ruleListChild[itemInner].format.value === 'number'||ruleListChild[itemInner].format.value === 'currency') && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] < 0 ? {color: 'red'} : '']"  :class="ruleListChild[itemInner].isLink ? 'text-link' : ''" @click="openLinkText(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner])">
                            <template v-if="(ruleListChild[itemInner].format.value==='currency' || ruleListChild[itemInner].format.value==='accounting') && ruleListChild[itemInner].format.currency !== '万元'">
                              {{ruleListChild[itemInner].format.currency}}
                            </template>
                            {{sliceEncrypt(sliceEncrypt(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type],ruleListChild[itemInner].encrypt),ruleListChild[itemInner].encrypt)||'&nbsp;'}}
                            <!-- 百分比符号、自定义符号 -->
                            <template v-if="ruleListChild[itemInner].format && ruleListChild[itemInner].format.value==='percentage'">%</template>
                            <template v-else-if="ruleListChild[itemInner].format && ruleListChild[itemInner].format.value==='number'">{{ruleListChild[itemInner].format.customSymbols}}</template>
                            <template v-else-if="isWYFN(ruleListChild[itemInner])">{{ruleListChild[itemInner].format.currency}}</template>
                          </span>
                          <span v-else class="right-block-text" style="padding-top: 8px;padding-bottom:8px;line-height:24px;"  :class="ruleListChild[itemInner].isLink ? 'text-link' : ''" @click="openLinkText(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner])">
                            {{sliceEncrypt(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type],ruleListChild[itemInner].encrypt)||'&nbsp;'}}
                          </span>
                        </template>
                        <template v-else>
                          <!-- 文本输入 -->
                          <div v-if="ruleListChild[itemInner].queryOnly && ruleListChild[itemInner].dataconfig && ruleListChild[itemInner].dataconfig.setUpValue && ruleListChild[itemInner].dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                            <div class="on-show-show on-show-left" style="pointer-events:none;">
                              <i class="iconfont icon-shujuchaxun" />
                              {{ruleListChild[itemInner].placeholder}}
                            </div>
                          </div>
            <!--            @blur="approvalProcess(item, '', formdata)"    -->
                          <el-autocomplete
                            style="width: 100%;"
                            size="large"
                            :ref="ruleListChild[itemInner].title"
                            popper-class="select-text"
                            :maxlength="ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit !== 'Infinity' > 0 ? Number(ruleListChild[itemInner].sizeLimit) : undefined"
                            v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                            :fetch-suggestions="querySearchAsync"
                            :placeholder="ruleListChild[itemInner].placeholder"
                            @focus="autocompleteFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]); conditionLink(ruleListChild[itemInner]); setAi(ruleListChild[itemInner])"
                            @change="approvalProcess(ruleListChild[itemInner], '', formdata)"
                            @blur="conditionLinkObj = null; setAi(null)"
                            @input="autoinputFun($event, ruleListChild[itemInner])"
                            @select="approvalProcess(ruleListChild[itemInner], '', formdata)"
                            :disabled="ruleListChild[itemInner].exhibiIs"
                            :readonly="ruleListChild[itemInner].type === 'text' && Number(ruleListChild[itemInner].disSearch) === 1"
                          ></el-autocomplete>
                          <!-- 错误提示 -->
                          <span
                            class="textarea-right"
                            v-if="ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit !== 'Infinity'"
                          >{{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] ? formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length : 0}}/{{ruleListChild[itemInner].sizeLimit}}</span>
                        </template>
                        <span
                          class="icon-text"
                          @click="onUp(item)"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 数值 -->
                  <div v-else-if="ruleListChild[itemInner].type=='number'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])"
                  >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required === 'required', trigger: 'false' }]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])">
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <span class="right-block-text right-block-number"
                            v-if="ruleListChild[itemInner].format && ruleListChild[itemInner].format.value !== 'routine'"
                            :style="{
                              color:ruleListChild[itemInner].format && ruleListChild[itemInner].format.markedRed &&
                              (ruleListChild[itemInner].format.value === 'number'||ruleListChild[itemInner].format.value === 'currency') &&
                              formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] < 0 ? 'red': '',
                              justifyContent: ruleListChild[itemInner].format && ruleListChild[itemInner].format.value==='accounting'?'space-between':''
                            }">
                            <span>
                              <!-- 货币符号 -->
                              <template v-if="(ruleListChild[itemInner].format.value === 'currency' || ruleListChild[itemInner].format.value==='accounting') && ruleListChild[itemInner].format.currency !== '万元'">
                                {{ruleListChild[itemInner].format.currency}}
                              </template>
                            </span>
                            <span>
                              {{numberFormat(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner] )}}
                              <!-- 百分比符号、自定义符号 -->
                              <template v-if="ruleListChild[itemInner].format.value==='percentage'">%</template>
                              <template v-else-if="ruleListChild[itemInner].format.value==='number'">{{ruleListChild[itemInner].format.customSymbols}}</template>
                              <template v-else-if="isWYFN(ruleListChild[itemInner])">{{ruleListChild[itemInner].format.currency}}</template>
                            </span>
                          </span>
                          <span v-else class="right-block-text right-block-number">{{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]}}</span>
                        </template>
                        <template v-if="!(ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2) && !getUpcontroll(ruleListChild[itemInner])">
                          <template v-if="isWYFN(ruleListChild[itemInner], true)">
                            <el-input-number
                              v-model="tempFormdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              class="input-details"
                              size="large"
                              :step="ruleListChild[itemInner].step"
                              label="描述文字"
                              style="width:80%"
                              controls-position="right"
                              @keyup="(e) => { numDecimal(e, ruleListChild[itemInner].format.value!=='routine'?ruleListChild[itemInner].format.decimal:null); handleNumKeyup(e, ruleListChild[itemInner]); }"
                              :placeholder="ruleListChild[itemInner].placeholder||'请输入'"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              :disabled="ruleListChild[itemInner].exhibiIs"
                              ></el-input-number>
                            <span>万元</span>
                          </template>
                          <el-input-number
                            v-else
                            v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                            class="input-details"
                            size="large"
                            :step="ruleListChild[itemInner].step"
                            label="描述文字"
                            style="width:100%"
                            controls-position="right"
                            @keyup="(e) => { numDecimal(e, ruleListChild[itemInner].format.value!=='routine'?ruleListChild[itemInner].format.decimal:null); handleNumKeyup(e, ruleListChild[itemInner]); }"
                            :placeholder="ruleListChild[itemInner].placeholder||'请输入'"
                            @change="approvalProcess(ruleListChild[itemInner])"
                            :disabled="ruleListChild[itemInner].exhibiIs"
                          ></el-input-number>
                        </template>
                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 单选 -->
                  <div v-else-if="ruleListChild[itemInner].type=='radio'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])"
                  >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div class="on-show" v-if="ruleListChild[itemInner].onShow">
                        <div class="on-show-show"
                              v-show="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]"
                              @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])">
                          <i class="iconfont icon-dakaiyanjing" />
                          {{ruleListChild[itemInner].placeholder}}
                        </div>
                        <i class="iconfont icon-guanbiyanjing on-show-close on-select"
                            @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])" />
                      </div>
                      <div>
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <p class="right-block-text radio-list-view">
                            <span
                              v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              :class="['list-block', ruleListChild[itemInner].types && ruleListChild[itemInner].types === 2 ? 'radio-list-imgs' : '', ruleListChild[itemInner].types && ruleListChild[itemInner].types === 3 ? 'radio-list-button' : '', ruleListChild[itemInner].types && ruleListChild[itemInner].types === 6 ? 'no-back' : '']"
                              :style="[{marginBottom: 0}, ruleListChild[itemInner].selsItemColor && ruleListChild[itemInner].selsItemColor[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]] ? {backgroundColor: ruleListChild[itemInner].selsItemColor[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]], color:ruleListChild[itemInner].selsItemColor&&ruleListChild[itemInner].selsItemColor[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]] ? '#fff':'#333'} : {padding: 0}]"
                            >
                              <template v-if="ruleListChild[itemInner].types && ruleListChild[itemInner].types === 2">
                                <el-image v-if="ruleListChild[itemInner].selsItemImg && ruleListChild[itemInner].selsItemImg[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]]"
                                          class="radio-list-img"
                                          :src="$imgurl + ruleListChild[itemInner].selsItemImg[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]] + '?accesstoken=' + token"></el-image>
                                <span v-else class="radio-list-img">
                                  <el-icon class="no-icon"><Picture /></el-icon>
                                </span>
                                <span class="radio-list-text ellipsis" :style="getButtonStyle(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner])">
                                  {{getRadioLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner]))}}
                                </span>
                              </template>
                              <template v-else-if="ruleListChild[itemInner].types && ruleListChild[itemInner].types === 5">
                                {{getRadioProvinces(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner])}}
                              </template>
                              <radioXing v-else-if="ruleListChild[itemInner].types && ruleListChild[itemInner].types === 6" :sels="objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])" :value="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" :edit="false" />
                              <template v-else>
                                {{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] === 'others其他' && ruleListChild[itemInner].others ? '其他' : getRadioLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner]))}}
                              </template>
                            </span>&nbsp;
                          </p>
                          <span
                            class="right-block-text"
                            style="margin-top: 22px;"
                            v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] === 'others其他' && ruleListChild[itemInner].others"
                          >{{ruleListChild[itemInner].othersVal}}</span>
                        </template>
                        <!--radio跟select互换了格式-->
                        <template v-else>
                          <div v-if="ruleListChild[itemInner].types && Number (ruleListChild[itemInner].types) !== 0" :class="ruleListChild[itemInner].isCut ? 'r-c-block' : ''">
                            <div v-if="ruleListChild[itemInner].isCut" class="r-c-header">
                              <div :class="['r-c-list', cutObj[ruleListChild[itemInner].title] === its.label ? 'r-c-list-active' : '']"
                                    v-for="(its, itsI) in ruleListChild[itemInner].cutList"
                                    @click="$set(cutObj, ruleListChild[itemInner].title, its.label)"
                                    :key="ruleListChild[itemInner].title + itsI">
                                {{ its.label }}
                              </div>
                            </div>
                            <div :class="ruleListChild[itemInner].isCut ? 'r-c-content' : ''">
                              <el-radio-group v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                              @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)"
                                              v-if="Number(ruleListChild[itemInner].types) === 1">
                                <template v-for="sels in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <el-radio v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value || sels">
                                    <span
                                      class="radiovalue"
                                      v-if="ruleListChild[itemInner].selsItemColor"
                                      :style="{backgroundColor:ruleListChild[itemInner].selsItemColor[sels.value || sels],color:ruleListChild[itemInner].selsItemColor[sels.value || sels]?'#fff':''}"
                                    >{{sels.label || sels}}</span>
                                    <template v-else>
                                      {{ sels.label || sels }}
                                    </template>
                                  </el-radio>
                                </template>
                                <el-radio label="others其他" v-if="ruleListChild[itemInner].others">其他</el-radio>
                              </el-radio-group>
                              <div v-else-if="Number(ruleListChild[itemInner].types) === 2" class="radio-list">
                                <template v-for="(its, indexIts) in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <div v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[its.value || its]"
                                      :key="indexIts + (its.value || its)"
                                      class="radio-list-imgs"
                                      :style="getButtonBlock(its.value || its, ruleListChild[itemInner])"
                                      @click="setRadio({val: its.value || its, item: ruleListChild[itemInner]})">
                                    <el-image v-if="ruleListChild[itemInner].selsItemImg && ruleListChild[itemInner].selsItemImg[its.value || its]"
                                              class="radio-list-img"
                                              :src="$imgurl + ruleListChild[itemInner].selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                    <div v-else class="radio-list-img">
                                      <el-icon class="no-icon"><Picture /></el-icon>
                                    </div>
                                    <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, ruleListChild[itemInner])">{{its.label || its}}</div>
                                  </div>
                                </template>
                              </div>
                              <div v-else-if="Number(ruleListChild[itemInner].types) === 3" class="radio-list" style="margin-bottom:-10px;">
                                <template v-for="(its, indexIts) in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <div v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[its.value || its]"
                                    :key="indexIts + (its.value || its)"
                                    @click="setRadio({val: its.value || its, item: ruleListChild[itemInner]})"
                                    :style="getRadioStyle(its.value || its, ruleListChild[itemInner])"
                                    class="radio-list-button">{{its.label || its}}</div>
                                </template>
                              </div>
                              <div class="radio-switch" v-else-if="Number(ruleListChild[itemInner].types) === 4">
                                <template v-if="ruleListChild[itemInner].switchStyle && ruleListChild[itemInner].switchStyle === 3">
                                  <el-checkbox size="large" v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                              :true-label="getSwitchColor({ele: ruleListChild[itemInner], type: 'active',isGet: true})"
                                              :false-label="getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive',isGet: true})"
                                              @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)" />
                                </template>
                                <el-switch v-else 
                                  :active-value="getSwitchColor({ele: ruleListChild[itemInner], type: 'active',isGet: true})"
                                  :inactive-value="getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive',isGet: true})"
                                  :active-color="getSwitchColor({ele: ruleListChild[itemInner], type: 'active'})"
                                  :inactive-color="getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive'})"
                                  :inactive-text="ruleListChild[itemInner].switchStyle === 1 ? '' : getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive', isGet: true})"
                                  :active-text="ruleListChild[itemInner].switchStyle === 1 ? '' : getSwitchColor({ele: ruleListChild[itemInner], type: 'active', isGet: true})"
                                  v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                  @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)"
                                />
                              </div>
                              <multilevel v-else-if="Number(ruleListChild[itemInner].types) === 5" :config="ruleListChild[itemInner].multilevelConfig" :formdata="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" 
                              @update:formdata="handleFormdataUpdata(ruleListChild[itemInner], $event)" @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)" :placeholder="ruleListChild[itemInner].placeholder" />
                              <radioXing v-else-if="Number(ruleListChild[itemInner].types) === 6" :sels="objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])" :value="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" :edit="true" @upXing="val => upXing(val, ruleListChild[itemInner])" />
                            </div>
                          </div>
                          <div v-else :class="ruleListChild[itemInner].isCut ? 'r-c-select' : ''">
                            <el-select v-if="ruleListChild[itemInner].isCut" v-model="cutObj[ruleListChild[itemInner].title]" size="large" style="margin-right:12px;">
                              <el-option v-for="(itss, indexItss) in ruleListChild[itemInner].cutList"
                                :key="ruleListChild[itemInner].title + indexItss + 'a'"
                                :value="itss.label"
                                :label="itss.label"></el-option>
                            </el-select>
                            <el-select
                                v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                :placeholder="ruleListChild[itemInner].placeholder"
                                class="input-details select-details check-inp"
                                size="large"
                                style="width: 100%"
                                filterable
                                clearable
                                @focus="conditionLink(ruleListChild[itemInner])"
                                :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                                @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)"
                                @visible-change="onselschange($event,ruleListChild[itemInner])"
                                :disabled="ruleListChild[itemInner].exhibiIs"
                              >
                                <template #prefix>
                                  <div style="height:31px;line-height:31px;margin-top:3px" v-if="!radioBlur[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]">
                                    <span
                                      v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]!=='others其他' && getRadioLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner]))"
                                      class="ridiotagstyle ellipsis"
                                      :style="{backgroundColor:ruleListChild[itemInner].selsItemColor&&ruleListChild[itemInner].selsItemColor[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]],color:ruleListChild[itemInner].selsItemColor&&ruleListChild[itemInner].selsItemColor[formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]]?'#fff':'#333'}"
                                    >
                                      {{getRadioLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner]))}}
                                    </span>
                                    <span v-else style="padding-left: 5px;">{{ruleListChild[itemInner].placeholder}}</span>
                                  </div>
                                </template>
                                <template v-for="(sels, selsIndex) in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <el-option
                                  v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[sels.value || sels]"
                                    :key="selsIndex"
                                    :label="sels.label || sels"
                                    :value="sels.value || sels"
                                  >
                                    <span
                                      v-if="ruleListChild[itemInner].selsItemColor"
                                      :style="{backgroundColor:ruleListChild[itemInner].selsItemColor[sels.value || sels],color:ruleListChild[itemInner].selsItemColor[sels.value || sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                                    >{{sels.label || sels}}</span>
                                  </el-option>
                                </template>
                                <el-option key="others" label="其他" value="others其他" v-if="ruleListChild[itemInner].others">
                                  <span :style="{backgroundColor:'#fff',padding:'4px 8px',borderRadius:'10px'}">
                                    其他
                                  </span>
                                </el-option>
                            </el-select>
                            <!-- 其他 -->
                            <template
                              v-if="ruleListChild[itemInner].others && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] === 'others其他'"
                            >
                              <input
                                type="text"
                                placeholder="请输入内容"
                                :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner].othersVal)"
                                class="other-class"
                                v-model="ruleListChild[itemInner].othersVal"
                                @blur="approvalProcess(ruleListChild[itemInner],'others其他')"
                              />
                            </template>
                          </div>
                        </template>

                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 多选 -->
                  <div v-else-if="ruleListChild[itemInner].type=='checkbox'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])"
                  >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>

                      <div class="on-show" v-if="ruleListChild[itemInner].onShow">
                        <div class="on-show-show"
                              v-show="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]"
                              @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])">
                          <i class="iconfont icon-dakaiyanjing" />
                          {{ruleListChild[itemInner].placeholder}}
                        </div>
                        <i class="iconfont icon-guanbiyanjing on-show-close on-select"
                            @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])" />
                      </div>

                      <div :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])" :style="ruleListChild[itemInner].types && (ruleListChild[itemInner].types === 1 || ruleListChild[itemInner].types === 3) ? 'background-color: transparent;' : ''">
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <span class="right-block-text">
                            <span
                              :style="{backgroundColor:ruleListChild[itemInner].selsItemColor? ruleListChild[itemInner].selsItemColor[list] : '#fff',color:ruleListChild[itemInner].selsItemColor&&ruleListChild[itemInner].selsItemColor[list] ? '#fff' : '#333'}"
                              class="list-block"
                              v-for="list in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]||[]"
                              :key="list"
                            >{{list}}</span>&nbsp;
                          </span>
                        </template>
                        <template v-else>
                          <div v-if="ruleListChild[itemInner].types && Number (ruleListChild[itemInner].types) !== 0" :class="ruleListChild[itemInner].isCut ? 'r-c-block' : ''">
                            <div v-if="ruleListChild[itemInner].isCut" class="r-c-header">
                              <div :class="['r-c-list', cutObj[ruleListChild[itemInner].title] === its.label ? 'r-c-list-active' : '']"
                                    v-for="(its, itsI) in ruleListChild[itemInner].cutList"
                                    @click="$set(cutObj, ruleListChild[itemInner].title, its.label)"
                                    :key="ruleListChild[itemInner].title + itsI">
                                {{ its.label }}
                              </div>
                            </div>
                            <div :class="ruleListChild[itemInner].isCut ? 'r-c-content' : ''">
                              <el-checkbox-group v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              size="large"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              v-if="ruleListChild[itemInner].types && ruleListChild[itemInner].types === 1">
                                <template v-for="sels in objSels(ruleListChild[itemInner].sels, item)">
                                  <el-checkbox v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[sels.value || sels]" :label="sels" :key="sels.value || sels">
                                    <span
                                      class="checkboxvalue"
                                      v-if="ruleListChild[itemInner].selsItemColor"
                                      :style="{backgroundColor:ruleListChild[itemInner].selsItemColor[sels],color:ruleListChild[itemInner].selsItemColor[sels]?'#fff':''}"
                                    >{{sels}}</span>
                                  </el-checkbox>
                                </template>
                              </el-checkbox-group>
                              <div v-else-if="Number(ruleListChild[itemInner].types) === 2" class="radio-list">
                                <template v-for="(its, indexIts) in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <div v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[its.value || its]"
                                      :key="indexIts + (its.value || its)"
                                      class="radio-list-imgs"
                                      :style="getButtonBlock(its.value || its, ruleListChild[itemInner], true)"
                                      @click="setCheck({val: its.value || its, item: ruleListChild[itemInner]})">
                                    <el-image v-if="ruleListChild[itemInner].selsItemImg && ruleListChild[itemInner].selsItemImg[its.value || its]"
                                              class="radio-list-img"
                                              :src="$imgurl + ruleListChild[itemInner].selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                                    <div v-else class="radio-list-img">
                                      <el-icon class="no-icon"><Picture /></el-icon>
                                    </div>
                                    <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, ruleListChild[itemInner], true)">{{its.label || its}}</div>
                                  </div>
                                </template>
                              </div>
                              <div v-else-if="Number(ruleListChild[itemInner].types) === 3" class="radio-list" style="margin-bottom:-10px;">
                                <template v-for="(its, indexIts) in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                  <div v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[its.value || its]"
                                    :key="indexIts + (its.value || its)"
                                    @click="setCheck({val: its.value || its, item: ruleListChild[itemInner]})"
                                    :style="getRadioStyle(its.value || its, ruleListChild[itemInner])"
                                    class="radio-list-button">{{its.label || its}}</div>
                                </template>
                              </div>
                              <div class="radio-switch" v-else-if="Number(ruleListChild[itemInner].types) === 4">
                                <el-switch 
                                  :active-value="getSwitchColor({ele: ruleListChild[itemInner], type: 'active',isGet: true})"
                                  :inactive-value="getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive',isGet: true})"
                                  :active-color="getSwitchColor({ele: ruleListChild[itemInner], type: 'active'})"
                                  :inactive-color="getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive'})"
                                  :inactive-text="ruleListChild[itemInner].switchStyle === 1 ? '' : getSwitchColor({ele: ruleListChild[itemInner], type: 'inactive', isGet: true})"
                                  :active-text="ruleListChild[itemInner].switchStyle === 1 ? '' : getSwitchColor({ele: ruleListChild[itemInner], type: 'active', isGet: true})"
                                  v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                  @change="approvalProcess(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], formdata)"
                                />
                              </div>
                            </div>
                          </div>
                          <div v-else :class="ruleListChild[itemInner].isCut ? 'r-c-select' : ''">
                            <el-select v-if="ruleListChild[itemInner].isCut" v-model="cutObj[ruleListChild[itemInner].title]" size="large" style="margin-right:12px;">
                              <el-option v-for="(itss, indexItss) in ruleListChild[itemInner].cutList"
                                :key="ruleListChild[itemInner].title + indexItss + 'a'"
                                :value="itss.label"
                                :label="itss.label"></el-option>
                            </el-select>
                            <el-select
                              v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              class="select-details check-inp"
                              size="large"
                              filterable
                              @focus="conditionLink(ruleListChild[itemInner])"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              multiple
                              :placeholder="ruleListChild[itemInner].placeholder"
                              @visible-change="onselschange($event,ruleListChild[itemInner])"
                              style="width: 100%"
                              :disabled="ruleListChild[itemInner].exhibiIs"
                            >
                              <template #prefix>
                                <span style="line-height:normal;display:contents;">
                                  <template v-if="formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length > 0">
                                    <template v-for="sels in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" :key="sels.label">
                                      <span class="demo-tag"
                                        :style="{'background':ruleListChild[itemInner].selsItemColor&&ruleListChild[itemInner].selsItemColor[sels] ? ruleListChild[itemInner].selsItemColor[sels] : ''}"
                                      >
                                        {{sels}}
                                      </span>
                                    </template>
                                  </template>
                                  <!-- 如果没有数据则显示 placeholder -->
                                  <template v-else>
                                    <span style="padding-left: 5px;">{{ruleListChild[itemInner].placeholder}}</span>
                                  </template>                                  
                                </span>
                              </template>
                              <template v-for="sels in objSels(ruleListChild[itemInner].sels, ruleListChild[itemInner])">
                                <el-option v-if="!ruleListChild[itemInner].isHideObj || !ruleListChild[itemInner].isHideObj[sels.value || sels]"
                                  :key="sels.value || sels"
                                  :label="sels"
                                  :value="sels"
                                >
                                  <span
                                    v-if="ruleListChild[itemInner].selsItemColor"
                                    :style="{backgroundColor:ruleListChild[itemInner].selsItemColor[sels],color:ruleListChild[itemInner].selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                                  >{{sels}}</span>
                                </el-option>
                              </template>
                            </el-select>
                          </div>
                        </template>
                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 时间 -->
                  <div v-else-if="ruleListChild[itemInner].type=='date'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) &&  getHide(ruleListChild[itemInner])"
                  >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])">
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <div class="time-block time-blockA">
                            <span class="right-block-text">
                              <template v-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'yyyy-MM'">
                                {{ getTimeYM(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]) }}
                              </template>
                              <template v-else-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'yyyy-MM-dd HH:mm' && ruleListChild[itemInner].timeList && ruleListChild[itemInner].timeList.open">
                                {{getTimeYMD(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])}}  
                              </template>
                              <template v-else-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'HH:mm'">
                                {{ getTimeHHmm(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]) }}
                              </template>
                              <template v-else>
                                {{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]||'&nbsp;'}}
                              </template>
                            </span>
                            <div v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && ruleListChild[itemInner].match === 'yyyy-MM-dd ww'" class="time-week" style="border-color:#f7f7f7;">星期{{timeWeek(timeFilter(ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type))}}</div>
                            <div v-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'yyyy-MM-dd HH:mm' && ruleListChild[itemInner].timeList && ruleListChild[itemInner].timeList.open">{{getTimeLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner].timeList.options)}}</div>
                          </div>
                        </template>
                        <el-form-item :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type" style="margin: 0;" v-else>
                          <div class="time-block time-blockB">
                            <el-date-picker
                              v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              type="date"
                              class="input-details"
                              size="large"
                              placeholder="选择日期"
                              placement="bottom-start"
                              format="YYYY-MM-DD"
                              value-format="YYYY-MM-DD"
                              style="width: 100%;"
                              v-if="ruleListChild[itemInner].match=='yyyy-MM-dd' || ruleListChild[itemInner].match=='yyyy-MM-dd ww'"
                              :default-value="nextMonthFun(ruleListChild[itemInner].limit || new Date())"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              :picker-options="pickerOptionsLimit(ruleListChild[itemInner])"
                              :disabled="ruleListChild[itemInner].exhibiIs"
                            ></el-date-picker>
                            <div v-else-if="ruleListChild[itemInner].match=='yyyy-MM'" class="time-y-m">
                              <el-date-picker
                                v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                type="month"
                                format="YYYY-MM-DD"
                                class="input-details"
                                size="large"
                                value-format="YYYY-MM-DD"
                                style="width: 100%;"
                                placement="bottom-start"
                                :default-value="nextMonthFun(ruleListChild[itemInner].limit || new Date())"
                                @change="approvalProcess(ruleListChild[itemInner])"
                                :picker-options="pickerOptionsLimit(ruleListChild[itemInner])"
                                :disabled="ruleListChild[itemInner].exhibiIs"
                                placeholder="选择月">
                              </el-date-picker>
                              <div class="time-y-m-text">
                                {{ getTimeYM(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]) }}
                              </div>
                            </div>
                            <div v-else-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match == 'yyyy-MM-dd HH:mm' && ruleListChild[itemInner].timeList && ruleListChild[itemInner].timeList.open && ruleListChild[itemInner].timeList.options.length > 0" class="time-y-m time-md-m">
                              <timePicker :config="ruleListChild[itemInner]" :formdata="formdata" @update:formdata="handleFormdataUpdata(ruleListChild[itemInner], $event)" :modifyId="modifyId" @change="approvalProcess(ruleListChild[itemInner])" />
                            <!--
                              <el-date-picker
                                v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                class="input-details"
                                popper-class="time-zjy-widget-one-layer"
                                type="date"
                                placeholder="选择日期时间"
                                style="width: 100%;"
                                :picker-options="pickerOptionsLimit(ruleListChild[itemInner])"
                                :default-value="nextMonthFun(ruleListChild[itemInner].limit || '')"
                                format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm"
                                @change="(val) => {setTimeDefault(val, ruleListChild[itemInner], formdata);approvalProcess(ruleListChild[itemInner]);}"
                                :disabled="ruleListChild[itemInner].exhibiIs"
                              ></el-date-picker>
                              -->
                              <!-- <div class="time-y-m-text">
                                {{ getTimeYMD(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]) }}
                              </div>
                              <div class="time-md">
                                <el-select v-model="timeWidthObj[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" @change="(val) => getItt(formdata, ruleListChild[itemInner], val, 1)" placeholder=" " :disabled="!formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]">
                                  <el-option v-for="(itt, ittInd) in ruleListChild[itemInner].timeList.options" :key="ittInd + item.title" :value="itt.value" :label="itt.label" />
                                </el-select>
                                <div class="time-md-text">{{getTimeLabel(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type], ruleListChild[itemInner].timeList.options, ruleListChild[itemInner].timeList.defaultValue) || '请选择'}}</div>
                              </div> -->
                            </div>
                            <div v-else-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'HH:mm'" class="time-y-m time-md-m time-text-color">
                              <el-time-picker
                                  @change="approvalProcess(ruleListChild[itemInner])"
                                  value-format="HH:mm"
                                  format="HH:mm"
                                  style="width: 100%;"
                                  v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                  :picker-options="{ format: 'HH:mm' }"
                                  :disabled="ruleListChild[itemInner].exhibiIs"
                                  placeholder="任意时间点">
                              </el-time-picker>
                              <div class="time-y-m-text">
                                {{ getTimeHHmm(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]) }}
                              </div>
                            </div>
                            <el-date-picker
                              v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              class="input-details"
                              size="large"
                              type="datetime"
                              placeholder="选择日期时间"
                              placement="bottom-start"
                              style="width: 100%;"
                              :picker-options="pickerOptionsLimit(ruleListChild[itemInner])"
                              :default-value="nextMonthFun(ruleListChild[itemInner].limit || new Date())"
                              format="YYYY-MM-DD HH:mm:ss"
                              value-format="YYYY-MM-DD HH:mm:ss"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              v-else-if="ruleListChild[itemInner].match && ruleListChild[itemInner].match === 'yyyy-MM-dd HH:mm:ss'"
                              :disabled="ruleListChild[itemInner].exhibiIs"
                            ></el-date-picker>
                            <el-date-picker
                              v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              class="input-details"
                              size="large"
                              type="datetime"
                              placeholder="选择日期时间"
                              placement="bottom-start"
                              style="width: 100%;"
                              :picker-options="pickerOptionsLimit(ruleListChild[itemInner])"
                              :default-value="nextMonthFun(ruleListChild[itemInner].limit || new Date())"
                              format="YYYY-MM-DD HH:mm"
                              value-format="YYYY-MM-DD HH:mm"
                              @change="approvalProcess(ruleListChild[itemInner])"
                              v-else
                              :disabled="ruleListChild[itemInner].exhibiIs"
                            ></el-date-picker>
                            <div v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && ruleListChild[itemInner].match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(timeFilter(ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type))}}</div>
                          </div>
                        </el-form-item>
                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 联系人 -->
                  <div v-else-if="ruleListChild[itemInner].type=='relation-user'"
                    class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    :key="ruleListChild[itemInner].id"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])"
                  >
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div class="on-show" v-if="ruleListChild[itemInner].onShow">
                        <div class="on-show-show"
                              v-show="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]"
                              @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])">
                          <i class="iconfont icon-dakaiyanjing" />
                          {{ruleListChild[itemInner].placeholder}}
                        </div>
                        <i class="iconfont icon-guanbiyanjing on-show-close"
                            @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])" />
                      </div>

                      <div :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])">
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                          <p class="right-block-text" style="min-height:30px">
                            <!-- padding:5px 10px; -->
                            <template v-for="relU in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]">
                              <span
                                v-if="relU"
                                class="relationUserStyle"
                                :key="relU.userId"
                                >
                                <relationUserInfo v-if="ruleListChild[itemInner].isMoreInfo" :moreInfo="ruleListChild[itemInner].moreInfoArr" :checkedInfo="ruleListChild[itemInner].checkKey" :info="relU" :isNewInfo="ruleListChild[itemInner].isNewData" />
                                <template v-else>{{ relU.realname }}</template>
                              </span>
                            </template>
                          </p>
                        </template>
                        <!-- 精准搜索 -->
                        <div v-else-if="ruleListChild[itemInner].isEnterChoice">
                          <user-drop-down
                            :data="ruleListChild[itemInner]"
                            :formdata="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                            :itemInfo="ruleListChild"
                            :placeholder="ruleListChild[itemInner].placeholder==''?'输入添加联系人':ruleListChild[itemInner].placeholder"
                            @userCheck="userCheckCallback"
                            @closeFlow="(index)=>{handleCloseFlow(ruleListChild[itemInner],index,1)}"
                          >
                          </user-drop-down>
                        </div>
                        <!-- 默认 -->
                        <template v-else>                          
                          <div @click="foucsInput(ruleListChild[itemInner])" :class="ruleListChild[itemInner].dataShow ? 'relation-user-wrap relation-default aaa' : 'relation-user-wrap aaa'" :ref="'relationUserRef_' + ruleListChild[itemInner].title">
                            <template
                              v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length!=0"
                            >
                              <div
                                class="relation-user"
                                @click="relationUserChoice(ruleListChild[itemInner],1, formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                                style="text-align: left;cursor: pointer;"
                              >
                                <template v-for="(relU,index) in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]">
                                  <el-tag
                                    type="info"
                                    :key="relU.userId"
                                    closable
                                    :disable-transitions="false"
                                    @close="handleCloseFlow(ruleListChild[itemInner],index,1)"
                                    v-if="index==0"
                                  >{{relU.realname}}</el-tag>
                                </template>
                                <span
                                  class="relationUserStyle"
                                  v-if="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length>1"
                                >等{{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length}}人</span>
                                <el-input
                                  style="width: 100px;"
                                  size="large"
                                  :autofocus="false"
                                  ref="input"
                                  v-model="linkedWd[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                  readonly
                                >
                                </el-input>
                              </div>
                            </template>
                            <template v-else>
                              <div
                                class="relation-user"
                                @click="relationUserChoice(ruleListChild[itemInner],1, formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                              >
                                <el-input
                                  style="width: 100px;"
                                  size="large"
                                  :autofocus="false"
                                  :ref="'relationInputRef_' + item.title"
                                  v-model="linkedWd[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                                  readonly
                                >
                                </el-input>
                              </div>
                            </template>
                            <div class="fast-btn">
                              <a href="javascript:;" title="组织查找" @click="relationUserChoice(ruleListChild[itemInner],1, formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type],false,'orgBtn')"><i class="iconfont icon-zuzhijigou"></i></a>
                              <a v-if="ruleListChild[itemInner].singleIsUser !== 0" href="javascript:;" title="批量查找" @click="showBatchSearch(ruleListChild[itemInner])"><i class="iconfont icon-kuaisuchazhao"></i></a>
                            </div>                           
                            <!-- 下拉框 -->
                            <linked-drop-down
                              v-if="ruleListChild[itemInner].dataShow"
                              :ref="'linkedDropDownRef_' + ruleListChild[itemInner].title"
                              :formdata="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                              :itemInfo="ruleListChild[itemInner]"
                              @userCheck="userCheckCallback"
                              @closeFlow="(index)=>{handleCloseFlow(ruleListChild[itemInner],index,1)}"
                            >
                            </linked-drop-down>
                          </div>
                        </template>
                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 附件 -->
                  <div v-else-if="ruleListChild[itemInner].type=='file'" :key="ruleListChild[itemInner].title" class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])">
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      @click="listCli(itemInner, ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                      @mousemove="listCliRemo(itemInner)"
                      :class="ruleListChild[itemInner].title"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <template #label>
                        <div class="file-label">
                          <!-- 备注：2025.7.16群里报附件标题重复的问题，暂不确定注释是否会有其他影响 -->
                          {{getLabelName(ruleListChild[itemInner])}}
                          <strong 
                            v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length > 1 && !LRobject[tipsize]" 
                            class="file-label-down" 
                            @click.stop="fileDown(ruleListChild[itemInner])"
                          >
                            <i class="iconfont icon-xiazai" />
                            打包下载
                          </strong>
                        </div>
                      </template>
                      <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                        <div
                          style="width:calc(50% - 34px);text-align: center;"
                          v-if="ctoArrayChild && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length === 0"
                        >{{ruleListChild[itemInner].placeholder==''?'选择添加附件':ruleListChild[itemInner].placeholder}}</div>
                        <div
                          class="a-list-block"
                          v-else
                          v-for="(list, items) in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                          :key="items"
                        >
                          <div
                            class="a-list ellipsis"
                            @click="file_pvw(list)"
                            :title="list.realname ? list.realname : list.name"
                          >{{list.realname ? list.realname : list.name}}</div>
                          <div
                            style="min-width:100px;text-align:right;display:flex;align-items:center;"
                            :style="{minWidth: ((list.url && (list.url.indexOf('.pdf') > 0 || list.url.indexOf('.PDF') > 0) && ruleListChild[itemInner].signet ? 100: 40) + (ruleListChild[itemInner].fileDocument && ruleListChild[itemInner].fileDocument === 'music' ? 22 : 0) + 'px' )}"
                          >
                            <!---如需提交后的数据需要更新显示，需要配置模板时时，已经提过，孙要求-->
                            <template
                              v-if="list.url && (list.url.indexOf('.pdf') > 0 || list.url.indexOf('.PDF') > 0) && ruleListChild[itemInner].signet"
                            >
                              <span
                                v-if="list.signet&&list.signet.isArchived"
                                @click="getdochashconf({key: items, item: ruleListChild[itemInner] })"
                              >已归档</span>
                              <span v-else-if="list.signet&&list.signet.isRejectSign">已作废</span>
                              <el-dropdown @command="handleSignet" v-else>
                                <span class="el-dropdown-link">
                                  签章
                                  <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <template #dropdown>
                                  <el-dropdown-menu>
                                    <el-dropdown-item :command="{key: items, item: ruleListChild[itemInner], command:'a'}">签章</el-dropdown-item>
                                    <!-- 没有对应接口，先隐藏该选项 -->
                                    <!-- <el-dropdown-item
                                      :command="{key: items, item: ruleListChild[itemInner], command:'b'}"
                                      v-if="list.signet"
                                    >作废</el-dropdown-item> -->
                                  </el-dropdown-menu>
                                </template>
                              </el-dropdown>
                            </template>
                            <a class="a-list-download" @click.stop="handleFileDown(list)">下载</a>
                            <a class="a-list-download" v-if="ruleListChild[itemInner].isFileEdit" @click.stop="handleFileDown(list, true)">编辑</a>
                            <i 
                              v-if="ruleListChild[itemInner].fileDocument && (ruleListChild[itemInner].fileDocument === 'music' || ruleListChild[itemInner].fileDocument === 'video')" 
                              @click.stop="playFun(list, ruleListChild[itemInner].fileDocument)"
                            :style="{color: themeConfig.headColor}" class="iconfont icon-bofang play" />
                          </div>
                        </div>
                        <strong v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length > 1 && LRobject[tipsize]" class="file-label-down" @click.stop="fileDown(ruleListChild[itemInner])">
                          <i class="iconfont icon-xiazai" />
                          打包下载
                        </strong>
                        <div
                          style="text-align:center;display:none;"
                          v-if="ruleListChild[itemInner].signet&&formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length>0"
                        >
                          <el-dropdown @command="handleListSignet">
                            <el-button size="small" type="primary" style="width:170px">
                              批量操作
                              <i class="el-icon-caret-bottom el-icon--right"></i>
                            </el-button>
                            <template #dropdown>
                              <el-dropdown-menu>
                                <el-dropdown-item
                                  :command="{item: ruleListChild[itemInner], command:'a'}"
                                  v-if="ruleListChild[itemInner].signet && ruleListChild[itemInner].signetWay"
                                >签章</el-dropdown-item>
                                <el-dropdown-item :command="{item: ruleListChild[itemInner], command:'b'}">文档签署完毕，归档</el-dropdown-item>
                              </el-dropdown-menu>
                            </template>
                          </el-dropdown>
                        </div>
                      </template>
                      <template v-else>
                        <el-upload
                        :action="$url+'/userfile/upload?accesstoken='+token"
                        :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                        ref="upload"
                        :disabled="!upDataFile"
                        :file-list="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                        class="img-file-class no-details"
                        :on-progress="handleProgress"
                        list-type="text"
                        :limit="Number(ruleListChild[itemInner].upNumber)"
                        :on-preview="handlePreview"
                        :on-success="handleSuccess"
                        :on-error="handleError"
                        :on-remove="handleRemove"
                        :before-upload="(val) => beforeFileUpload(val, ruleListChild[itemInner])"
                        :before-remove="beforeRemove"
                        :multiple="true"
                      >
                        <div
                          class="el-upload__text"
                          style="line-height: 20px;padding-top: 8px;padding-bottom: 8px;width:100%;"
                        >
                          <el-icon><Link /></el-icon>
                          {{ruleListChild[itemInner].placeholder==''?'选择添加附件':ruleListChild[itemInner].placeholder}}
                        </div>
                      </el-upload>
                    
                      </template>
                      <span
                        class="icon-text"
                        @click="onUp(ruleListChild[itemInner])"
                        v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                      >
                        <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                        查看记录
                      </span>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 图片 -->
                  <div v-else-if="ruleListChild[itemInner].type=='image'" :key="ruleListChild[itemInner].title" class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])">
                    <el-form-item
                      :label="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :title="getLabelName(ruleListChild[itemInner])"
                      :class="ruleListChild[itemInner].title"
                      class="no-details-img"
                      @click="listCli(itemInner)"
                      @mousemove="listCliRemo(itemInner)"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2 || getUpcontroll(ruleListChild[itemInner])">
                        <p
                          style="width:80px;height:80px;border:1px dashed #8c939d;font-size:30px;background:#f7f7f7;line-height:80px;"
                          v-if="ctoArrayChild && formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length === 0 || ctoArrayChild && !formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                        >
                          <i class="el-icon-plus icon-img-file-class"></i>
                        </p>
                        <div style="padding-left:5px;padding-top:5px;" v-else>
                          <div
                            v-for="list in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                            class="a-list-img"
                            :key="list.url"
                          >
                            <el-image
                              :src="list.url"
                              :preview-src-list="(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]).map(val=>{return val.url})"
                            ></el-image>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div v-if="ruleListChild[itemInner].signature === true" class="signa-box">
                          <a class="signabtn" title="点击签名" @click="showSigna(ruleListChild[itemInner])">点击签名</a>
                          <div class="signaPic" v-for="(list1, list1I) in formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]" :key="list1I">
                            <el-image
                              fit="cover"
                              :src="list1.url || ($url + list1.response + '?accesstoken=' + token)" ></el-image>
                            <a class="btn-delete" title="删除签名" @click="deleteSign(list1,ruleListChild[itemInner])"></a>
                          </div>
                        </div>
                        <el-upload
                          :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                          class="file-img-up"
                          v-else-if="ruleListChild[itemInner].imgSet && ruleListChild[itemInner].imgSet.isopen === true"
                          :ref="'uploadImgSet_' + ruleListChild[itemInner].title"
                          :disabled="!upDataFileImgSet"
                          :file-list="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                          list-type="picture-card"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :multiple="true"
                          :auto-upload="false"
                          :show-file-list="true"
                          :limit="Number(ruleListChild[itemInner].upNumber)"
                          :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, ruleListChild[itemInner])}"
                          :on-change="(file, fileList)=>{return selectChange(file, fileList, ruleListChild[itemInner])}"
                        >
                          <div
                            style="color:#57A8FB;line-height: 20px;padding-top: 20px;box-sizing: border-box;"
                          >
                            <el-icon color="#57A8FB"><CirclePlus /></el-icon>
                            <span style="display:block;font-size: 12px;">添加图片</span>
                          </div>
                        </el-upload>
                        <el-upload
                          :action="$url+'/userfile/upload?accesstoken='+token"
                          :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])"
                          class="file-img-up"
                          v-else
                          ref="upload"
                          :disabled="!upDataFile"
                          :file-list="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                          :on-progress="handleProgress"
                          list-type="picture-card"
                          :on-preview="handlePreview"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :on-remove="handleRemove"
                          :limit="Number(ruleListChild[itemInner].upNumber)"
                          :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, ruleListChild[itemInner])}"
                          :before-upload="(file)=>{return beforeImgUpload(file, ruleListChild[itemInner])}"
                          :multiple="true"
                        >
                          <div
                            style="width: 84px;height:84px;color:#57A8FB;line-height: 20px;padding-top: 20px;box-sizing: border-box;"
                          >
                            <el-icon color="#57A8FB"><CirclePlus /></el-icon>
                            <span style="display:block;font-size: 12px;">添加图片</span>
                          </div>
                        </el-upload>
                      </template>

                      <span
                        class="icon-text"
                        @click="onUp(ruleListChild[itemInner])"
                        v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                      >
                        <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                        查看记录
                      </span>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                  <!-- 多行输入框 -->
                  <div v-else-if="ruleListChild[itemInner].type=='textarea'" :key="ruleListChild[itemInner].title" class="container-tt"
                    :style="getConterStyle(item.styleRatio, ruleListChild[itemInner].title)"
                    v-show="onAssVisiblel(ruleListChild[itemInner],itemInner) && getHide(ruleListChild[itemInner])">
                    <el-form-item
                      :title="getLabelName(ruleListChild[itemInner])"
                      :prop="ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type"
                      :rules="[{ required: ruleListChild[itemInner].required=='required'?true:false,trigger: 'false'}]"
                    >
                    <template #label>
                      <span :style="getLabelStyle(ruleListChild[itemInner])">{{ getLabelName(ruleListChild[itemInner]) }}</span>
                    </template>
                      <div v-if="ruleListChild[itemInner].annotationTop" class="annotation-top">{{ruleListChild[itemInner].annotationTop}}</div>
                      <div class="on-show" v-if="ruleListChild[itemInner].onShow" :style="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type] ? 'height:40px;' : ''">
                        <div class="on-show-show"
                            v-show="!onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]"
                            @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])">
                          <i class="iconfont icon-dakaiyanjing" />
                          {{ruleListChild[itemInner].placeholder}}
                        </div>
                        <i class="iconfont icon-guanbiyanjing on-show-close"
                          @click="setOnShow(ruleListChild[itemInner], onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type])" />
                      </div>
                      <div v-if="!ruleListChild[itemInner].onShow || onShowObj[ruleListChild[itemInner].title+'_'+ruleListChild[itemInner].type]" :class="classFun(ruleListChild[itemInner], formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type])">
                        <template v-if="ruleListChild[itemInner].per && Number(ruleListChild[itemInner].per) === 2">
                          <span
                            class="right-block-text"
                            style="white-space: pre-wrap;line-height: 24px;padding-top:8px;padding-bottom:8px;"
                            :style="{background: isNews ? '#FFFFFF' : '#f7f7f7'}"
                          >{{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]||'&nbsp;'}}</span>
                        </template>

                        <template v-else>
                          <div v-if="ruleListChild[itemInner].queryOnly && ruleListChild[itemInner].dataconfig && ruleListChild[itemInner].dataconfig.setUpValue && ruleListChild[itemInner].dataconfig.setUpValue === 3" class="on-show" style="min-height:36px;">
                            <div class="on-show-show on-show-left"
                                tabindex="-1"
                                @blur="inputBlur(ruleListChild[itemInner])"
                                @focus="upTextarea(ruleListChild[itemInner], $event)">
                              <i class="iconfont icon-shujuchaxun" />
                              {{ruleListChild[itemInner].placeholder}}
                            </div>
                          </div>
                          <el-input
                            v-else
                            type="textarea"
                            :maxlength="ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit !== 'Infinity' > 0 ? ruleListChild[itemInner].sizeLimit : undefined"
                            class="input-details"
                            :autosize="{ minRows: 4}"
                            v-model="formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]"
                            @change="approvalProcess(ruleListChild[itemInner])"
                            @focus="upTextarea(ruleListChild[itemInner], $event); setAi(ruleListChild[itemInner]);"
                            @blur="inputBlur(ruleListChild[itemInner]); setAi(null);"
                            @keyup="upTextarea(ruleListChild[itemInner], $event)"
                            :placeholder="ruleListChild[itemInner].placeholder"
                            :disabled="ruleListChild[itemInner].exhibiIs"
                          ></el-input>
                          <div
                            :class="'textarea-rel ' + ruleListChild[itemInner].title"
                            v-if="ruleListChild[itemInner].sels && JSON.parse(ruleListChild[itemInner].sels).length > 0 && textareaRelShow"
                          >
                            <el-scrollbar style="height: 150px;">
                              <div
                                class="textarea-list"
                                @click="ruleListChild[itemInner].queryOnly && ruleListChild[itemInner].dataconfig && ruleListChild[itemInner].dataconfig.setUpValue && ruleListChild[itemInner].dataconfig.setUpValue === 3 ? '' : bulorList(ruleListChild[itemInner], textList, formdata)"
                                v-show="new RegExp(escapeRegex(formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]?formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type]:'')).test(textList)"
                                v-for="(textList, textIndex) in JSON.parse(ruleListChild[itemInner].sels)"
                                :key="textIndex"
                              >{{textList}}</div>
                            </el-scrollbar>
                          </div>
                          <span
                            class="textarea-right"
                            v-if="ruleListChild[itemInner].sizeLimit && ruleListChild[itemInner].sizeLimit !== 'Infinity'"
                          >{{formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type] ? formdata[ruleListChild[itemInner].title + '_' + ruleListChild[itemInner].type].length : 0}}/{{ruleListChild[itemInner].sizeLimit}}</span>
                        </template>
                        <span
                          class="icon-text"
                          @click="onUp(ruleListChild[itemInner])"
                          v-if="ruleListChild[itemInner].record && ruleListChild[itemInner].record.length > 0"
                        >
                          <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                          查看记录
                        </span>
                      </div>
                      <div v-if="ruleListChild[itemInner].annotationBottom" class="annotation-bottom">{{ruleListChild[itemInner].annotationBottom}}</div>
                    </el-form-item>
                  </div>
                </template>
              </div>
            </div>
          <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
        </el-col>
        <!-- 标签 -->
        <el-col
          :span="24"
          v-if="item.type=='label'"
          :key="item.id"
          :style="getLabelBack(item, index)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <p v-if="item.status && JSON.stringify(item.status) === 'true'"
            class="label-line">
            <span v-if="item.annotationTop" style="display:block;position:relative;z-index:1;">{{item.annotationTop}}</span>
            <span :style="{'border-bottom-style': item.lineStyle, width:'100%', display: 'block'}"
                  class="label-line-1">
              <span class="label-line-1-t"></span>
              <span class="label-line-1-r"></span>
              <span class="label-line-1-b"></span>
              <span class="label-line-1-l"></span>
            </span>
            <span v-if="item.annotationBottom" style="position:relative;z-index:1;">{{item.annotationBottom}}</span>
          </p>
          <template v-else-if="item.status && item.status === 'richTextWid'">
            <span v-if="item.annotationTop" style="display:block;">{{item.annotationTop}}</span>
            <div class="label-richTextWid" :style="setBackground(item)">
              <rich-text-editor
                :catchData="{per:2}"
                :disabled="item.per === 2"
                :content="item.richTextWid"
              ></rich-text-editor>
            </div>
            <span v-if="item.annotationBottom" style="display:block;">{{item.annotationBottom}}</span>
          </template>
          <template v-else-if="item.status && item.status === 'file'">
            <span v-if="item.annotationTop" style="display:block;">{{item.annotationTop}}</span>
            <div class="label-file">
              <div :class="['form-labet-class-text', item.labelConfig && item.labelConfig.isNameShow ? 'no-label' : '']">{{item.name}}</div>
              <div class="label-file-right">
                <div v-for="(list, listInd) in getFileList(item.fileList)" :key="listInd + 'lab'" class="label-file-label">
                    <div class="file-list-title" @click="file_pvw(list)">
                        <i class="iconfont icon-exe-post-primary" />
                        {{ list.name }}
                    </div>
                    <div class="icon-b-shezhi" @click.stop="handleFileDown(list)">下载</div>
                </div>
            </div>
            </div>
            <span v-if="item.annotationBottom" style="display:block;">{{item.annotationBottom}}</span>
          </template>
          <p class="form-labet-class" v-else>
            <span v-if="item.annotationTop" style="display:block;">{{item.annotationTop}}</span>
            <span :class="['form-labet-class-text', item.labelConfig && item.labelConfig.isNameShow ? 'no-label' : '']">{{item.name}}</span>
            <span v-if="item.annotationBottom" style="display:block;">{{item.annotationBottom}}</span>
          </p>
        </el-col>
        <!-- 文本 -->
        <el-col
          :span="getCol(item)"
          v-if="item.type=='text' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
          >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>
            <div :class="[
              classFun(item, formdata[item.title + '_' + item.type],formdata),
              'input-details',
              item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? 'on-show-pointer' : ''
            ]">
              <template v-if="item.per && item.per === 2 || getUpcontroll(item)">
                <span v-if="item.format && item.format.value !== 'routine' && formdata[item.title + '_' + item.type] && !isNaN(sliceEncrypt(formdata[item.title + '_' + item.type],item.encrypt))" class="right-block-text" :style="[{paddingTop: '8px',paddingBottom: '8px', lineHeight: '24px'}, item.format && item.format.markedRed &&
                    (item.format.value === 'number'||item.format.value === 'currency') &&
                    formdata[item.title + '_' + item.type] < 0 ? {color: 'red'} : '']" :class="item.isLink ? 'text-link' : ''" @click="openLinkText(formdata[item.title + '_' + item.type], item)">
                  <template v-if="(item.format.value==='currency'||item.format.value==='accounting') && item.format.currency !== '万元'">
                    {{item.format.currency}}
                  </template>
                  {{sliceEncrypt(numberFormat(formdata[item.title + '_' + item.type], item ),item.encrypt)||'&nbsp;'}}
                  <!-- 百分比符号、自定义符号 -->
                  <template v-if="item.format && item.format.value==='percentage'">%</template>
                  <template v-else-if="item.format && item.format.value==='number'">{{item.format.customSymbols}}</template>
                  <template v-else-if="isWYFN(item)">{{item.format.currency}}</template>
                </span>
                <span v-else class="right-block-text" style="padding-top: 8px;padding-bottom:8px;line-height:24px;" :class="item.isLink ? 'text-link' : ''" @click="openLinkText(formdata[item.title + '_' + item.type], item)">
                  {{sliceEncrypt(formdata[item.title + '_' + item.type],item.encrypt)||'&nbsp;'}}
                </span>
              </template>
              <template v-else>
                <!-- 文本输入 -->
                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="pointer-events:none;">
                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                    <i class="iconfont icon-shujuchaxun" />
                    {{item.placeholder}}
                  </div>
                </div>
                <el-autocomplete
                  style="width: 100%;"
                  :ref="item.title"
                  popper-class="select-text"
                  size="large"
                  :maxlength="item.sizeLimit && item.sizeLimit && item.sizeLimit !== 'Infinity' > 0 ? Number(item.sizeLimit) : undefined"
                  v-model="formdata[item.title + '_' + item.type]"
                  :fetch-suggestions="querySearchAsync"
                  :placeholder="item.placeholder"
                  @focus="autocompleteFun(item, formdata[item.title + '_' + item.type]); conditionLink(item); setAi(item)"
                  @change="approvalProcess(item, '', formdata)"
                  @blur="conditionLinkObj = null; setAi(null)"
                  @input="autoinputFun($event, item)"
                  @select="approvalProcess(item, '', formdata)"
                  :disabled="item.exhibiIs"
                  :readonly="item.type === 'text' && Number(item.disSearch) === 1"
                ></el-autocomplete>
                <!-- 错误提示 -->
                <span
                  class="textarea-right"
                  v-if="item.sizeLimit && item.sizeLimit !== 'Infinity'"
                >{{formdata[item.title + '_' + item.type] ? formdata[item.title + '_' + item.type].length : 0}}/{{item.sizeLimit}}</span>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 多行输入框 -->
        <el-col
          :span="24"
          v-else-if="item.type=='textarea' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            :prop="item.title+'_'+item.type"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow" :style="!onShowObj[item.title+'_'+item.type] ? 'height:40px;' : ''">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>
            <div v-if="!item.onShow || onShowObj[item.title+'_'+item.type]" :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <span
                  class="right-block-text"
                  style="white-space: pre-wrap;line-height: 24px;padding-top:8px;padding-bottom:8px;"
                  :style="{background: isNews ? '#FFFFFF' : '#f7f7f7'}"
                >{{formdata[item.title + '_' + item.type]||'&nbsp;'}}</span>
              </template>

              <template v-else>
                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3" class="on-show" style="min-height:36px;">
                  <div class="on-show-show on-show-left"
                       tabindex="-1"
                       @blur="inputBlur(item)"
                       @focus="upTextarea(item, $event)">
                    <i class="iconfont icon-shujuchaxun" />
                    {{item.placeholder}}
                  </div>
                </div>
                <el-input
                  v-else
                  type="textarea"
                  :maxlength="item.sizeLimit && item.sizeLimit && item.sizeLimit !== 'Infinity' > 0 ? item.sizeLimit : undefined"
                  class="input-details"
                  :autosize="{ minRows: 4}"
                  v-model="formdata[item.title + '_' + item.type]"
                  @change="approvalProcess(item)"
                  @focus="upTextarea(item, $event); setAi(item);"
                  @blur="inputBlur(item); setAi(null);"
                  @keyup="upTextarea(item, $event)"
                  :placeholder="item.placeholder"
                  :disabled="item.exhibiIs"
                ></el-input>
                <div
                  :class="'textarea-rel ' + item.title"
                  v-if="item.sels && JSON.parse(item.sels).length > 0 && textareaRelShow"
                >
                  <el-scrollbar style="height: 150px;">
                    <div
                      class="textarea-list"
                      @click="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3 ? '' : bulorList(item, textList, formdata)"
                      v-show="new RegExp(escapeRegex(formdata[item.title + '_' + item.type]?formdata[item.title + '_' + item.type]:'')).test(textList)"
                      v-for="(textList, textIndex) in JSON.parse(item.sels)"
                      :key="textIndex"
                    >{{textList}}</div>
                  </el-scrollbar>
                </div>
                <span
                  class="textarea-right"
                  v-if="item.sizeLimit && item.sizeLimit !== 'Infinity'"
                >{{formdata[item.title + '_' + item.type] ? formdata[item.title + '_' + item.type].length : 0}}/{{item.sizeLimit}}</span>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 数值 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='number' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <span class="right-block-text right-block-number"
                  v-if="item.format && item.format.value !== 'routine'"
                  :style="{
                    color:item.format && item.format.markedRed &&
                    (item.format.value === 'number'||item.format.value === 'currency') &&
                    formdata[item.title + '_' + item.type] < 0 ? 'red': '',
                    justifyContent: item.format && item.format.value==='accounting'?'space-between':''
                  }">
                  <span>
                    <!-- 货币符号 -->
                    <template v-if="(item.format.value==='currency'||item.format.value==='accounting') && item.format.currency !== '万元'">
                      {{item.format.currency}}
                    </template>
                  </span>
                  <span>
                    {{numberFormat(formdata[item.title + '_' + item.type], item )}}
                    <!-- 百分比符号、自定义符号 -->
                    <template v-if="item.format.value==='percentage'">%</template>
                    <template v-else-if="item.format.value==='number'">{{item.format.customSymbols}}</template>
                    <template v-else-if="isWYFN(item)">{{item.format.currency}}</template>
                  </span>
                </span>
                <span v-else class="right-block-text right-block-number">{{formdata[item.title + '_' + item.type]}}</span>
              </template>
              <div v-show="!(item.per && Number(item.per) === 2) && !getUpcontroll(item)">
                <template v-if="isWYFN(item, true)">
                  <el-input-number
                    v-model="tempFormdata[item.title + '_' + item.type]"
                    class="input-details"
                    size="large"
                    :step="item.step"
                    label="描述文字"
                    style="width:90%"
                    controls-position="right"
                    :disabled="item.exhibiIs"
                    :placeholder="item.placeholder||'请输入'"
                    @keyup="(e) => { numDecimal(e, item.format.value!=='routine' ? item.format.decimal + 4 : null); handleNumKeyup(e, item); }"
                    @change="approvalProcess(item);setOriginalData(item)"
                  ></el-input-number>
                  <span>万元</span>
                </template>
                <el-input-number
                  v-else
                  v-model="formdata[item.title + '_' + item.type]"
                  class="input-details"
                  size="large"
                  :step="item.step"
                  label="描述文字"
                  style="width:100%"
                  controls-position="right"
                  :placeholder="item.placeholder||'请输入'"
                  @keyup="(e) => { numDecimal(e, item.format.value!=='routine' ? item.format.decimal : null); handleNumKeyup(e, item); }"
                  @change="approvalProcess(item);"
                  :disabled="item.exhibiIs"
                ></el-input-number>
              </div>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 单选 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='radio' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close on-select"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>

            <div>
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <p class="right-block-text radio-list-view">
                  <span
                    v-if="formdata[item.title + '_' + item.type]"
                    :class="['list-block', item.types && item.types === 2 ? 'radio-list-imgs' : '', item.types && item.types === 3 ? 'radio-list-button' : '', item.types && item.types === 6 ? 'no-back' : '']"
                    :style="[{marginBottom: 0}, item.selsItemColor && item.selsItemColor[formdata[item.title + '_' + item.type]] ? { backgroundColor: item.selsItemColor[formdata[item.title + '_' + item.type]], color: '#fff' } : {padding: 0}]"
                  >
                    <template v-if="item.types && item.types === 2">
                      <el-image v-if="item.selsItemImg && item.selsItemImg[formdata[item.title + '_' + item.type]]"
                                class="radio-list-img"
                                :src="$imgurl + item.selsItemImg[formdata[item.title + '_' + item.type]] + '?accesstoken=' + token"></el-image>
                      <span v-else class="radio-list-img">
                        <el-icon class="no-icon"><Picture /></el-icon>
                      </span>
                      <span class="radio-list-text ellipsis" :style="getButtonStyle(formdata[item.title + '_' + item.type], item)">
                        {{getRadioLabel(formdata[item.title + '_' + item.type], objSels(item.sels, item))}}
                      </span>
                    </template>
                    <template v-else-if="item.types && item.types === 5">{{getRadioProvinces(formdata[item.title + '_' + item.type], item)}}</template>
                    <radioXing v-else-if="item.types && item.types === 6" :sels="objSels(item.sels, item)" :model-value:value="formdata[item.title + '_' + item.type]" :edit="false" />
                    <template v-else>
                      {{formdata[item.title + '_' + item.type] === 'others其他' && item.others ? '其他' : getRadioLabel(formdata[item.title + '_' + item.type], objSels(item.sels, item))}}
                    </template>
                  </span>&nbsp;
                </p>
                <span
                  class="right-block-text"
                  style="margin-top: 22px;"
                  v-if="formdata[item.title + '_' + item.type] === 'others其他' && item.others"
                >{{item.othersVal}}</span>
              </template>
              <!--radio跟select互换了格式-->
              <template v-else>
                <div v-if="item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1" class="on-show" style="pointer-events:none;">
                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                    <i class="iconfont icon-shujuchaxun" />
                    {{item.placeholder}}
                  </div>
                </div>
                <div v-if="item.types && Number (item.types) !== 0" :class="item.isCut ? 'r-c-block' : ''">
                  <div v-if="item.isCut" class="r-c-header">
                    <div :class="['r-c-list', cutObj[item.title] === its.label ? 'r-c-list-active' : '']"
                          v-for="(its, itsI) in item.cutList"
                          @click="$set(cutObj, item.title, its.label)"
                          :key="item.title + itsI">
                      {{ its.label }}
                    </div>
                  </div>
                  <div :class="item.isCut ? 'r-c-content' : ''">
                    <el-radio-group v-model="formdata[item.title + '_' + item.type]"
                                    @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)"
                                    v-if="Number(item.types) === 1">
                      <template v-for="sels in objSels(item.sels, item)">
                        <el-radio v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                          <span
                            class="radiovalue"
                            v-if="item.selsItemColor"
                            :style="{backgroundColor:item.selsItemColor[sels.value || sels],color:item.selsItemColor[sels.value || sels]?'#fff':''}"
                          >{{sels.label || sels}}</span>
                          <template v-else>
                            {{ sels.label || sels }}
                          </template>
                        </el-radio>
                      </template>
                      <el-radio label="others其他" v-if="item.others">其他</el-radio>
                    </el-radio-group>
                    <div v-else-if="Number(item.types) === 2" class="radio-list">
                      <template v-for="(its, indexIts) in objSels(item.sels, item)">
                        <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            class="radio-list-imgs"
                            :style="getButtonBlock(its.value || its, item)"
                            @click="setRadio({val: its.value || its, item: item})">
                          <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                    class="radio-list-img"
                                    :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                          <div v-else class="radio-list-img">
                            <el-icon class="no-icon"><Picture /></el-icon>
                          </div>
                          <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item)">{{its.label || its}}</div>
                        </div>
                      </template>
                    </div>
                    <div v-else-if="Number(item.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                      <template v-for="(its, indexIts) in objSels(item.sels, item)">
                        <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                          :key="indexIts + (its.value || its)"
                          @click="setRadio({val: its.value || its, item: item})"
                          :style="getRadioStyle(its.value || its, item)"
                          class="radio-list-button">{{its.label || its}}</div>
                      </template>
                    </div>
                    <div class="radio-switch" v-else-if="Number(item.types) === 4">
                      <template v-if="item.switchStyle && item.switchStyle === 3">
                        <el-checkbox size="large" v-model="formdata[item.title + '_' + item.type]"
                                    :true-label="getSwitchColor({ele: item, type: 'active',isGet: true})"
                                    :false-label="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                                    @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)" />
                      </template>
                      <el-switch v-else 
                        :active-value="getSwitchColor({ele: item, type: 'active',isGet: true})"
                        :inactive-value="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                        :active-color="getSwitchColor({ele: item, type: 'active'})"
                        :inactive-color="getSwitchColor({ele: item, type: 'inactive'})"
                        :inactive-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'inactive', isGet: true})"
                        :active-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'active', isGet: true})"
                        v-model="formdata[item.title + '_' + item.type]"
                        @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)"
                      />
                    </div>
                    <multilevel v-else-if="Number(item.types) === 5" :config="item.multilevelConfig" :formdata="formdata[item.title + '_' + item.type]" @update:formdata="handleFormdataUpdata(item, $event)" @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)" :placeholder="item.placeholder" />
                    <radioXing v-else-if="Number(item.types) === 6" :sels="objSels(item.sels, item)" :value="formdata[item.title + '_' + item.type]" :edit="true" @upXing="val => upXing(val, item)" />
                  </div>
                </div>
                <div v-else :class="item.isCut ? 'r-c-select' : ''">
                  <el-select v-if="item.isCut" v-model="cutObj[item.title]" size="large" style="margin-right:12px;">
                    <template v-for="(itss, indexItss) in item.cutList">
                      <el-option v-if="!item.isHideObj || !item.isHideObj[itss.value || itss]"
                      :key="item.title + indexItss + 'a'"
                      :value="itss.label"
                      :label="itss.label"></el-option>
                    </template>
                  </el-select>
                  <el-select
                      v-model="formdata[item.title + '_' + item.type]"
                      size="large"
                      :placeholder="item.placeholder"
                      class="input-details select-details check-inp"
                      style="width: 100%"
                      filterable
                      clearable
                      @focus="conditionLink(item)"
                      :class="classFun(item, formdata[item.title + '_' + item.type])"
                      @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)"
                      @visible-change="onselschange($event,item)"
                      :disabled="item.exhibiIs"
                    >
                      <template #prefix>
                        <div style="height:31px;line-height:31px;margin-top:3px" v-if="!radioBlur[item.title + '_' + item.type]">
                          <span v-if="formdata[item.title + '_' + item.type]!=='others其他' && getRadioLabel(formdata[item.title + '_' + item.type], objSels(item.sels, item))" 
                                class="ridiotagstyle ellipsis" 
                                :style="{backgroundColor:item.selsItemColor&&item.selsItemColor[formdata[item.title + '_' + item.type]],color:item.selsItemColor&&item.selsItemColor[formdata[item.title + '_' + item.type]]?'#fff':'#333'}">
                                {{getRadioLabel(formdata[item.title + '_' + item.type], objSels(item.sels, item))}}
                          </span>
                          <span v-else style="padding-left: 5px;">{{item.placeholder}}</span>
                        </div>
                      </template>
                      <template v-for="(sels, selsIndex) in objSels(item.sels, item)">
                        <el-option v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                          :key="selsIndex"
                          :label="sels.label || sels"
                          :value="sels.value || sels"
                        >
                          <span
                            v-if="item.selsItemColor"
                            :style="{backgroundColor:item.selsItemColor[sels.value || sels],color:item.selsItemColor[sels.value || sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                          >{{sels.label || sels}}</span>
                        </el-option>
                      </template>
                      
                      <el-option key="others" label="其他" value="others其他" v-if="item.others">
                        <span :style="{backgroundColor:'#fff',padding:'4px 8px',borderRadius:'10px'}">
                          其他
                        </span>
                      </el-option>
                  </el-select>
                  <!-- 其他 -->
                  <template
                    v-if="item.others && formdata[item.title + '_' + item.type] === 'others其他'"
                  >
                    <input
                      type="text"
                      placeholder="请输入内容"
                      :class="classFun(item, formdata[item.title + '_' + item.type], item.othersVal)"
                      class="other-class"
                      v-model="item.othersVal"
                      @blur="approvalProcess(item,'others其他')"
                    />
                  </template>
                </div>
              </template>

              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 多选 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='checkbox' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close on-select"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>

            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <span class="right-block-text">
                  <!-- color:item.selsItemColor&&item.selsItemColor[list] ? '#fff' : '#333' -->
                  <span
                    :style="{backgroundColor:item.selsItemColor? item.selsItemColor[list] : '#4e86ff',color:'#fff'}"
                    class="list-block"
                    v-for="list in formdata[item.title + '_' + item.type]||[]"
                    :key="list"
                  >{{list}}</span>&nbsp;
                </span>
              </template>
              <template v-else>
                <div v-if="item.types && Number (item.types) !== 0" :class="item.isCut ? 'r-c-block' : ''">
                  <div v-if="item.isCut" class="r-c-header">
                    <div :class="['r-c-list', cutObj[item.title] === its.label ? 'r-c-list-active' : '']"
                          v-for="(its, itsI) in item.cutList"
                          @click="$set(cutObj, item.title, its.label)"
                          :key="item.title + itsI">
                      {{ its.label }}
                    </div>
                  </div>
                  <div :class="item.isCut ? 'r-c-content' : ''">
                    <el-checkbox-group v-model="formdata[item.title + '_' + item.type]"
                     @change="approvalProcess(item)"
                     size="large"
                     v-if="item.types && item.types === 1">
                     <template v-for="sels in objSels(item.sels, item)">
                        <el-checkbox v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value || sels">
                          <span class="checkboxvalue"
                            :style="item.selsItemColor && item.selsItemColor[sels.value || sels] ? {backgroundColor:item.selsItemColor[sels.value || sels],color:'#fff'} : {}"
                          >{{ sels.label || sels }}</span>
                        </el-checkbox>
                     </template>
                      
                    </el-checkbox-group>
                    <div v-else-if="Number(item.types) === 2" class="radio-list">
                      <template v-for="(its, indexIts) in objSels(item.sels, item)">
                        <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            class="radio-list-imgs"
                            :style="getButtonBlock(its.value || its, item, true)"
                            @click="setCheck({val: its.value || its, item: item})">
                          <el-image v-if="item.selsItemImg && item.selsItemImg[its.value || its]"
                                    class="radio-list-img"
                                    :src="$imgurl + item.selsItemImg[its.value || its] + '?accesstoken=' + token"></el-image>
                          <div v-else class="radio-list-img">
                            <el-icon class="no-icon"><Picture /></el-icon>
                          </div>
                          <div class="radio-list-text ellipsis" :style="getButtonStyle(its.value || its, item, true)">{{its.label || its}}</div>
                        </div>
                      </template>
                    </div>
                    <div v-else-if="Number(item.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                      <template v-for="(its, indexIts) in objSels(item.sels, item)">
                        <div v-if="!item.isHideObj || !item.isHideObj[its.value || its]"
                          :key="indexIts + (its.value || its)"
                          @click="setCheck({val: its.value || its, item: item})"
                          :style="getRadioStyle(its.value || its, item)"
                          class="radio-list-button">
                          {{its.label || its}}
                        </div>
                      </template>
                    </div>
                    <div class="radio-switch" v-else-if="Number(item.types) === 4">
                      <el-switch 
                        :active-value="getSwitchColor({ele: item, type: 'active',isGet: true})"
                        :inactive-value="getSwitchColor({ele: item, type: 'inactive',isGet: true})"
                        :active-color="getSwitchColor({ele: item, type: 'active'})"
                        :inactive-color="getSwitchColor({ele: item, type: 'inactive'})"
                        :inactive-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'inactive', isGet: true})"
                        :active-text="item.switchStyle === 1 ? '' : getSwitchColor({ele: item, type: 'active', isGet: true})"
                        v-model="formdata[item.title + '_' + item.type]"
                        @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)"
                      />
                    </div>
                  </div>
                </div>
                <div v-else :class="item.isCut ? 'r-c-select' : ''">
                  <el-select v-if="item.isCut" v-model="cutObj[item.title]" size="large" style="margin-right:12px;">
                    <el-option v-for="(itss, indexItss) in item.cutList"
                      :key="item.title + indexItss + 'a'"
                      :value="itss.label"
                      :label="itss.label"></el-option>
                  </el-select>
                  <el-select
                    v-model="formdata[item.title + '_' + item.type]"
                    class="select-details check-inp"
                    size="large"
                    filterable
                    @focus="conditionLink(item)"
                    @change="approvalProcess(item)"
                    multiple
                    :placeholder="item.placeholder"
                    @visible-change="onselschange($event,item)"
                    style="width: 100%"
                    :disabled="item.exhibiIs"
                  >
                    <template #prefix>
                      <span style="line-height:normal;display:contents;">
                        <template v-if="formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length > 0">
                          <template v-for="sels in formdata[item.title + '_' + item.type]" :key="sels.label">
                            <span class="demo-tag"
                              :style="{'background':item.selsItemColor&&item.selsItemColor[sels] ? item.selsItemColor[sels] : ''}"
                            >
                              {{sels}}
                            </span>
                          </template>
                        </template>
                        <!-- 如果没有数据则显示 placeholder -->
                        <template v-else>
                          <span style="padding-left: 5px;">{{item.placeholder}}</span>
                        </template>
                      </span>
                    </template>
                    <template v-for="sels in objSels(item.sels, item)">
                      <el-option v-if="!item.isHideObj || !item.isHideObj[sels.value || sels]"
                        :key="sels.value || sels"
                        :label="sels"
                        :value="sels"
                      >
                        <span
                          v-if="item.selsItemColor"
                          :style="{backgroundColor:item.selsItemColor[sels],color:item.selsItemColor[sels]?'#fff':'',padding:'4px 8px',borderRadius:'10px'}"
                        >{{sels}}</span>
                      </el-option>
                    </template>
                  </el-select>
                </div>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 时间 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='date' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) &&  getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <div class="time-block time-blockC">
                  <span class="right-block-text">
                    <template v-if="item.match && item.match === 'yyyy-MM'">
                      {{ getTimeYM(formdata[item.title + '_' + item.type]) }}
                    </template>
                    <template v-else-if="item.match && item.match === 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open">
                      {{getTimeYMD(formdata[item.title + '_' + item.type])}}  
                    </template>
                    <template v-else-if="item.match && item.match === 'HH:mm'">
                      {{ getTimeHHmm(formdata[item.title + '_' + item.type]) }}
                    </template>
                    <template v-else>
                      {{formdata[item.title + '_' + item.type]||'&nbsp;'}}
                    </template>
                  </span>
                  <div v-if="formdata[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'" class="time-week" style="border-color:#f7f7f7;">星期{{timeWeek(timeFilter(item.title + '_' + item.type))}}</div>
                  <div v-if="formdata[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open" class="time-week" style="border-color:#f7f7f7;">{{getTimeLabel(formdata[item.title + '_' + item.type], item.timeList.options)}}</div>
                </div>
              </template>
              <el-form-item :prop="item.title+'_'+item.type" style="margin: 0;" v-else>
                <div class="time-block time-blockD">
                  <el-date-picker
                    v-model="formdata[item.title + '_' + item.type]"
                    type="date"
                    class="input-details"
                    size="large"
                    placeholder="选择日期"
                    placement="bottom-start"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                    style="width: 100%;"
                    v-if="item.match=='yyyy-MM-dd' || item.match=='yyyy-MM-dd ww'"
                    :default-value="nextMonthFun(item.limit || new Date())"
                    @change="approvalProcess(item)"
                    :picker-options="pickerOptionsLimit(item)"
                    :disabled="item.exhibiIs"                    
                  ></el-date-picker>
                  <div v-else-if="item.match == 'yyyy-MM'" class="time-y-m">
                    <el-date-picker
                      v-model="formdata[item.title + '_' + item.type]"
                      type="month"
                      format="YYYY-MM-DD"
                      class="input-details"
                      size="large"
                      value-format="YYYY-MM-DD"
                      placement="bottom-start"
                      style="width: 100%;"
                      :default-value="nextMonthFun(item.limit || new Date())"
                      @change="approvalProcess(item)"
                      :picker-options="pickerOptionsLimit(item)"
                      :disabled="item.exhibiIs"
                      placeholder="选择月">
                    </el-date-picker>
                    <div class="time-y-m-text">
                      {{ getTimeYM(formdata[item.title + '_' + item.type]) }}
                    </div>
                  </div>
                  <timePicker v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" :config="item" :formdata="formdata" @update:formdata="handleFormdataUpdata(item, $event)" :modifyId="modifyId" @change="approvalProcess(item)" />
                 <!--
                  <div v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm' && item.timeList && item.timeList.open && item.timeList.options.length > 0" class="time-y-m time-md-m">
         
                    <el-date-picker
                      popper-class="time-zjy-widget-one-layer"
                      v-model="formdata[item.title + '_' + item.type]"
                      class="input-details"
                      type="date"
                      placeholder="选择日期时间"
                      style="width: 100%;"
                      :picker-options="pickerOptionsLimit(item)"
                      :default-value="nextMonthFun(item.limit || '')"
                      format="yyyy-MM-dd HH:mm"
                      value-format="yyyy-MM-dd HH:mm"
                      @change="(val) => {setTimeDefault(val, item, formdata);approvalProcess(item);}"
                      :disabled="item.exhibiIs"
                    ></el-date-picker>
                  
                    <div class="time-y-m-text">
                      {{ getTimeYMD(formdata[item.title + '_' + item.type]) }}
                    </div>
                    <div class="time-md">
                      <el-select v-model="timeWidthObj[item.title + '_' + item.type]" @change="(val) => getItt(formdata, item, val, 1)" placeholder=" " :disabled="!formdata[item.title + '_' + item.type]">
                        <el-option v-for="(itt, ittInd) in item.timeList.options" :key="ittInd + item.title" :value="itt.value" :label="itt.label" />
                      </el-select>
                      <div class="time-md-text">{{getTimeLabel(formdata[item.title + '_' + item.type], item.timeList.options, item.timeList.defaultValue) || '请选择'}}</div>
                    </div>
                  </div>
                -->
                  <div v-else-if="item.match && item.match === 'HH:mm'" class="time-y-m time-md-m time-text-color">
                    <el-time-picker
                        @change="approvalProcess(item)"
                        value-format="HH:mm"
                        format="HH:mm"
                        style="width: 100%;"
                        v-model="formdata[item.title + '_' + item.type]"
                        :picker-options="{ format: 'HH:mm' }"
                        :disabled="item.exhibiIs"
                        placeholder="任意时间点">
                    </el-time-picker>
                    <div class="time-y-m-text">
                      {{ getTimeHHmm(formdata[item.title + '_' + item.type]) }}
                    </div>
                  </div>
                  <el-date-picker
                    v-else-if="item.match && item.match == 'yyyy-MM-dd HH:mm:ss'"
                    v-model="formdata[item.title + '_' + item.type]"
                    class="input-details"
                    size="large"
                    type="datetime"
                    placeholder="选择日期时间"
                    placement="bottom-start"
                    style="width: 100%;"
                    :picker-options="pickerOptionsLimit(item)"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    @change="approvalProcess(item)"
                    :disabled="item.exhibiIs"
                  ></el-date-picker>
                  <el-date-picker
                    v-else
                    v-model="formdata[item.title + '_' + item.type]"
                    class="input-details"
                    size="large"
                    type="datetime"
                    placeholder="选择日期时间"
                    placement="bottom-start"
                    style="width: 100%;"
                    :picker-options="pickerOptionsLimit(item)"
                    format="YYYY-MM-DD HH:mm"
                    value-format="YYYY-MM-DD HH:mm"
                    @change="approvalProcess(item)"
                    :disabled="item.exhibiIs"
                  ></el-date-picker>
                  <div v-if="formdata[item.title + '_' + item.type] && item.match === 'yyyy-MM-dd ww'" class="time-week">星期{{timeWeek(timeFilter(item.title + '_' + item.type))}}</div>
                </div>
              </el-form-item>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 联系人 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='relation-user' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :prop="item.title+'_'+item.type"
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>

            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <p class="right-block-text" style="min-height:40px">
                  <!-- padding:5px 10px; -->
                  <template v-for="relU in formdata[item.title + '_' + item.type]">
                    <span
                      class="relationUserStyle"
                      v-if="relU && relU.userId"
                      :key="relU.userId"
                    >
                      <relationUserInfo v-if="item.isMoreInfo" :moreInfo="item.moreInfoArr" :checkedInfo="item.checkKey" :info="relU" :isNewInfo="item.isNewData" />
                      <template v-else>{{ relU.realname }}</template>
                    </span>
                  </template>
                </p>
              </template>
              <!-- 精准搜索 -->
              <div v-else-if="item.isEnterChoice">
                <user-drop-down
                  :data="item"
                  :formdata="formdata[item.title + '_' + item.type]"
                  :itemInfo="item"
                  :placeholder="item.placeholder==''?'输入添加联系人':item.placeholder"
                  @userCheck="userCheckCallback"
                  @closeFlow="(index)=>{handleCloseFlow(item,index,1)}"
                >
                </user-drop-down>
              </div>
              <!-- 默认 -->
              <template v-else>
                <div @click="foucsInput(item)" :class="item.dataShow ? 'relation-user-wrap relation-default ccc' : 'relation-user-wrap ccc'" :ref="'relationUserRef_' + item.title">
                  <template
                    v-if="formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length!=0"
                  >
                    <div
                      class="relation-user"
                      @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                      style="text-align: left;cursor: pointer;"
                    >
                      <template v-for="(relU,index) in formdata[item.title + '_' + item.type]">
                        <el-tag
                          type="info"
                          :key="relU.userId"
                          closable
                          :disable-transitions="false"
                          @click="editUser(relU, item, $event)"
                          @close="handleCloseFlow(item,index,1)"
                          v-if="index==0 || item.isExpand"
                        >{{relU.realname}}</el-tag>
                      </template>
                      <span
                        class="relationUserStyle"
                        v-if="formdata[item.title + '_' + item.type].length>1 && !item.isExpand"
                      >等{{formdata[item.title + '_' + item.type].length}}人</span>
                      <span 
                        v-if="formdata[item.title + '_' + item.type].length>1 && !item.isExpand" 
                        style="color: #4E86FF; font-size: 12px;"
                        @click.stop="expandUser(index, true)">展开 <i class="iconfont icon-shuangjiantouyou" style="font-size: 12px;" /></span>
                      <span 
                        v-if="formdata[item.title + '_' + item.type].length>1 && item.isExpand" 
                        style="float:left; color: #4E86FF; font-size: 12px;"
                        @click.stop="expandUser(index, false)">收起 <i class="iconfont icon-shuangjiantouzuo" style="font-size: 12px;" /></span>
                        <el-input
                          v-if="formdata[item.title + '_' + item.type].length < 2"
                          style="width: 100px;"
                          size="large"
                          :autofocus="false"
                          :ref="'relationInputRef_' + item.title"
                          v-model="linkedWd[item.title + '_' + item.type]"
                          readonly
                        >
                        </el-input>
                    </div>
                  </template>
                  <template v-else>
                    <div
                      class="relation-user"
                      @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                    >
                      <el-input
                        :placeholder="formdata[item.title + '_' + item.type].length > 0 ? '' : (item.placeholder==''?'选择添加联系人':item.placeholder)"
                        :autofocus="false"
                        :ref="'relationInputRef_' + item.title"
                        size="large"
                        v-model="linkedWd[item.title + '_' + item.type]"
                        readonly
                      >
                      </el-input>
                    </div>
                  </template>
                  <div class="fast-btn">
                    <a href="javascript:;" title="组织查找" @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type],false,'orgBtn')"><i class="iconfont icon-zuzhijigou"></i></a>
                    <a v-if="item.singleIsUser !== 0" title="批量查找" @click="showBatchSearch(item)"><i class="iconfont icon-kuaisuchazhao"></i></a>
                  </div>
                  <!-- 下拉框 -->
                  <linked-drop-down
                    v-if="item.dataShow"
                    :ref="'linkedDropDownRef_' + item.title"
                    :formdata="formdata[item.title + '_' + item.type]"
                    :itemInfo="item"
                    @userCheck="userCheckCallback"
                    @closeFlow="(index)=>{handleCloseFlow(ruleListChild[itemInner],index,1)}"
                  >
                  </linked-drop-down>
                </div>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 图片 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='image' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :prop="item.title+'_'+item.type"
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            class="no-details-img"
            @click="listCli(index)"
            @mousemove="listCliRemo(index)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
              <p
                style="width:80px;height:80px;border:1px dashed #8c939d;font-size:30px;background:#f7f7f7;line-height:80px;"
                v-if="ctoArrayChild && formdata[item.title + '_' + item.type].length === 0 || ctoArrayChild && !formdata[item.title + '_' + item.type]"
              >
                <i class="el-icon-plus icon-img-file-class"></i>
              </p>
              <div style="padding-left:5px;padding-top:5px;" v-else>
                <div
                  v-for="list in formdata[item.title + '_' + item.type]"
                  class="a-list-img"
                  :key="list.url"
                >
                  <el-image
                    :src="list.url"
                    :preview-src-list="(formdata[item.title + '_' + item.type]).map(val=>{return val.url})"
                  ></el-image>
                </div>
              </div>
            </template>
            <template v-else>
              <div v-if="item.signature === true" class="signa-box">
                <a class="signabtn" title="点击签名" @click="showSigna(item)">点击签名</a>
                <div class="signaPic" v-for="(list1, index) in formdata[item.title + '_' + item.type]" :key="index">
                  <el-image
                    fit="cover"
                    :src="list1.url || ($url + list1.response + '?accesstoken=' + token)" ></el-image>
                  <a class="btn-delete" title="删除签名" @click="deleteSign(list1,item)"></a>
                </div>
              </div>
              <el-upload
                :class="classFun(item, formdata[item.title + '_' + item.type])"
                class="file-img-up"
                v-else-if="item.imgSet && item.imgSet.isopen === true"
                :ref="'uploadImgSet_' + item.title"
                :disabled="!upDataFileImgSet"
                :file-list="formdata[item.title + '_' + item.type]"
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :multiple="true"
                :auto-upload="false"
                :show-file-list="true"
                :limit="Number(item.upNumber)"
                :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, item)}"
                :on-change="(file, fileList)=>{return selectChange(file, fileList, item)}"
              >
              <!-- style="width: 84px;height:84px;color:#57A8FB;line-height: 20px;padding-top: 17px;" -->
                <div
                  style="color:#57A8FB;line-height: 20px;padding-top: 20px;box-sizing: border-box;"
                >
                  <el-icon color="#57A8FB"><CirclePlus /></el-icon>
                  <span style="display:block;font-size: 12px;">添加图片</span>
                </div>
              </el-upload>
              <el-upload
                :action="$url+'/userfile/upload?accesstoken='+token"
                :class="classFun(item, formdata[item.title + '_' + item.type])"
                class="file-img-up"
                v-else
                ref="upload"
                :disabled="!upDataFile"
                :file-list="formdata[item.title + '_' + item.type]"
                :on-progress="handleProgress"
                list-type="picture-card"
                :on-preview="handlePreview"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-remove="handleRemove"
                :limit="Number(item.upNumber)"
                :on-exceed="(file, fileList)=>{return handleExceed(file, fileList, item)}"
                :before-upload="(file)=>{return beforeImgUpload(file, item)}"
                :multiple="true"
              >
                <div
                  style="width: 84px;height:84px;color:#57A8FB;line-height: 20px;padding-top: 20px;box-sizing: border-box;"
                >
                  <el-icon color="#57A8FB"><CirclePlus /></el-icon>
                  <span style="display:block;font-size: 12px;">添加图片</span>
                </div>
              </el-upload>
            </template>

            <span
              class="icon-text"
              @click="onUp(item)"
              v-if="item.record && item.record.length > 0"
            >
              <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
              查看记录
            </span>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 文件 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='file' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            @click="listCli(index, item, formdata[item.title + '_' + item.type])"
            @mousemove="listCliRemo(index)"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
              <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
              <div class="file-label">
                <!-- 备注：2025.7.16群里报附件标题重复的问题，暂不确定注释是否会有其他影响 -->
                <!-- {{getLabelName(item)}} -->
                <strong v-if="item.per && Number(item.per) === 2 && formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length > 1 && !LRobject[tipsize]" class="file-label-down" @click.stop="fileDown(item)">
                  <i class="iconfont icon-xiazai" />
                  打包下载
                </strong>
              </div>
            </template>
            <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
              <div
                style="width:calc(50% - 34px);text-align: center;"
                v-if="ctoArrayChild && formdata[item.title + '_' + item.type].length === 0"
              >{{item.placeholder==''?'选择添加附件':item.placeholder}}</div>
              <div
                class="a-list-block"
                v-else
                v-for="(list, items) in formdata[item.title + '_' + item.type]"
                :key="items"
              >
                <div
                  class="a-list ellipsis"
                  @click="file_pvw(list)"
                  :title="list.realname ? list.realname : list.name"
                >{{list.realname ? list.realname : list.name}}</div>
                <div
                  style="min-width:100px;text-align:right;display:flex;align-items:center;"
                  :style="{minWidth: ((list.url && (list.url.indexOf('.pdf') > 0 || list.url.indexOf('.PDF') > 0) && item.signet ? 100: 40) + (item.fileDocument && item.fileDocument === 'music' ? 22 : 0) + 'px' )}"
                >
                  <!---如需提交后的数据需要更新显示，需要配置模板时时，已经提过，孙要求-->
                  <template
                    v-if="list.url && (list.url.indexOf('.pdf') > 0 || list.url.indexOf('.PDF') > 0) && item.signet"
                  >
                    <span
                      v-if="list.signet&&list.signet.isArchived"
                      @click="getdochashconf({key: items, item: item })"
                    >已归档</span>
                    <span v-else-if="list.signet&&list.signet.isRejectSign">已作废</span>
                    <el-dropdown @command="handleSignet" v-else>
                      <span class="el-dropdown-link">
                        签章
                        <i class="el-icon-arrow-down el-icon--right"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item :command="{key: items, item: item, command:'a'}">签章</el-dropdown-item>
                          <!-- 没有对应接口，先隐藏该选项 -->
                          <!-- <el-dropdown-item
                            :command="{key: items, item: item, command:'b'}"
                            v-if="list.signet"
                          >作废</el-dropdown-item> -->
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </template>
                  <a class="a-list-download" @click.stop="handleFileDown(list)">下载</a>
                  <a class="a-list-download" v-if="item.isFileEdit" @click.stop="handleFileDown(list, true)">编辑</a>
                  <i 
                    v-if="item.fileDocument && (item.fileDocument === 'music' || item.fileDocument === 'video')" 
                    @click.stop="playFun(list, item.fileDocument)"
                   :style="{color: themeConfig.headColor}" class="iconfont icon-bofang play" />
                </div>
              </div>
              <strong v-if="item.per && Number(item.per) === 2 && formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length > 1 && LRobject[tipsize]" class="file-label-down" @click.stop="fileDown(item)">
                <i class="iconfont icon-xiazai" />
                打包下载
              </strong>
              <div
                style="text-align:center;display:none;"
                v-if="item.signet&&formdata[item.title + '_' + item.type].length>0"
              >
                <el-dropdown @command="handleListSignet">
                  <el-button size="small" type="primary" style="width:170px">
                    批量操作
                    <i class="el-icon-caret-bottom el-icon--right"></i>
                  </el-button>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item
                        :command="{item: item, command:'a'}"
                        v-if="item.signet && item.signetWay"
                      >签章</el-dropdown-item>
                      <el-dropdown-item :command="{item: item, command:'b'}">文档签署完毕，归档</el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </template>
            <template v-else>
              <el-upload
              :action="$url+'/userfile/upload?accesstoken='+token"
              :class="classFun(item, formdata[item.title + '_' + item.type])"
              ref="upload"
              :disabled="!upDataFile"
              :file-list="formdata[item.title + '_' + item.type]"
              class="img-file-class no-details"
              :on-progress="handleProgress"
              list-type="text"
              :limit="Number(item.upNumber)"
              :on-preview="handlePreview"
              :on-success="handleSuccess"
              :on-error="handleError"
              :on-remove="handleRemove"
              :before-upload="(val) => beforeFileUpload(val, item)"
              :before-remove="beforeRemove"
              :multiple="true"
            >
              <div
                class="el-upload__text"
                style="line-height: 20px;padding-top: 8px;padding-bottom: 8px;width:100%;"
              >
                <el-icon><Link /></el-icon>
                {{item.placeholder==''?'选择添加附件':item.placeholder}}
              </div>
            </el-upload>
            <!-- 列表展示 -->
              <!-- <ul class="show_imglist" >
                <li
                  v-for="(item1,index1) in formdata[item.title + '_' + item.type]"
                  :key="item1.uid"
                >
                  <i class="el-icon-document" style="color:#999;"></i>
                  <a
                    href="#"
                    @click="file_pvw({ url: item1.response })"
                    :title="item1.name"
                  >{{item1.name}}</a>
                  <span class="icon_to">
                    <i class="el-icon-upload-success el-icon-circle-check" style="color:#4e86ff;"></i>
                    <i
                      class="el-icon-close"
                      @click="deleteImg(formdata[item.title + '_' + item.type],index1)"
                    ></i>
                  </span>
                </li>
              </ul> -->
            </template>
            <span
              class="icon-text"
              @click="onUp(item)"
              v-if="item.record && item.record.length > 0"
            >
              <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
              查看记录
            </span>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 富文本 -->
        <el-col
          :span="24"
          v-if="item.type=='richTextWid'"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div class="on-show" v-if="item.onShow" :style="!onShowObj[item.title+'_'+item.type] ? 'height:40px;' : ''">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>
            <template v-if="!item.onShow || onShowObj[item.title+'_'+item.type]">
              <!--只读再组件中设置-->
              <rich-text-editor
                :catchData="item"
                :isNews="isNews"
                :modify="modify"
                :disabled="item.per === 2"
                v-model:content="formdata[item.title + '_' + item.type]"
                @retAi="(val) => setAi(val ? item : null, item)"
                @handleClickImage="richTextHandleClickImage"
              ></rich-text-editor>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </template>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 新版关联单选 -->
        <el-col
          :span="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 || !item.isRel ? 24 : layout == 4 || layout === 14 ? 6 : layout == 2 || layout === 12 ? 12 : 24"
          v-else-if="item.type=='new-rel-radio'"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <p
            style="color: #333333;font-size: 14px;margin-bottom: 6px;font-weight: bold;padding-left:10px;"
            :class="item.title"
            :title="item.name"
            v-if="item.record && item.record.length > 0"
          >
            <!--{{item.name}}-->
            <span
              class="icon-text"
              @click="onUp(item)"
              v-if="item.record && item.record.length > 0"
            >
              <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
              查看记录
            </span>
          </p>
          <div :class="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 || !item.isRel ? 'hr' : ''" :style="getRelBorder(item.title)">
            <div v-if="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 || !item.isRel"
             class="rel-radio-name">
              <span class="rel-radio-name-name">{{ getLabelName(item) }}</span>
              <span v-if="!item.per || item.per && Number(item.per) !== 2 && !getUpcontroll(item)" class="rel-radio-name-button" @click="openRelUp(item)">
                {{ item.placeholder }}
              </span>
              <div v-if="relevancyShowObj[item.title + '_' + item.type]" class="rel-radio-dialog">
                <div class="rel-radio-dialog-back"></div>
                <el-col
                  class="rel-radio-dialog-new"
                  :style="{transform: relevancyTransform ? 'translateX(100%)': 0} "
                >
                <!-- :style="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 ? (layout == 4 ? 'width:calc(25% - 10px)' : 'width:50%') : ''" -->

                  <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
                  <el-form-item
                    v-show="relevancyShowObj"
                    :label="item.name"
                    :prop="item.title+'_'+item.type"
                    :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
                  >
                    <template #label>
                      <div>
                        {{ item.name }}
                        <span class="rel-radio-name-button" @click="openRelUp(item)">确定</span>
                      </div>
                    </template>
                    <div :class="classFun(item, formdata[item.title + '_' + item.type])">
                      <span
                        :class="formdata[item.title + '_' + item.type] ? 'right-block-text new-rel-radio-block' : 'right-block-text'"
                        v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)"
                      >{{formdata[item.title + '_' + item.type]||'&nbsp;'}}</span>
                      <span class="button-rel" v-else>
                        <new-rel-radio
                          :relRadio="item"
                          :isMom="false"
                          :bindVal="formdata"
                          :userHide="userHide"
                          :formdata="formdata"
                          :approvalId="approvalId"
                          :AuditList="AuditList"
                          @onRelCondition="onRelCondition"
                          @onLinkageNewRel="onLinkageNewRel"
                        ></new-rel-radio>
                        <i
                          class="WSiconfont WSicon-fwbbiaoge icon-rel"
                          @click="associatedControls(item,1, formdata)"
                        ></i>
                      </span>
                    </div>
                    <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
                  </el-form-item>
                </el-col>
              </div>
            </div>

            <el-col
              v-if="!formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type] !== 0 && item.isRel"
              style="padding:0;"
              :style="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 ? (layout == 4 ? 'width:calc(25% - 10px)' : 'width:50%') : ''"
            >
              <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
              <el-form-item
                :prop="item.title+'_'+item.type"
                :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
              >
                <template #label>
                  <span :style="getLabelStyle(item)">{{ item.name }}</span>
                </template>
                <div :class="classFun(item, formdata[item.title + '_' + item.type])">
                  <span
                    :class="formdata[item.title + '_' + item.type] ? 'right-block-text new-rel-radio-block' : 'right-block-text'"
                    v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)"
                  >{{formdata[item.title + '_' + item.type]||'&nbsp;'}}</span>
                  <span class="button-rel" v-else>
                    <new-rel-radio
                      :relRadio="item"
                      :isMom="false"
                      :bindVal="formdata"
                      :userHide="userHide"
                      :formdata="formdata"
                      :approvalId="approvalId"
                      :AuditList="AuditList"
                      @onRelCondition="onRelCondition"
                      @onLinkageNewRel="onLinkageNewRel"
                    ></new-rel-radio>
                    <i
                      class="WSiconfont WSicon-fwbbiaoge icon-rel"
                      @click="associatedControls(item,1, formdata)"
                    ></i>
                  </span>
                </div>
                <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
              </el-form-item>
            </el-col>
            <div v-show="formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === 0 || !item.isRel"
                 class="rel-radio-center">
                 <div :class="formdata[item.title + '_' + item.type] ? 'right-block-text new-rel-radio-block' : 'right-block-text'"
                    v-if="item.per && Number(item.per) === 2 && getPerFormdata(formdata, item) || !getUpcontroll(item)"
                    style="margin-bottom: 20px;padding-top: 10px;padding-bottom: 10px;"
                  >{{formdata[item.title + '_' + item.type]||'&nbsp;'}}</div>
              <widget-one-layer
                :ruleListChild="item.list"
                :ruleListChildType="3"
                :isOnes="isOne"
                :formdata="formdata"
                :layout="layout"
                :associationVisible="{key:associationVisible.key==-1?-1:-1,value:associationVisible.value,select:associationVisible.select}"
                :modifyId="modifyId"
                @record="recordFun"
                @linkageMethEmit="linkageMethChild"
                class="relation-radio-widget"
                @setAi="(val) => $emit('setAi', val)"
              ></widget-one-layer>
            </div>
            <!-- 这个是用来清除浮动的 -->
            <div style="clear: both;"></div>
          </div>
        </el-col>
        <!--此控件后台模板已淘汰--stater-->
        <el-col
          :span="layout == 4 ? 6 : 12"
          v-else-if="item.type=='relation-radio' && Number(item.per) !== 3"
          :key="item.id"
          v-show="onAssVisiblel(item,index)"
        >此控件不在支持，请联系管理员处理</el-col>
        <!--此控件后台模板已淘汰--end-->
        <!-- 关联多选 -->
        <el-col
          :span="formdata[item.title + '_' + item.type] && typeof formdata[item.title + '_' + item.type] === 'object' && formdata[item.title + '_' + item.type].data.length > 0 ? 24 : layout == 4 || layout === 14 ? 6 : layout == 2 || layout === 12 ? 12 : 24"
          v-else-if="item.type=='relation-check'"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <!-- 关联多选新格式显示（对象格式显示成这个新的，字段还是老的） -->
          <div v-if="formdata[item.title + '_' + item.type] && typeof formdata[item.title + '_' + item.type] === 'object' && formdata[item.title + '_' + item.type].data" class="rel-check">
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div v-if="relevancyShowObj[item.title + '_' + item.type]" class="rel-radio-dialog">
              <div class="rel-radio-dialog-back"></div>
              <div class="rel-radio-dialog-new" :style="{transform: (relevancyTransform ? 'translateX(100%)': 0), width: 'calc(100% - -30px)', paddingBottom: '20px'} ">
                <div class="rel-check-name">
                  {{ getLabelName(item) }}
                  <span v-if="!item.per || item.per && Number(item.per) !== 2" class="rel-radio-name-button" @click="openRelUp(item)">确定</span>
                  <span class="icon-text" @click="onUp(item)" v-if="item.record && item.record.length > 0">
                    <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                    查看记录
                  </span>
                </div>
                <el-button
                  @click="associatedControls(item,2, formdata)"
                  style="width:100%;line-height:20px;padding: 10px 20px;"
                  class="relation-radio"
                >
                  <i class="WSiconfont WSicon-fwbbiaoge"></i>
                    {{item.placeholder==''?'选择添加关联表单':item.placeholder}}
                </el-button>
              </div>
            </div>
            <div class="rel-check-name">
              {{ getLabelName(item) }}
              <span v-if="!item.per || item.per && Number(item.per) !== 2" class="rel-radio-name-button" @click="openRelUp(item)">修改</span>
              <span class="icon-text" @click="onUp(item)" v-if="item.record && item.record.length > 0">
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <tableRead :config="item" :formdata="formdata[item.title + '_' + item.type]" />
          </div>
          <el-form-item
            v-else
            :label="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <span
                v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)"
                :class="formdata[item.title + '_' + item.type] ? 'right-block-text new-rel-radio-block' : 'right-block-text'"
              >
                <span
                  v-if="(typeof formdata[item.title + '_' + item.type]).toLowerCase() === 'object' && formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length > 0"
                >
                  <span
                    v-for="(itemIn, itemInKey) in formdata[item.title + '_' + item.type]"
                    :key="itemInKey"
                    class="list-block"
                  >{{itemIn}}</span>
                </span>
                <span
                  v-else-if="formdata[item.title + '_' + item.type] !== ''"
                >{{formdata[item.title + '_' + item.type]||'&nbsp;'}}</span>
              </span>
              <el-button
                v-else
                @click="associatedControls(item,2, formdata)"
                style="width:100%;line-height:20px;padding: 10px 20px;"
                class="relation-radio"
              >
                <template
                  v-if="!formdata[item.title + '_' + item.type] || formdata[item.title + '_' + item.type] === ''"
                >
                  <i class="WSiconfont WSicon-fwbbiaoge"></i>
                  {{item.placeholder==''?'选择添加关联表单':item.placeholder}}
                </template>
                <span
                  style="color:#333333;white-space:normal;line-height:20px"
                  v-else
                >{{formdata[item.title + '_' + item.type]}}</span> 
              </el-button>
            </div>
            <span
              class="icon-text"
              @click="onUp(item)"
              v-if="item.record && item.record.length > 0"
            >
              <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
              查看记录
            </span>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 明细 -->
        <el-col
          :span="24"
          v-else-if="item.type=='details'"
          id="details-widget-children"
          :key="item.id"
          :style="getBackk(item)"
          style="padding-bottom: 11px;padding-top:11px;"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
          <div class="details-class" style="margin-bottom: 8px;position: relative;">

            <p :class="[item.title, 'details-title-top', item.labelConfig && item.labelConfig.isNameShow ? 'no-label' : '']">
              <span style="font-weight: bold;" class="ellipsis" :title="item.name">{{ getLabelName(item) }}<em style="font-weight: normal; font-style: normal;" v-if="!isInput && !modifyId && formdata[item.title+'_fillStatus'] == 0">（未填）</em></span>

              <span style="display: flex;align-items: flex-end;">
                <span class="button-details">
                  <i v-if="item.onShow && onShowObj[item.title+'_'+item.type]"
                     class="iconfont icon-guanbiyanjing"
                     @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
                  <!-- <template v-if="(isInput&&item.per==1||!isInput&&!item.detailsNum&&item.per==1||modifyId) && (!item.detailsType || item.detailsType !== 'pcLine')">
                    <a
                      class="add-button"
                      @click="goJexcel(item, formdata[item.title + '_' + item.type])"
                      v-if="!item.BatchInputUnShow"
                    >
                      <i class="iconfont icon-bianji"></i> 批量录入
                    </a>
                    <a
                      v-if="!item.pagination"
                      class="add-button"
                      @click="yesDel(index, item, formdata[item.title + '_' + item.type])"
                    >
                      <i class="el-icon-delete color-red"></i> 批量删除
                    </a>
                  </template> -->
                </span>

                <span
                  class="icon-text"
                  @click="onUp(item)"
                  v-if="item.record && item.record.length > 0"
                >
                  <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                  查看记录
                </span>
                <!-- 用户控制明细填写 -->
                <span
                  class=""
                  v-if="(isInput || modifyId) && (item.fill && item.fill.switch)"
                >
                  <el-switch v-model="fillStatusMap[item.title + '_fillStatus']" :active-value="1" :inactive-value="0" :inactive-text="item.fill.text" class="new-center"></el-switch>
                </span>
              </span>
            </p>

            <div v-if="item.onShow && !onShowObj[item.title+'_'+item.type]" class="on-show">
              <div class="on-show-show details-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
            </div>
            <!-- retOrgChoiceMethod 明细删除条数 -->
            <div v-else-if="((isInput || modifyId) && fillStatusMap[item.title + '_fillStatus']) || (!isInput && !modifyId && formdata[item.title+'_fillStatus'] != 0)" :class="item.isCutDataConfig ? 'details-table-al' : ''">
              <div v-if="item.isCutDataConfig" class="details-table-he">
                <div v-for="(lit, ltind) in item.cutDataConfig" :key="lit.i" :class="['details-table-he-list', !detailsCutObj[item.title] && ltind === 0 || detailsCutObj[item.title] === lit.i ? 'details-table-he-active' : '']" @click="setCutDetails({ title: item.title, i: lit.i })">
                  {{ lit.label }}
                </div>  
              </div>
              <div v-if="item.isCutDataConfig" class="details-table-hr"></div>
              <detailsTable
                :formdata="formdata[item.title + '_' + item.type]"
                @update:formdata="handleFormdataUpdata(item, $event)"
                :userHide="userHide"
                :pageId="pageId"
                :modify="modify"
                :detailsWidgetData="item"
                :formdatas="formdata"
                :isOne="isOne"
                :modifyId="modifyId"
                :detailsIndex="index"
                :approvalId="approvalId"
                :isInput="isInput"
                :othersObj="othersObj"
                :pageSize="getPaginationPageSize(item)"
                :current="getPaginationCurrent(item)"
                :upView="onAssVisiblel(item,index)"
                :themeConfig="themeConfig"
                :layout="layout"
                :cutkey="item.isCutDataConfig && item.cutDataConfig.length > 0 ? (detailsCutObj[item.title] || item.cutDataConfig[0].i) : ''"
                :AuditList="AuditList"
                @detailsWidgetRelUers="detailsWidgetRelUersFunc"
                @detailsShowBatchSearch="showDetailBatchSearch"
                @detailsFastRelUers="detailsChoiceUers"
                @previewPictureImg="retPreviewPictureImg"
                @linkageMethEachEmit="linkageMethChild"
                @retOrgChoiceMethod="orgChoiceMethodFun"
                @signetdetail="signetdetailFun"
                @scanOcr="scanOcr"
                :ref="item.title + 'table'"
                @setAi="(val) => $emit('setAi', val)"
                @down-file="fileDown"
                @detailsEditUers="detailsEditUers"
              ></detailsTable>
              <div v-if="!item.onShow || onShowObj[item.title+'_'+item.type]" :class="['table-features', item.detailsType && item.detailsType === 'pcLine' ? 'pl-button' : '']">
                <!--发起人有新增，审批人如果有记录的话不显示新增，没有就显示-->
                <template
                  v-if="(isInput&&item.per==1||!isInput&&!item.detailsNum&&item.per==1||modifyId) && !getUpcontroll(item) && !item.pagination"
                >
                  <p
                    class="add-button"
                    style="color: #4e86ff;font-size:16px;"
                    @click="addWidget(item, index)"
                  >
                    <i class="iconfont icon-tianjia1 button-add-icon"></i>
                    {{item.placeholder}}
                  </p>
                </template>
                <template v-if="(isInput&&item.per==1||!isInput&&!item.detailsNum&&item.per==1||modifyId) && !getUpcontroll(item)">
                  <a
                    class="add-button"
                    @click="goJexcel(item, formdata[item.title + '_' + item.type])"
                    v-if="!item.BatchInputUnShow"
                  >
                    <i class="iconfont icon-bianji"></i> 批量
                  </a>
                  <a
                    v-if="!item.pagination"
                    class="add-button add-button-del"
                    @click="yesDel(index, item, formdata[item.title + '_' + item.type])"
                  >
                    <i class="iconfont icon-shanchu5 color-red"></i> 删除
                  </a>
                </template>
                <!-- 分页 -->
                <el-pagination
                  v-if="item.pagination && (formdata[item.title + '_' + item.type]).length > 20"
                  @size-change="(val) => handleSizeChange(val, item)"
                  @current-change="(val) => handleCurrentChange(val, item)"
                  :current-page="getPaginationCurrent(item)"
                  :page-sizes="[20, 50, 100]"
                  :page-size="getPaginationPageSize(item)"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="getPaginationTotal(formdata[item.title + '_' + item.type], item)"
                ></el-pagination>
              </div>

            </div>

          </div>
          <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
        </el-col>
        <!--预约控件 开始-->
        <el-col
          :span="24"
          v-else-if="item.type=='ready-widget'"
          v-show="getHide(item)"
          :class="item.title"
          :key="item.id"
          :style="getBackk(item)"
          style="padding:0"
        >
          <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
          <template v-for="(reaM, reaMIndex) in item.list">
            <span
              class="icon-text"
              @click="onUp(item)"
              v-if="item.record && item.record.length > 0"
              :key="reaM.id"
            >
              <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
              查看记录
            </span>
            <el-col :span="reaM.per !== 2 ? 24 : 12" v-if="reaM.type=='radio'" :key="reaM.id" :style="getBackk(reaM)">
              <el-form-item
                :title="getLabelName(reaM)"
                :prop="reaM.title+'_'+reaM.type"
                :class="getFormItemClass(reaM)"
                :rules="[{ required: reaM.required=='required'?true:false,trigger: 'false'}]"
              >
                <template #label>
                  <span :style="getLabelStyle(reaM)">{{ getLabelName(reaM) }}</span>
                </template>
                <div v-if="reaM.annotationTop" class="annotation-top">{{reaM.annotationTop}}</div>
                <div
                  :class="classFun(reaM, formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type])"
                >
                  <!--radio跟select互换了格式-->
                  <span
                    class="right-block-text radio-list"
                    v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)"
                  >
                    <span v-if="reaM.types && reaM.types === 3"
                          class="radio-list-button"
                          :style="{marginBottom: 0, backgroundColor:reaM.selsItemColor?reaM.selsItemColor[formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]]:'#fff',color:reaM.selsItemColor&&reaM.selsItemColor[formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]]?'#fff':'#333'}"
                          style="border-color:transparent;"
                    >
                      {{formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]}}
                    </span>
                    <template v-else>
                      {{formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]}}
                    </template>
                  </span>
                  <div v-else :class="{'r-c-block': reaM.isCut}">
                    <div v-if="reaM.isCut" class="r-c-header">
                      <div :class="['r-c-list', cutObj[reaM.title] === its.label ? 'r-c-list-active' : '']"
                            v-for="(its, itsI) in reaM.cutList"
                            @click="$set(cutObj, reaM.title, its.label)"
                            :key="reaM.title + itsI">
                        {{ its.label }}
                      </div>
                    </div>
                    <div :class="{'r-c-content': reaM.isCut}">
                      <el-radio-group v-model="formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                        @change="widgetOneLayerEmitFun(item)" v-if="Number(reaM.types) === 1">
                        <template v-for="sels in objSels(reaM.sels, reaM)">
                          <el-radio v-if="!reaM.isHideObj || !reaM.isHideObj[sels.value || sels]" :label="sels.value || sels" :key="sels.value">
                            <span
                              class="radiovalue"
                              v-if="reaM.selsItemColor"
                              :style="{backgroundColor:reaM.selsItemColor[sels.value || sels],color:reaM.selsItemColor[sels.value || sels]?'#fff':''}"
                            >{{sels.label || sels}}</span>
                            <template v-else>
                              {{ sels.label || sels }}
                            </template>
                          </el-radio>
                        </template>
                        <el-radio label="others其他" v-if="reaM.others">其他</el-radio>
                      </el-radio-group>
                      <div v-else-if="Number(reaM.types) === 3" class="radio-list" style="margin-bottom:-10px;">
                        <template v-for="(its, indexIts) in objSels(reaM.sels, reaM)">
                          <div v-if="!reaM.isHideObj || !reaM.isHideObj[its.value || its]"
                            :key="indexIts + (its.value || its)"
                            @click="setRadioWidget({val: its.value || its, item: reaM, widget: item.title + '_' + item.type}, item)"
                            :style="getRadioStyle(its.value || its, reaM, item.title + '_' + item.type)"
                            class="radio-list-button">{{its.label || its}}</div>
                        </template>
                      </div>
                      <el-select
                        v-else
                        v-model="formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                        :placeholder="reaM.placeholder"
                        class="input-details"
                        size="large"
                        style="width: 100%;"
                        @focus="conditionLink(item.list[0])"
                        @change="widgetOneLayerEmitFun(item)"
                        @visible-change="onselschange($event,item.list[0])"
                        :disabled="reaM.exhibiIs"
                      >
                        <template v-for="sels in objSels(reaM.sels)">
                          <el-option
                            v-if="!reaM.isHideObj || !reaM.isHideObj[sels.value || sels]"
                            :key="sels.value || sels"
                            :label="sels.label || sels"
                            :value="sels.value || sels"
                          ></el-option>
                        </template>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div v-if="reaM.annotationBottom" class="annotation-bottom">{{reaM.annotationBottom}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="reaM.per !== 2 ? 24 : 12" v-if="item.continuousMode && reaMIndex === 1 && formdata[item.title + '_' + item.type][0][item.list[0].title + '_' + item.list[0].type] && reaM.per !== 2" :key="reaM.id" :style="getBackk(reaM)">
              <el-form-item required>
                <template #label>
                  <span :style="getLabelStyle(reaM)">连续模式</span>
                </template>
                <div class="ready-widget-continue-model">
                  <el-radio-group @change="changeDateModel(item)" v-model="formdata[item.title + '_' + item.type][0].continueModel">
                    <el-radio value="week">循环周数</el-radio>
                    <el-radio value="day">循环天数</el-radio>
                  </el-radio-group>
                  <div class="ready-widget-continue-model-item">
                    <span class="model-item-title">预约天数:</span>
                    <el-input-number @change="changeDateModel(item)" :min="1" v-model="formdata[item.title + '_' + item.type][0].appointmentDays" />
                  </div>
                  <div class="ready-widget-continue-model-item">
                    <span class="model-item-title">间隔天数:</span>
                    <el-input-number @change="changeDateModel(item)" :min="0" v-model="formdata[item.title + '_' + item.type][0].daysInterval" />
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="reaM.per !== 2 ? 24 : 12" v-if="reaM.type=='dates' && formdata[item.title + '_' + item.type][0][item.list[0].title + '_' + item.list[0].type] && reaM.per !== 2" :key="reaM.id" :style="getBackk(reaM)">
              <el-form-item
                :title="getLabelName(reaM)"
                style="position:relative;"
                :class="getFormItemClass(reaM)"
                :rules="[{ required: reaM.required=='required'?true:false,trigger: 'false'}]"
              >
                <template #label>
                  <span :style="getLabelStyle(reaM)">{{ getLabelName(reaM) }}</span>
                </template>
                <div v-if="reaM.annotationTop" class="annotation-top">{{reaM.annotationTop}}</div>
                <div
                  :class="classFun(reaM, formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type])"
                >
                  <span class="right-block-text" v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                    <template
                      v-if="formdata[item.title + '_' + item.type][0] && formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                    >
                      <template
                        v-for="(timeItem, timeItenIndex) in formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                      >
                        {{timeItem}} {{timeItenIndex === 0 ? ' 至 ' : ''}}
                      </template>
                    </template>
                  </span>
                  <template v-else>
                    <div class="widget-ti">
                      <template v-if="!item.continuousMode">
                        <div class="widget-ti-t">
                          预约日期：
                          <template v-if="!formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type] || formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type].length === 0">未选择</template>
                          <template v-for="(timeItem, timeItenIndex) in formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]">
                            {{timeItem}} {{timeItenIndex === 0 ? ' 至 ' : ''}}
                          </template>
                          <i class="iconfont icon-yuyuekongjian" />
                        </div>
                        <el-date-picker
                            v-model="formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                            @change="datasOnPickFun(item,reaM)"
                            @focus="widgetDateFocus(formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type])"
                            @blur="widgetDateBlur"
                            :picker-options="pickerOptionsAdvance(reaM, item.weekConfig)"
                            class="input-widget"
                            size="large"
                            format="YYYY-MM-DD"
                            value-format="YYYY-MM-DD"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width:100%"
                          ></el-date-picker>
                      </template>
                      <template v-else>
                        <div class="widget-ti-t">
                          预约日期：
                          <template v-if="contineuDate">
                            {{ contineuDate }}
                          </template>
                          <i class="iconfont icon-yuyuekongjian" />
                        </div>
                        <el-date-picker
                          v-model="contineuDate"
                          @change="getWidgetVal($event, {item: item, reaM: reaM})"
                          class="input-widget"
                          format="YYYY-MM-DD"
                          value-format="YYYY-MM-DD"
                          type="date"
                          style="width:100%"
                        ></el-date-picker>
                      </template>
                    </div>
                    <switchScrell>
                      <div class="widget-b">
                        <div v-for="(wlist, wlistInd) in getWidgetList((formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type] || []), reaM, item)" :key="wlistInd + 'ww'" @click="getWidgetVal(wlist.date, {item: item, reaM: reaM})" :class="['widget-list', getCheckTime(wlist.date, formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type], item)]">
                          <div class="widget-list-d">{{wlist.date}}</div>
                          <div class="widget-list-w">{{wlist.week}}</div>
                        </div>
                      </div>
                    </switchScrell>
                  </template>
                </div>
                <div v-if="reaM.annotationBottom" class="annotation-bottom">{{reaM.annotationBottom}}</div>
              </el-form-item>
            </el-col>
            <el-col :span="reaM.per !== 2 ? 24 : 12" v-if="reaM.type=='displaylist' && formdata[item.title + '_' + item.type][0][item.list[1].title + '_' + item.list[1].type]" :key="reaM.id" :style="getBackk(reaM)">
              <el-form-item
                :title="getLabelName(reaM)"
                :class="getFormItemClass(reaM)"
                :prop="reaM.title+'_'+reaM.type"
                :rules="[{ required: reaM.required=='required'?true:false,trigger: 'false'}]"
              >
                <template #label>
                  <span :style="getLabelStyle(reaM)">{{ getLabelName(reaM) }}</span>
                </template>
                <div v-if="reaM.annotationTop" class="annotation-top">{{reaM.annotationTop}}</div>
                <div
                  :class="classFun(reaM, formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type])"
                >
                  <div class="time-class" v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                    <div class="time-class-wrap ready-class">
                      
                      <p
                        v-for="(dateTime, dateTimeIndex) in formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                        :key="dateTimeIndex"
                        style="margin-right: 5px;"
                      >
                        <span class="date">{{dateTime.date}}</span>
                        <span v-if="dateTime.optionsvalue">{{dateTime.optionsvalue}}</span>
                        <span v-else>
                          <template v-if="dateTime.tick ? dateTime.tick && dateTime.tick === 10 : item.weekConfig && item.weekConfig.tick && item.weekConfig.tick === 10">
                            {{timeArr10[dateTime.time[0]]}} 至
                            {{timeArr10[dateTime.time[1]+1]}}
                          </template>
                          <template v-else>
                            {{timeArr[dateTime.time[0]]}} 至
                            {{timeArr[dateTime.time[1]+1]}}
                          </template>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="time-class" v-else>
                    <display-list-select
                      :key="timeKey"
                      :value-time="formdata[item.title + '_' + item.type][0][reaM.title + '_' + reaM.type]"
                      :appointmentDays="formdata[item.title + '_' + item.type][0].appointmentDays"
                      @update:value-time="handleValueTimeUpdate(item, reaM, $event)"
                      @changeValue="changeValueTime(item, reaM, $event)"
                      :se-time="formdata[item.title + '_' + item.type][0][item.list[1].title + '_' + item.list[1].type]"
                      @update:se-time="handleSeTimeUpdate(item, $event)"
                      :widgetTimeObj="widgetTimeObj"
                      :config="item"
                    />
                  </div>
                </div>
                <div v-if="reaM.annotationBottom" class="annotation-bottom">{{reaM.annotationBottom}}</div>
              </el-form-item>
            </el-col>
          </template>
          <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
        </el-col>
        <!--预约控件 结束-->
        <!-- 组织控件 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='organization' && Number(item.per) !== 3"
          :key="item.id"
          v-show="onAssVisiblel(item,index) && getHide(item)"
          :style="getBackk(item)"
        >
          <el-form-item
            :prop="item.title+'_'+item.type"
            :title="item.name"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <p class="right-block-text" style="padding:5px 10px;min-height:30px">
                  <span
                    class="relationUserStyle"
                    v-for="relU in formdata[item.title + '_' + item.type]"
                    :key="relU.organizationId"
                  >
                    <el-tooltip effect="dark" :content="relU.name" placement="top">
                      <span>{{ dealShowName(relU) }}</span>
                    </el-tooltip>
                  </span>
                </p>
              </template>
              <!-- 默认 -->
              <template v-else>
                <template
                  v-if="formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length!=0"
                >
                  <div
                    class="relation-user relation-org-role"
                    @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                    style="text-align: left;cursor: pointer;"
                  >
                    <template v-for="(relU,index) in formdata[item.title + '_' + item.type]" :key="relU.organizationId">
                      <el-tooltip effect="dark" :content="relU.name" placement="top">
                        <el-tag
                          type="info"                          
                          closable
                          :disable-transitions="false"
                          @close="handleCloseFlow(item,index,1)"
                          v-if="index==0"
                        >{{ dealShowName(relU) }}</el-tag>
                      </el-tooltip>
                    </template>
                    <span
                      class="relationUserStyle"
                      v-if="formdata[item.title + '_' + item.type].length>1"
                    >等{{formdata[item.title + '_' + item.type].length}}个组织</span>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="relation-user relation-org-role"
                    @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                  >
                    <span>
                      <i
                        class="icon iconfont icon-gerenzhongxin"
                        style="line-height:0;"
                      ></i>
                      {{item.placeholder==''?'选择添加联系人':item.placeholder}}
                    </span>
                  </div>
                </template>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 角色控件 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='roule' && Number(item.per) !== 3"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :prop="item.title+'_'+item.type"
            :title="getLabelName(item)"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <div :class="classFun(item, formdata[item.title + '_' + item.type])">
              <template v-if="item.per && Number(item.per) === 2 || getUpcontroll(item)">
                <p class="right-block-text" style="padding:5px 10px;min-height:30px">
                  <span
                    class="relationUserStyle"
                    v-for="relU in formdata[item.title + '_' + item.type]"
                    :key="relU.roleId"
                  >{{relU.name}}</span>
                </p>
              </template>
              <!-- 默认 -->
              <template v-else>
                <template
                  v-if="formdata[item.title + '_' + item.type] && formdata[item.title + '_' + item.type].length!=0"
                >
                  <div
                    class="relation-user relation-org-role"
                    @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                    style="text-align: left;cursor: pointer;"
                  >
                    <template v-for="(relU,index) in formdata[item.title + '_' + item.type]">
                      <el-tag
                        type="info"
                        :key="relU.roleId"
                        closable
                        :disable-transitions="false"
                        @close="handleCloseFlow(item,index,1)"
                        v-if="index==0"
                      >{{relU.name}}</el-tag>
                    </template>
                    <span
                      class="relationUserStyle"
                      v-if="formdata[item.title + '_' + item.type].length>1"
                    >等{{formdata[item.title + '_' + item.type].length}}人</span>
                  </div>
                </template>
                <template v-else>
                  <div
                    class="relation-user relation-org-role"
                    @click="relationUserChoice(item,1, formdata[item.title + '_' + item.type])"
                  >
                    <span>
                      <i
                        class="icon iconfont icon-gerenzhongxin"
                        style="line-height:0;"
                      ></i>
                      {{item.placeholder==''?'选择添加联系人':item.placeholder}}
                    </span>
                  </div>
                </template>
              </template>
              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
        <!-- 查询控件 -->
        <el-col
          :span="getCol(item)"
          v-else-if="item.type=='query' && (!item.containerIs || (ruleListChildType && ruleListChildType === 3))"
          :key="item.id"
          :style="getBackk(item)"
          v-show="onAssVisiblel(item,index) && getHide(item)"
        >
          <el-form-item
            :title="getLabelName(item)"
            :prop="item.title+'_'+item.type"
            :class="getFormItemClass(item)"
            :rules="[{ required: item.required=='required'?true:false,trigger: 'false'}]"
          >
            <template #label>
              <span :style="getLabelStyle(item)">{{ getLabelName(item) }}</span>
            </template>
            <div v-if="item.annotationTop" class="annotation-top">{{item.annotationTop}}</div>
            <!-- 点击显示眼睛图标 -->
            <div class="on-show" v-if="item.onShow">
              <div class="on-show-show"
                   v-show="!onShowObj[item.title+'_'+item.type]"
                   @click="setOnShow(item, onShowObj[item.title+'_'+item.type])">
                <i class="iconfont icon-dakaiyanjing" />
                {{item.placeholder}}
              </div>
              <i class="iconfont icon-guanbiyanjing on-show-close on-select"
                 @click="setOnShow(item, onShowObj[item.title+'_'+item.type])" />
            </div>

            <div>
              <!--radio跟select互换了格式-->
              <template>
                <!-- 填充查询 -->
                <!-- <div class="on-show" style="pointer-events:none;">
                  <div class="on-show-show on-show-left" style="pointer-events:none;">
                    <i class="iconfont icon-shujuchaxun" />
                    {{item.placeholder}}
                  </div>
                </div> -->
                <!-- 填充查询 -->
                <div class="query-value1" v-if="item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1">
                  {{formdata[item.title + '_' + item.type]}}
                  <i class="iconfont icon-right icon-sousuo" />
                </div>
                <!-- 点击查询 -->
                <div class="query-value3" v-else-if="item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 3">
                  <i class="iconfont icon-sousuo" />
                  <el-select
                      v-model="formdata[item.title + '_' + item.type]"
                      :placeholder="item.placeholder"
                      class="input-details select-details"
                      style="width: 100%"
                      size="large"
                      filterable
                      clearable
                      @focus="conditionLink(item)"
                      :class="classFun(item, formdata[item.title + '_' + item.type])"
                      @change="approvalProcess(item, formdata[item.title + '_' + item.type], formdata)"
                      @visible-change="onselschange($event,item)"
                      :disabled="item.exhibiIs"
                    >
                      <el-option
                        v-for="(sels, selsIndex) in objSels(item.sels, item)"
                        :key="selsIndex"
                        :label="sels.label || sels"
                        :value="sels.value || sels"
                      >
                      </el-option>
                  </el-select>
                </div>
              </template>

              <span
                class="icon-text"
                @click="onUp(item)"
                v-if="item.record && item.record.length > 0"
              >
                <i class="iconfont icon-shenpitianxie-chakanjilu-"></i>
                查看记录
              </span>
            </div>
            <div v-if="item.annotationBottom" class="annotation-bottom">{{item.annotationBottom}}</div>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
    <el-dialog
      :show-close="false"
      v-model="percentageVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px"
      center
    >
      <el-progress :text-inside="true" :stroke-width="24" :percentage="percentage" status="success"></el-progress>
    </el-dialog>
    <el-dialog
      title="签名板"
      v-model="signaVisible"
      width="900px"
      class="signa"
      append-to-body
      >
      <div class="sign">
        <div class="pc">
          <h6>电脑端签名</h6>
          <div class="box">
            <vue-esign ref="esign" class="canvas" :width="582" :height="350" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor="bgColor" />
            <el-button class="clear" size="large" type="primary" @click="handleReset">重签</el-button>
          </div>
        </div>
        <div class="phone">
          <p class="tip1">使用微信扫码签名</p>
          <div class="code">
            <vue-qrcode 
              :value="vueqrval" 
              :options="{
                width: 188,
                height: 188,
                margin: 5
              }"
            />
          </div>
          <p class="tip2">扫描后可在手机端签名</p>
          <div v-if="uploadSignStatus">
            <div class="upload-sign">
              <el-icon><Plus /></el-icon>
              <span>上传签名图片</span>
              <input type="file" id="upload-file" @change="uploadSign()" />
            </div>
            <p class="tip2">上传签名图片格式.png</p>
          </div>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="signaVisible = false">取 消</el-button>
          <el-button size="large" type="primary" @click="upSigna">提 交</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      title="图片编辑"
      v-model="clipVisible"
      width="852px"
      class="dialog-imgset"
      :close-on-click-modal="false"
      :show-close="false"
      append-to-body
      >
      <template #title>
        <div class="dialog-title">
          <div class="title">图片编辑</div>
          <div class="close" @click="clipClose">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
      </template>
      <div class="up-img-block">
        <div class="up-img-crop">
          <VueCropper
            ref="cropper"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="true"
            :infoTrue="option.infoTrue"
            :full="option.full"
            :canScale="option.canScale"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :autoCropWidth="option.autoCropWidth"
            :autoCropHeight="option.autoCropHeight"
            :fixed="option.fixed"
            :fixedBox="option.fixedBox"
            :fixedNumber="option.fixedNumber"
            :centerBox="true"
          ></VueCropper>
        </div>
      </div>
      <div class="operate">
        <el-button size="mini" plain @click="updateCropper"
          >重新选择图片</el-button
        >
        <el-button size="mini" type="yeprimary" @click="yesCrop"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <oaExamineAssForm
      ref="oaExamineAssFormRef"
      :detailsNum="detailsNum"
      :userHide="userHide"
      :approvalId="approvalId"
      :openAssForm="openAssForm"
      @newRetDate="onLinkageNewRel"
      @momnewrelradio="momNewRelRadioFun"
      @retDate="linkageMethChild"
    ></oaExamineAssForm>
    <selection-period  ref="selectionPeriodRef" @retTime="retTimeChildFun"></selection-period>
    <multiple-choice
      ref="multipleChoiceRef"
      v-on:fromMultipleChoice="fromMultipleChoice"
      v-show="isMultipleChoice"
      :isSpace="isSpace"
      :isUpace="isUpace"
    ></multiple-choice>
    <allmultiple-choice
      ref="allMultipleChoiceRef"
      v-on:fromMultipleChoice="orgChoiceMethod"
      v-show="isAllMultipleChoice"
      :isSpace="isSpace"
    ></allmultiple-choice>
    <jexcelTable ref="jexcelTable" @retJexcel="retJexcel" :approvalId="approvalId"></jexcelTable>
    <signetList
      ref="signeListRef"
      :approvingId="approvingId"
      @signetListSet="signetListSetMethod"
      @SignetTemplateDown="handleFileDown"
    />
    <signet-template ref="signetTemplateRef" @signetTemplateChild="handleSignetTemplateChild" />
    <batch-search ref="batchSearchRef" @batchSearchChild="handleBatchSearchChild" />
    <loadprogress ref="loadprogressRef" />
    <sysUser ref="sysUser" :detailsNum="detailsNum" @newRetDate="onLinkageNewRel" @momnewrelradio="momNewRelRadioFun" />
    <editUserInfo :isView="isShowEidtUser" :userInfo="editUserInfo" :editUserInfoKey="editUserInfoKey" />
  </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { defineAsyncComponent } from 'vue'
/**
 * per  1 输入  2 只读  3 隐藏
 * */
import oaExamineAssForm from "../oaExamineAssCont.vue"; //关联表单
import multipleChoice from "../../common/multipleChoice"; //组织结构和角色选择
import newRelRadio from "./newRelRadio.vue"; //新版单选关联
import { VueCropper } from 'vue-cropper' //图片编辑裁剪
import tableRead from './detailsTable/tableRead.vue'
import * as widgetJs from "@/api/widgetOneLayer.js";
import * as func from "./js/signet"; //- 签章和区块链 路径
// 签名板
import vueEsign from 'vue-esign'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { debounce } from 'lodash'
import {
  formatDate,
  fileFormatted,
  linkedDetailsKeyMap,
  onIsinclude,
  linkedSetEvent,
  linkedFormatConversion,
  sliceEncrypt,
  onTimeDifference,
  onDigitCount,
  filePreview,
  fileListForeach,
  getSwitchColor,
  isStandardClass,
  getClassInfo,
  getOrgShowName,
  getPinyin,
} from "@/api/global.js";
import {
  openapiGetapprovalreserve,
  getlinkeddatalist,
  getapprovalordertimes,
  filepackdownload
} from "@/port/clientSide/oaExamineAudit";
import {
  momVal,
  unique,
  formatConversion,
  generateTime,
  generateTime10,
  assignFormdata,
  uploaderFun,
  othersRed,
  limitDate,
  thisNoTime,
  copyObj,
  countRule,
  downArrZip,
  formatWY,
  isWY,
  calculateSchedule
} from "@/api/utils";
import { getuserbindlistmsg, getnewuserbindmsg, getapiuserlist } from '@/port/clientSide/multipleChoice.js'
import { getuserroles } from '@/port/schoolInstrument/appConfig'
import { retClassName, getWeek } from "@/api/styleUtils";
import webSocketClass from "@/api/ws";
import detailsTable from "./detailsTable/detailsTable.vue";
import Axios from "axios";
import * as math from 'mathjs';
import { patentFun } from './js/ability'
import { getNewRelRadioRes } from './js/newRelRadioLink'
import { ElMessage } from 'element-plus'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from "v-viewer"
export default {
  name: "widget-one-layer",
  /**
   * ruleListChild  数据列表
   * ctoArrayChild  流程数据
   * ruleListChildType  类型判断2明细/3关联单选
   * isInput  是否发起1发起，2为重新提交或者暂存，无值处理人
   * modifyId   是否为修改
   * formdata 结果集
   * isOnes关联调用本组建，需要本组建参数  （othersObj 、layout）
   *    othersObj 单选框选择了其他的数据存储
   *    layout  1 左右布局（一列） 2 左右布局（两列） 4 左右布局（四列）  11 上下布局(一列) 12 上下布局(二列) 14 上下布局(四列)
   *    associationVisible  根据选项值隐藏显示
   *  tipsize 标题字体
   * themeConfig 主题配置
   *    isSubmit 是否一键提交
   * */
  props: [
    "ruleListChild",
    "ctoArrayChild",
    "ruleListChildType",
    "approvalId",
    "approvingId",
    "isInput",
    "isOnes",
    "modifyId",
    "formdata",
    "othersObj",
    "layout",
    "associationVisible",
    'pdwidth',
    "backColor",
    "tipsize",
    "themeConfig",
    "isSubmit",
    "modify",
    "baseSet",
    "cutObj",
    "opensafe",
    "AuditList",
    "pageId",
    "isNews",
    "customData",
    "isReadonlyDetails",
    "fiexdCanvasInfo",
    "isFiexdCanvas",
    "isAppenDetailsFeild"
  ],
  data() {
    return {
      isOne: false,
      // 图片上传
      upDataFile: true,
      indexNumber: null,
      removeIndN: null,
      fileListLength: 0,
      signaVisible: false,// 签名板的显示
      uploadSignStatus: false, //是否显示上传签名图片按钮
      indexString: null, // 记录签名板的位置
      // 签名板手机端二维码
      vueqrval: '',
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,
      signaPic:false, // 签名后的图片
      associatedControlsData: null, //关联控件单选
      isInformRelWyArr: [], //是否同步关于我的
      relationUserDataO: null, //联系人控件。选中值
      dataParenTy: "", //区分控件.1:外层，2:明细，3:关联单选，4:明细单选，
      informRelCto: [], //告知
      detailsAllWidgetData: null, //明细控件数据
      linkedMessageArr: [], //单选关联其它参数
      timeDistance: "", //预约天数
      thisMMDate: null,
      timeArr: [],
      timeArr10: [],
      // CustomTime: [], // 自定义时间段
      isIndex: 0, //明细回来的一级控件下标
      isListIndex: null, //明细回来的二级控件下标
      detailsNum: null, //限制的条数
      restaurants: [], //单行多行的搜索值（暂用）
      restaurantsFun: null,
      //数据联动加载进度条倒计时
      percentageVisible: false,
      percentage: 0,
      linkedDetailsKey: null, //联动明细暂时存储数据使用，不做任何渲染数据
      dataDeleteReturn: [], //- 联系人控件重新选择人时需要数据重新还原的数据
      radioBlur:{},//单选有颜色时候，点击下拉需要把项隐藏
      inputChange: false, //由于当行输入框无法获取数据改变方法事件，所以联动需要使用，就通过这个来写

      autocompleteFunText: null, // 这个是用来暂存的单行联动搜索数据

      styleTime: null,

      userHide: {}, // 提交后隐藏的数据集中存储地

      isMultipleChoice: false,
      linkedWd: {}, //联系人控件搜索
      isAllMultipleChoice: false,

      // 分页
      pageSize: 20,
      current: 1,
      // 点击显示使用
      onShowObj: {},
      // 打开选择模板
      openAssForm: '',
      // 数据选项使用
      conditionLinkObj: null,
      // 刷卡联动
      readcardLinked: false,
      readcardCount: 0,
      // toke
      token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
      // 图片编辑裁剪相关参数
      // 图片弹窗是否显示
      clipVisible: false,
      // 图片列表是否显示
      clipListShow: false,
      clipListLength: 0,
      // 图片裁剪信息
      imgBlod: null,
      // 图片列表
      clipList: [],
      upDataFileImgSet: true,
      uploadRef: '',
      option: {
        img: '',
        outputSize: 1, //剪切后的图片质量（0.1-1）
        full: true,//输出原图比例截图 props名full
        outputType: 'png',
        canScale: false, // 图片是否允许滚轮缩放
        canMove: true,
        original: true,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixed: true,
        fixedBox: true,
        fixedNumber: [1, 1]
      },
      // 关联单多选的弹出打开
      relevancyShowObj: {},
      relevancyTransform: false,
      LRobject: {
        11: true,
        12: true,
        14: true
      },
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      submitTimer: null, // 一键提交定时器
      widgetTimeObj: {},
      widgetDisp: {},
      widgetDate: '',
      // 存放时间配置下拉使用
      timeWidthObj: {},
      // 明细切页存值使用
      detailsCutObj: {},
      detailsPageSize: {},
      detailsCurrent: {},
      tempFormdata: {},
      isShowEidtUser: false, // 是否显示联系人编辑
      editUserInfoKey: {},
      editUserInfo: {},
      fillStatusMap: {}, //明细控件是否填写状态控制
      timeKey: 0,
      contactList: [], //联系人控件下拉菜单返回的数据
      textareaRelShow: false, //多行输入框联动下拉菜单是否显示
      currentUserRole: [],
      contineuDate: ''
    };
  },
  components: {
    oaExamineAssForm,
    selectionPeriod: defineAsyncComponent(() => import('../common/selectionPeriod')), //预约控件时间
    newRelRadio,
    multipleChoice,
    allmultipleChoice: defineAsyncComponent(() => import('../../common/allMultipleChoice')), //组织角色选择（平台+空间）
    richTextEditor: defineAsyncComponent(() => import('@/components/common/richTextEditor')),
    jexcelTable: defineAsyncComponent(() => import('@/components/jexcel/jexcelTbale')),
    detailsTable,
    signetList: defineAsyncComponent(() => import('./signetList')), // 批量操作
    signetTemplate: defineAsyncComponent(() => import('./signetTemplate')), //模板选择
    vueEsign,
    VueQrcode,
    VueCropper,
    sysUser: defineAsyncComponent(() => import('./sysUser')), //模板选择
    tableRead,
    switchScrell: defineAsyncComponent(() => import('./widgetCommon/switchScrell')), //预约控件日期切换
    displayListSelect: defineAsyncComponent(() => import('./widgetCommon/displayListSelect')),
    userDropDown: defineAsyncComponent(() => import('./userDropDown')),
    linkedDropDown: defineAsyncComponent(() => import('./linkedDropDown')),
    batchSearch: defineAsyncComponent(() => import('./batchSearch')),
    location: defineAsyncComponent(() => import('./location/index')),
    multilevel: defineAsyncComponent(() => import('../common/multilevel')),
    timePicker: defineAsyncComponent(() => import('../common/timePicker')),
    radioXing: defineAsyncComponent(() => import('./widgetCommon/radioXing')),
    relationUserInfo: defineAsyncComponent(() => import('@/components/clientSide/common/relationUserInfo')),
    editUserInfo: defineAsyncComponent(() => import('@/components/admins/organization/common/editUserInfo')),
  },
  created() {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
    }
    this.timeArr = generateTime();
    this.timeArr10 = generateTime10();
    this.getCurrentUserInfo()
  },
  computed: {
    handlePadding() {
      let pd = '20px'
      let width = 'calc(100% - 50px)'
      if (Number(this.pdwidth) <= 50) {
        pd = '20px 40px'
        width = 'calc(100% - 80px)'
      } else if (Number(this.pdwidth) > 50 && Number(this.pdwidth) < 80) {
        pd = '20px 60px'
        width = 'calc(100% - 120px)'
      } else if (Number(this.pdwidth) >= 80) {
        pd = '20px 120px'
        width = 'calc(100% - 240px)'
      }
      return {
        padding: pd,
        width 
      }
    },
    // 是否左右布局
    isPhonelayout () {
      let flag = this.LRobject[this.layout]
      if (this.isFiexdCanvas) {
        // 固定画布不生效
        flag = false
      }
      return flag
    }
  },
  methods: {
    // 控件布局
    async getCurrentUserInfo() {
      const user = localStorage.getItem('user')
      if (user) {
        const res = await getuserroles()
        if (res.code === 0) {
          this.currentUserRole = res.data.list
        }
      }
    },
    isRolePermission(li) {
      if (this.currentUserRole.length === 0) return false
      for (const ele of this.currentUserRole) {
        const roleId = ele.roleId
        const idx = li.findIndex(f => f.roleId === roleId)
        if(idx !== -1) {
          return true
        }
      }
      return false
    },
    getCol (item) {
      let col = this.layout == 4 || this.layout === 14 ? 6 : this.layout == 2 || this.layout === 12 ? 12 : 24
      switch(item.type) {
        case 'file': {
          col = this.isNews ? 24 : col
          break
        }
        case 'organization': {
          col = this.layout == 4 ? 6 : this.layout == 2 ? 12 : 24
          break
        }
        case 'roule': {
          col = this.layout == 4 ? 6 : this.layout == 2 ? 12 : 24
          break
        }
      }
      // 如果是固定画布下走固定画布的配置
      col = this.isFiexdCanvas && item.col ? item.col : col
      return col
    },
    changeDateModel(config) {
      const key = config.title + '_' + config.type
      const val = this.formdata[key][0]
      const { continueModel, appointmentDays, daysInterval } = val
      const list = config.list
      if (val) {
        const reaM = list.find(f => f.type === 'dates')
        const lookCustomArrRole = reaM.lookCustomArrRole || []
        let flag = true
        if (reaM.isLimit && this.isRolePermission(lookCustomArrRole)) {
          flag = false
        }
        if (appointmentDays > reaM.lengthTime && flag) {
          ElMessage.warning(`选择时长不能超过${reaM.lengthTime}天`)
          return
        }
        let dates = {
          value: [],
          key: ''
        }
        let displaylist = {
          value: [],
          key: ''
        }

        for (const key in val) {
          if (key.includes('dates')) {
            dates.value = val[key] || []
            dates.key = key
            continue
          }
          if (key.includes('displaylist')) {
            displaylist.value = val[key]  || []
            displaylist.key = key
            continue
          }
        }
        const fdate = dates.value[0]
        const fdisplaylist = displaylist.value[0]
        if (fdate) {
          const opt = {
            reservationDays: appointmentDays,
            gapDays: daysInterval,
            value: fdate,
            model: continueModel
          }
          const newDate = calculateSchedule(opt)
          this.formdata[key][0][dates.key] = newDate
          if (fdisplaylist) {
            this.formdata[key][0][displaylist.key] = newDate.map(item=>{
              return {
                tick: fdisplaylist.tick,
                date: item,
                time: fdisplaylist.time
              }
            })
          }
        }
      }
    },
    foucsInput(item) {
      const key = `relationInputRef_${item.title}`
      const refs = this.$refs[key]
      // 添加安全检查
      if (refs && Array.isArray(refs) && refs.length > 0) {
        const ref = refs[0]
        if (ref && ref.$refs && ref.$refs.input) {
          ref.$refs.input.focus()
        }
      } else if (refs && refs.$refs && refs.$refs.input) {
        // 如果 refs 不是数组，直接使用
        refs.$refs.input.focus()
      }
    },
    richTextHandleClickImage (e) {
      if (e) {
        viewerApi({ images: [e] })
      }
    },
    debounce(fn) {
      return debounce(fn)
    },
    dealShowName(data) {
      return getOrgShowName(data)
    },
    expandUser (index, flag) {
      // this.$set(this.ruleListChild[index], 'isExpand', flag)
      this.ruleListChild[index]['isExpand'] = flag
    },
    async editUser (user, item, event) {
      // 修改页面才可以修改用户信息
      // pageId 5 关于我的 7 全部数据 1 个人数据
      const pageObj = {
        1: 'person',
        5: 'about',
        7: 'all',
      }
      if (this.modify && item.isMoreInfo && item.isUserEidt && item.userEidtInfo) {
        const { userInfo, page } = item.userEidtInfo
        if (page && page[pageObj[this.pageId]]) {
          event.stopPropagation();
          if (Object.keys(userInfo).length === 0) {
            return this.$message.warning('未选择可编辑字段')
          } else {
            const { data } = await getapiuserlist({userids: user.userId, curpage: 0, pagesize: 1})
            if (data && data[0]) {
              this.editUserInfo = data[0]
              this.editUserInfoKey = userInfo
              this.isShowEidtUser = true
            } else {
              this.$message.warning('用户不存在')
            }
          }
        }
      }
    },
    detailsEditUers ({ editUserInfoKey, editUserInfo }) {
      this.editUserInfo = editUserInfo
      this.editUserInfoKey = editUserInfoKey
      this.isShowEidtUser = true
    },
    upXing (val, item) {
      const type = item.title + '_' + item.type
      // this.$set(this.formdata, type, val)
      this.formdata.type = val
      // this.$emit('update:formdata', { ...this.formdata, [type]: val })
      this.approvalProcess(item, this.formdata[type], this.formdata)
    },
    openLinkText (val, config = {}) {
      if (config.isLink) {
        window.open(val)
      }
    },
    pickerOptionsAdvance (config, weekConfig) {
      if (config.advance && Number(config.advanceNum)) {
        let o = ''
        if (config.advanceType && config.advanceType === 'hour') {
          o = (Number(config.advanceNum) * 3600 * 1000)
        } else {
          o = (Number(config.advanceNum) - 1) * 24 * 3600 * 1000
        }
        return {
           disabledDate (time) {
            if (weekConfig) {
              const day = time.getDay()
              if (config.advanceType && config.advanceType === 'hour') {
                return time.getTime() < Date.now() || !weekConfig[day === 0 ? 7 : day]
              } else {
                return time.getTime() < Date.now() + o || !weekConfig[day === 0 ? 7 : day]
              }
            } else {
              return time.getTime() < Date.now() + o
            }
          }
        }
      } else {
        return {
          disabledDate (time) {
            if (weekConfig) {
              const day = time.getDay()
              return !weekConfig[day === 0 ? 7 : day]
            } else {
              return true
            }
          }
        }
      }
    },
    getPaginationCurrent (item) {
      if (item.isCutDataConfig) {
        const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
        return this.detailsCurrent[iid] || this.current
      } else {
        return this.current
      }
    },
    getPaginationPageSize (item) {
      if (item.isCutDataConfig) {
        const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
        return this.detailsPageSize[iid] || this.pageSize
      } else {
        return this.pageSize
      }
    },
    getPaginationTotal (formdata = [], item) {
      if (item.isCutDataConfig) {
        const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
        if (iid) {
          const ar = formdata.filter(it => it.tip === iid)
          return ar.length
        }
      }
      return formdata.length
    },
    // 明细-切页
    setCutDetails ({ title, i }) {
      if (!i || !title) return false
      // this.$set(this.detailsCutObj, title, i)
      this.detailsCutObj.title = i
    },
    // 明细-切页end
    getTimeHHmm (val = '') {
      if (!val) return val
      const vv = val.split(':').slice(0, 2).join(':')
      return vv
    },
    getItt (formdata, item, value, key) {
      console.log('getItt')
      const type = item.title + '_' + item.type
      const e = formatDate(new Date(formdata[type]), "yyyy-MM-dd")
      const str = e + ' ' + value
      // this.$set(formdata, type, str)
      formdata.type = str
      switch (key) {
        case 1:
          this.approvalProcess(item)
          break
      }
    },
    getTimeLabel (val, sels, defaultValue) {
      if (!val && defaultValue) {
        for (const i of sels) {
          if (i.value === defaultValue) return i.label
        }
      }
      if (!val || !sels || sels.length === 0) return val
      const v = val.split(' ')[1]
      for (const i of sels) {
        if (i.value === v) return i.label
      }
      const vvv = v ? v : val
      return vvv
    },
    getTimeYM (val = '') {
      if (!val) return ''
      const date = new Date(val)
      const y = date.getFullYear()
      let m = date.getMonth() + 1
      if (m < 10) m = '0' + m
      return y + '-' + m
    },
    getTimeYMD (val = '') {
      if (!val) return ''
      return formatDate(new Date(val), "yyyy-MM-dd")
    },
    getFileList (arr) {
        const list = uploaderFun(arr)
        return list
    },
    setBackground (config) {
        if (!config.backColor) return {}
        return {
            backgroundColor: config.backColor + '18',
            borderColor: config.backColor,
            color: config.backColor
        }
    },
    // 单选-多级选项值
    getRadioProvinces (key, config) {
      if (!key || !config || !config.multilevelConfig || !config.multilevelConfig.levelConfig) return key
      return this.getShowVal(key, config.multilevelConfig)
    },
    getShowVal (val, config) {
      if (!config.levelConfig || config.levelConfig.length === 0 || !val) return val
      const s = val.split(',')
      const e = []
      let levelConfig = JSON.parse(JSON.stringify(config.levelConfig))
      if (config.dataType === 'provinces') {
          for (const i of s) {
              if (levelConfig[i]) {
                  e.push(levelConfig[i].label)
                  levelConfig = levelConfig[i].children
              } else {
                  e.push(i)
              }
          }
          return e.join(',')
      } else {
          for (const i of s) {
              const a = levelConfig.findIndex(it => it.value === i)
              if (a !== -1) {
                  e.push(levelConfig[a].label)
                  levelConfig = levelConfig[a].children
              } else {
                  e.push(i)
              }
          }
          return e.join(',')
      }
    },
    // 打包下载
    async fileDown (config) {
      const obc = {
        fieldName: config.name,
        field: config.title + '_' + config.type,
        fatherField: "",
        index: 0
      }
      if (config.fatherField) {
        obc.fatherField = config.fatherField
        obc.index = config.faIndex
      }
      const ob = {
        approvingId: this.approvingId,
        approvalId: this.approvalId,
        downloadfield: obc
      }

      const res = await filepackdownload(ob).catch(err => { console.log(err) })
      if (res && res.data) {
        console.log('回来的', res, res.data)
        const name = decodeURIComponent(res.headers['content-disposition']).split(';')[1].split('=')[1]
        // try {
          downArrZip(res.data, name)
        // } catch (e) {
        //   console.log('出错', e)
        //   // 出错就直接走打开新页面逻辑(后端提供的方式)
        //   const c = qs.stringify(ob)
        //   const token = JSON.parse(localStorage.getItem('user')).accesstoken;
        //   window.open(this.$apiurl + '/openapi/filepackdownload?hashkey=khosidfopsdfsdowsjdsfsdf&hashcode=' + jiami({ accesstoken: token, ...ob }) + '&accesstoken=' + token + '&' + c)
        // }
      }
    },
    getConterStyle (styleRatio, key) {
      if (styleRatio && key && styleRatio[key]) return { width: styleRatio[key] + '%' }
    },
    getRelBorder (title) {
      const ruleListChild = this.ruleListChild.filter((its, index) => this.onAssVisiblel(its,index) && this.getHide(its))
      const ind = ruleListChild.findIndex(its => its.title === title)
      if (ind !== -1 && ind === 0) return { borderTop: 'none' }
      return {}
    },
    getTitType (config) {
        if (config.list[2].styleShow && config.list[2].styleShow === 'fixed') {
            const ind = (config.list[2].optionals || []).findIndex(its => its.checked)
            return ind === -1
        }
        return false
    },
    getSwitchColor (opt = {}) {
      return getSwitchColor(opt)
    },
    // 预约控件新版
    widgetDateFocus (e) {
      console.log('获取焦点', this.widgetDate)
      this.widgetDate = e
    },
    widgetDateBlur () {
      console.log('失去焦点', this.widgetDate)
      this.widgetDate = ''
    },
    getWeekStartTime (n, weekConfig) {
      const day = new Date(n).getDay()
      if (weekConfig[day === 0 ? 7 : day]) {
        // console.log('当前时间为开始时间设定', n, weekConfig)
        return n
      } else {
        n = n + (24 * 3600 * 1000)
        return this.getWeekStartTime(JSON.parse(JSON.stringify(n)), weekConfig)
      }
    },
    getWeekEndTime (c, weekConfig) {
      const day = new Date(c).getDay()
      if (!weekConfig[day === 0 ? 7 : day]) {
        return c
      } else {
        c = c + (24 * 3600 * 1000)
        return this.getWeekEndTime(JSON.parse(JSON.stringify(c)), weekConfig)
      }
    },
    getWidgetList (time, config, pConfig) {
      const weekConfig = pConfig.weekConfig
      let date = time && time.length > 0 ? JSON.parse(JSON.stringify(time)) : []
      const o = 24 * 3600 * 1000
      const arew = weekConfig ? Object.keys(weekConfig) : []
      // 开始和结束时间，默认为当前和之后的7天
      if (!date || date.length === 0) {
        let n = new Date().getTime()
        let c = 0
        if (config.advance && Number(config.advanceNum) > 0) {
          if (config.advanceType && config.advanceType === 'hour') {
            const o1 = 3600 * 1000
            n += (Number(config.advanceNum) * o1)
          } else {
            n += (Number(config.advanceNum) * o)
          }
        }
        if (weekConfig) {
          // const arew = Object.keys(weekConfig)
          n = this.getWeekStartTime(JSON.parse(JSON.stringify(n)), weekConfig)
          
          if (arew.length < 8) {
            c = this.getWeekEndTime(JSON.parse(JSON.stringify(n + o)), weekConfig)
          } else {
            c = n + (o * 6)
          }
        } else {
          c = n + (o * 6)
        }
        date = [new Date(n), new Date(c)]
      }
      const arr = []
      // 计算差距天数
      let x = Math.ceil((new Date(date[date.length - 1]).getTime() - new Date(date[0]).getTime()) / o) + 1
      if (x < 7 && (!weekConfig || arew.length === 8)) {
        x =  7
        date[1] = new Date(date[0]).getTime() + o * 7
      } else if (date && date.length > 1 && weekConfig) {
        const ds = this.getWeekStartTime(JSON.parse(JSON.stringify(new Date(date[0]).getTime())), weekConfig)
        let dc = 0
        if (arew.length < 8) {
          dc = this.getWeekEndTime(JSON.parse(JSON.stringify(ds + o)), weekConfig)
          if (dc >= new Date(date[1]).getTime()) {
            date[1] = new Date(dc).getTime()
            x = (dc - new Date(date[0]).getTime()) / o
          }
        }
      }

      const cc = new Date(date[0]).getTime()
      for (let i = 0; i < x; i++) {
        const ee = cc + i * o
        const obj = {
          date: formatDate(new Date(ee), "yyyy-MM-dd"),
          week: '星期' + getWeek(ee)
        }
        arr.push(obj)
      }
      // if (pConfig.continuousMode) {
      //   const f = arr[0].date
      //   for (let index = 0; index < 3; index++) {
      //     const date = new Date(f).getTime() - ((index + 1) * o)
      //     const obj = {
      //       date: formatDate(date, "yyyy-MM-dd"),
      //       week: '星期' + getWeek(date)
      //     }
      //     arr.unshift(obj)
      //   }
      // }
        console.log('最后时间返回', arr, time, config, weekConfig)
      return arr
    },
    getCheckTime (key, arr, item) {
      if (!arr || arr.length === 0) return ''
      const keyDate = new Date(formatDate(new Date(key), "yyyy-MM-dd")).getTime()
      const ar1 = new Date(formatDate(new Date(arr[0]), "yyyy-MM-dd")).getTime()
      const ar2 = new Date(formatDate(new Date(arr[1]), "yyyy-MM-dd")).getTime()
      if (item.continuousMode) {
        return arr.find(f=>new Date(f).getTime() === keyDate) ? 'widget-active' : ''
      } else {
        return ar1 === keyDate || ar2 === keyDate || ar1 < keyDate && keyDate < ar2 ? 'widget-active' : ''
      }
    },
    // 外面进来模板触发的
    openGetWidgetVal () {
      console.log('触发数据1', this.widgetDisp)

      for (const i of this.ruleListChild) {
        if (i.type === 'ready-widget') {
          const ttt = i.list[1].title + '_' + i.list[1].type
          console.log('赋值')
          // this.$set(this.widgetDisp, i.title + '_' + i.type, JSON.parse(JSON.stringify(this.formdata[i.title + '_' + i.type][0][ttt])))
          this.widgetDisp[i.title + '_' + i.type] = JSON.parse(JSON.stringify(this.formdata[i.title + '_' + i.type][0][ttt]))
          console.log('赋值1')
          this.getWidgetTime(i, this.formdata[i.title + '_' + i.type][0])
        }
      }
      console.log('触发数据', this.widgetDisp)

    },
    getWidgetVal (val, {item, reaM}) {
      const itemType = item.title + '_' + item.type
      const type = reaM.title + '_' + reaM.type
      if (item.continuousMode) {
        let flag = true
        if (reaM.isLimit && this.isRolePermission(reaM.lookCustomArrRole)) {
          flag = false
        }
        const { continueModel, appointmentDays, daysInterval } = this.formdata[item.title + '_' + item.type][0]
        if (!continueModel) {
          ElMessage.warning('请选择循环周数或者循环天数')
          return
        }
        if (!(appointmentDays + '')) {
          ElMessage.warning('请输入预约天数')
          return
        }
        if (!(daysInterval + '')) {
          ElMessage.warning('请输入间隔天数')
          return
        }
        if (appointmentDays > reaM.lengthTime && flag) {
          ElMessage.warning(`选择时长不能超过${reaM.lengthTime}天`)
          return
        }
        const opt = {
          reservationDays: appointmentDays,
          gapDays: daysInterval,
          value: val,
          model: continueModel
        }
        this.contineuDate = val
        const dates = calculateSchedule(opt)
        this.formdata[itemType][0][type] = dates
        this.datasOnPickFun(item, reaM)
        // this.widgetDate = this.formdata[itemType][0][type] ? JSON.parse(JSON.stringify(this.formdata[itemType][0][type])) : ''
        return
      }
      this.widgetDate = this.formdata[itemType][0][type] ? JSON.parse(JSON.stringify(this.formdata[itemType][0][type])) : ''

      const v = JSON.parse(JSON.stringify(this.formdata[itemType][0][type]))
      if (v) this.widgetDate = v
      const itemOnType = item.list[0].title + '_' + item.list[0].type
      if (!this.formdata[itemType][0][itemOnType]) {
        this.$message.error(item.list[0].name + "不能为空");
        return false
      }
      console.log('数据', val, !v || v.length === 0)
      if (!v || v.length === 0) {
        const sss = formatDate(new Date(val), "yyyy-MM-dd")
        const ee = [sss, sss]
        // this.$set(this.formdata[itemType][0], type, ee)
        this.formdata[itemType][0][type] = ee
        console.log('存储', ee, this.formdata[itemType][0][type])
        this.datasOnPickFun(item, reaM)
        return false
      }
      let v1 = new Date(v[0]).getTime()
      let v2 = new Date(v[1]).getTime()
      const v3 = new Date(val).getTime()
      const o = 24 * 3600 * 1000
      console.log('数据222', val, v1, v2, v3, v)

      let ea = []
      if (v1 === v3 && v2 === v3) {
        // this.$set(this.formdata[itemType][0], type, '')
        this.formdata[itemType][0][type] = ''
        return false
      } else if (v1 === v3) {
        ea = [formatDate(new Date(v1 + o), "yyyy-MM-dd"), formatDate(new Date(v2), "yyyy-MM-dd")]
      } else if (v2 === v3) {
        ea = [formatDate(new Date(v1), "yyyy-MM-dd"), formatDate(new Date(v2 - o), "yyyy-MM-dd")]
      } else {
        console.log('不存在的位置', v3)
        if (v1 < v3 && v3 < v2) {
          return false
        } else if (v3 > v2) {
          ea = [formatDate(new Date(v1), "yyyy-MM-dd"), formatDate(new Date(v3), "yyyy-MM-dd")]
        } else if (v3 < v1) {
          ea = formatDate(new Date(v3), "yyyy-MM-dd"), formatDate(new Date(v2), "yyyy-MM-dd")
        }
      }
      // this.$set(this.formdata[itemType][0], type, ea)
      this.formdata[itemType][0][type] = ea
      console.log('给过去的值', ea, type)
      this.datasOnPickFun(item, reaM)
      this.widgetDate = ''
    },
    // 查询预约时间
    async getWidgetTime (config, value) {
      const cgType = config.list[0].title + '_' + config.list[0].type
      const timeType = config.list[1].title + '_' + config.list[1].type
      const obj = {
        approvalId: this.approvalId,
        title: config.title,
        cg: value[cgType],
        startdate: !config.list[2].timeType || config.list[2].timeType === 0 ? value[timeType][0] : formatDate(new Date(value[timeType][0]), "yyyy-MM-dd"),
        enddate: !config.list[2].timeType || config.list[2].timeType === 0 ? value[timeType][1] : formatDate(new Date(value[timeType][1]), "yyyy-MM-dd")
      }
      if (config.continuousMode && this.formdata[config.title + '_' + config.type][0].appointmentDays === 1) {
        obj.enddate = obj.startdate
      }
      const fun = !config.list[2].timeType || config.list[2].timeType === 0 ? openapiGetapprovalreserve : getapprovalordertimes
      const res = await fun(obj).catch(err => { console.log(err) })
      if (res.code === 0) {
        const titi = this.widgetDisp[config.title + '_' + config.type]
        // 返回过来的格式合并一次，因为格式错误有的带0有的没带
        console.log('修改时选中时间段处理', this.modify && titi, res.data, !(!config.list[2].timeType || config.list[2].timeType === 0), value)

          if (!(!config.list[2].timeType || config.list[2].timeType === 0)) {
            const resObj = {}
            for (const s in res.data) {
              const s1 = formatDate(new Date(s), "yyyy-MM-dd")
              if (resObj[s1]) {
                resObj[s1] = { ...resObj[s1], ...res.data[s] }
              } else {
                resObj[s1] = res.data[s]
              }
            }
            res.data = resObj
          }
          if (this.modify && titi) {
            if (!(!config.list[2].timeType || config.list[2].timeType === 0)) {
              const t1 = new Date(titi[0]).getTime()
              const t2 = new Date(titi[1]).getTime()
              for (const s in res.data) {
                const s1 = new Date(s).getTime()
                if (t1 <= s1 && s1 <= t2) {
                  // 便利配置里面的时间段
                  for (const se of config.list[2].optionals) {
                    const sestr = se.data + '(' + (se.TimeValue || []).join('-') + ')'
                    if (res.data[s][sestr] && Number(res.data[s][sestr]) === Number(se.TimeCount)) res.data[s][sestr] -= 1
                  }
                }
              }
            } else if (Array.isArray(res.data)) {
              // 已选中的不参与这边
              const t1 = new Date(titi[0] + ' 00:00:00').getTime()
              const t2 = new Date(titi[1] + ' 23:59:59').getTime()
              const type3 = config.list[2].title + '_' + config.list[2].type
              const bb = []
              for (const s of res.data) {
                const s1 = new Date(s.date).getTime()
                let isa = false
                if (t1 <= s1 && s1 <= t2) {
                  for (const sa of (value[type3] || [])) {
                    if (sa.date === s.date) {
                      if (s.time && s.time.length === 2 && s.time[0] === sa.time[0] && s.time[1] === sa.time[1]) {
                        isa = true
                        break
                      }
                    }
                  }
                }
                if (!isa) bb.push(s)
              }
              res.data = bb
            }
          }
          if (res.data && JSON.stringify(res.data) !== '{}'){
            const key = config.title + '_' + config.type;
            // this.$set(this.widgetTimeObj, key, res.data);
            this.widgetTimeObj[key] = res.data
            this.$nextTick(() => {
              this.widgetTimeObj[key] = res.data;
              this.timeKey++
            });
          }
        // this.widgetTimeObj[config.title + '_' + config.type] = res.data
      }
    },
    // 预约控件新版end
    // 播放音乐、视频
    async playFun (val, fileDocument) {
      const url = this.$url + val.response
      if (fileDocument === 'music') {
        this.$musicPlayer().paly(url)
      } else if(fileDocument === 'video') {
        this.$videoPlayer().paly(url)
      }
    },
    // 容器控件过滤匹配
    getConterList (arr) {
      return arr.map(its => {
        const ind = this.ruleListChild.findIndex(ite => ite.title === its)
        if (ind !== -1) return ind
      }).filter(it => it)
    },
    getBackk (config) {
      const style = widgetJs.getLabelBackk(config)
      if (config.width) {
        style.width = config.width + '%'
        style.flexBasis = config.width + '%'

      }
      return style
    },
    // 容器控件获取背景色+宽度
    getConBackk (config) {
      console.log("config==",config)
      return widgetJs.getLabelConBackk(config)
    },
    getLabelName (item) {
      return this.isNews ? '' : widgetJs.getFromLabel(item || {})
    },
    getFormItemClass (item) {
      const classList = [item.title]
      if (item.layout !== undefined && item.layout === 0) {
        classList.push('layout-l')
      }
      return classList
    },
    // 固定画布下获取标题文字样式
    getLabelStyle (item) {
      let style = {}
      if (item.labelConfig && item.labelConfig.fontKey) {
        const { fontColorValue, fontSetValue, fontSizeValue, fontisBold, fontisItalics, fontisUnderline } = item.labelConfig.fontKey
        style = {
          color: fontColorValue,
          fontFamily: fontSetValue,
          fontSize: fontSizeValue + 'px',
          fontWeight: fontisBold ? '700' : '400',
          fontStyle: fontisItalics ? 'italic' : 'normal',
          textDecoration: fontisUnderline ? 'underline' : 'none'
        }
      }
      return style
    },
    getLabelBack (item, index) {
      const obj = {}
      if (!item.status || item.status === 'label') {
        obj.backgroundColor = item.backColor || '#ffffff'
        if (index === 0) {
          obj.borderTopLeftRadius = '8px'
          obj.borderTopRightRadius = '8px'
          // obj.marginTop = '-20px'
        }
        if(item.type !== 'container'){
          obj.paddingTop = '18px'
          // obj.marginBottom = '20px'
        }
        if (item.type === 'container' && index === this.ruleListChild.length - 1) {
          obj.paddingBottom = '20px'
        }
      }
      return obj
    },
    getPerFormdata (val, config) {
      // 如果list 里面全部为空，那么他就是只显示自定义
      const type = config.title + '_' + config.type
      if (val[type] && (!config.list || config.list.length === 0)) return true
      if (!val[type] && val[type] !== 0 && config.list && config.list.length > 0) {
        let count = 0
        for (const i of config.list || []) {
          const types = i.title + '_' + i.type
          if (val[types] || val[types] === 0) count += 1
        }
        return count === 0
      }
      return false
    },
    // 单选显示值匹配
    getRadioLabel (val, item) {
      if (!item || item.length === 0) return val
      for (const i of item) {
        if (i.value === val) return i.label
        else if (Array.isArray(val) && val.length > 0 && i.value === val[0].name) return i.label
      }
      return val
    },
    async openRelUp (item) {
      const type = item.title + '_' + item.type
      // this.$set(this.relevancyShowObj, type, !this.relevancyShowObj[type])
      this.relevancyShowObj[type] = !this.relevancyShowObj[type]
      // 留给动画的触发
      await this.$nextTick()
        setTimeout (() => {
        // this.$set(this, 'relevancyTransform', !this.relevancyTransform)
        this.relevancyTransform = !this.relevancyTransform
      }, 10)
    },
    setAi (val, item) {
      // 固定画布的提交和修改有联动修改他表的功能 类似前端公式的等于
      if (this.isFiexdCanvas && item && item.type === 'richTextWid') {
        this.$emit('updateOtherAppData', item, this.formdata[item.title + '_' + item.type])
      }
      this.$emit('setAi', val)
    },
    getHide (item) {
      if (item.type === 'details' && this.isReadonlyDetails) {
        if (item.list && item.list.length > 0 && this.isAppenDetailsFeild && this.isAppenDetailsFeild.length > 0) {
          for (const ele of item.list) {
            if (this.isAppenDetailsFeild.includes(`${ele.title}_${ele.type}`)) {
              ele.viewHide = false
            } else {
              ele.viewHide = true
            }
          }
        }
        return !item.viewHide && Number(item.per) !== 3 && this.isReadonlyDetails === item.title
      } else {
        return !item.viewHide && Number(item.per) !== 3 && !this.isReadonlyDetails
      }
    },
    getUpcontroll (item) {
      return item.upcontroll && this.modifyId
    },
    getButtonStyle (val, item, key) {
      const color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
      let e = this.formdata[item.title + '_' + item.type]
      if (key && typeof e === 'string') {
        try {
          e = JSON.parse(e)
        } catch (s) {
          console.log("sss",s)
        }
      } 
      return {
        color: e && (!key && val === e || key && e.includes(val)) ? color : ''
      }
    },
    getButtonBlock (val, item, key) {
      const obj = {}
      let e = this.formdata[item.title + '_' + item.type]
      if (key && typeof e === 'string') {
        try {
          e = JSON.parse(e)
        } catch (s) {
          console.log("sss",s)
        }
      } 
      if (e && ((!key && val === e) || key && e.includes(val))) {
        const color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
        obj.borderColor = color
      }
      return obj
    },
    // 有key 代表是预约控件的
    getRadioStyle (val, item, key) {
      const obj = {}
      let color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#C0C4CC'
      const e = key ? this.formdata[key][0][item.title + '_' + item.type] : this.formdata[item.title + '_' + item.type]
      const isColor = item.type === 'checkbox' && e && e.includes(val) || item.type !== 'checkbox' && e && val === e
      if (isColor) {
        color = item.selsItemColor && item.selsItemColor[val] ? item.selsItemColor[val] : '#057EFF'
      }
      obj.backgroundColor = isColor ? color : ''
      obj.borderColor = color
      obj.color = isColor ? '#ffffff' : color
      return obj
    },
    setRadioWidget ({ val, item, widget}, config) {
      console.log('复制', val, item, widget, config)
      // this.$set(this.formdata[widget][0], item.title + '_' + item.type, val)
      this.formdata[widget][0][item.title + '_' + item.type] = val
      this.widgetOneLayerEmitFun(config)
    },
    setRadio ({ val, item }) {
      // this.$set(this.formdata, item.title + '_' + item.type, val)
      this.formdata[item.title + '_' + item.type] = val
      this.approvalProcess(item, val, this.formdata)
    },
    setCheck ({ val, item }) {
      let value = JSON.parse(JSON.stringify(this.formdata[item.title + '_' + item.type]))
      if (!value || !Array.isArray(value)) value = []
      const ind = value.findIndex(its => its === val)
      if (ind !== -1) {
        value.splice(ind, 1)
      } else {
        value.push(val)
      }
      // this.$set(this.formdata, item.title + '_' + item.type, value)
      this.formdata[item.title + '_' + item.type] = value
      this.$forceUpdate()
      this.approvalProcess(item)
    },
    numDecimal(e, num){
      let value = e.target.value
      let valueArr = value.split('.')
      if(num === null||!valueArr[1]||valueArr[1].length<=0) return false
      value = e.target.value.replace(/[^\d.-]/g, '') // 清除“数字”和“.”以外的字符
        .replace(/\.{2,}/g, '.') // 只保留第一个. 清除多余的
        .replace(/\.{2,}/g, '-') // 只保留第一个-清除多余的
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      if(value.split('.')[1].length>num){
        value = Number(value).toFixed(num)
      }
      e.target.value = value
         // 只能输入两个小数
    },
    isWYFN (item, isSet) {
      if (isWY(item) && isSet) {
        const decimal = 4 + (item.format.decimal || 0)
        const field = `${item.title}_${item.type}`
        // this.$set(this.tempFormdata, field, (this.formdata[field] / 10000).toFixed(decimal))
        this.tempFormdata[field] = (this.formdata[field] / 10000).toFixed(decimal)
      }
      return isWY(item)
    },
    setOriginalData (item) {
      const field = `${item.title}_${item.type}`
      if (this.tempFormdata[field] * 10000 !== this.formdata[field]) {
        // this.$set(this.formdata, field, this.tempFormdata[field] * 10000)
        this.formdata[field] = this.tempFormdata[field] * 10000
      }
    },
    setTempData (item) {
      const field = `${item.title}_${item.type}`
      if (this.tempFormdata[field] * 10000 !== this.formdata[field]) {
        console.log(this.formdata[field], '原始值改变了')
        // this.$set(this.formdata, field, this.tempFormdata[field] * 10000)
      }
    },
    // 千分符和保留小数点
    numberFormat (value, item) {
      const format = item.format
      const decimal = format.decimal //小数点
      let str = Number(value).toFixed(decimal)
      if (isWY(item)) {
        str = formatWY(value, decimal)
      }
      // 千分符
      if ((format.value === 'number' || format.value === 'currency') && format.separator) {
        let num = str.split('.')
        var reg = /\d{1,3}(?=(\d{3})+$)/g
        num[0] = (num[0] + '').replace(reg, '$&,')
        str = num.join('.')
      } else if (format.value === 'percentage') { // 百分比
        str = (value * 100).toFixed(decimal)
      }
      // 触发四则
      this.arithmetic(item)
      return isNaN(str) ? format.value==='number' || format.value==='currency'&&format.separator ? str : 0 : str
    },
    escapeRegex(string) {
      return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    },
    // 下来联动然后触发
    async commitReadcard ({index, commit}) {
      const item = this.ruleListChild[index]
      if (commit === 2) this.readcardLinked = true
      console.log('聚焦下来触发', item.type, item)
      if (item.type === 'text') {
        this.autoinputFun()
        await this.approvalProcess(item, '', this.formdata)
      } else {
        await this.approvalProcess(item)
      }
      // 延迟 10ms 看看是否触发了联动
      setTimeout(() => {
          if (this.readcardCount <= 0 && commit === 2) {
            this.readcardCountLink()
          }
      }, 10)
    },
    // 这个方法只给一级控件的 单多行、单多选 控件 使用
    async conditionLink (item) {
    console.log('开始进行联动', item)
      if (item.dataconfig && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0) {
        if (item.type === 'text') {
          this.conditionLinkObj = {
            type: false,
            dataconfig: item.dataconfig
          }
        } else {
          
          // 如果是 单多选，并且为填充联动的自定义和字典，则不走以下逻辑
          if ((item.type === 'radio' || item.type === 'checkbox') && item.dataconfig && item.dataconfig.setUpValue && (item.dataconfig.setUpValue === 1 && item.dataconfig.downType && (item.dataconfig.downType === 'customize' || item.dataconfig.downType === 'dictionary'))) return false
          let obj = {type: false, dataconfig: item.dataconfig}
          // 从空间进入，需要传空间id
          if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
            obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
          }
          const res = await getlinkeddatalist(obj).catch(err => { console.log(err) })
          if (res.code === 0) {
            // this.$set(item, 'sels', JSON.stringify(res.data) || '[]')
            item.sels = JSON.stringify(res.data) || '[]'
            if(item.type === 'textarea' && res.data.length > 0){
              this.textareaRelShow = true
            }
          }
        }
      }
    },
    deleteImg (item, i) {
      item.splice(i,1)
    },
    // 点击显示
    setOnShow (item, val) {
      const type = item.title + '_' + item.type;
      // this.$set(this.onShowObj, type, !val)
      this.onShowObj[type] = !val
    },
    // 时间过滤
    timeFilter(name){
      this.formdata[name] = this.formdata[name].split(' ')[0]
      return this.formdata[name]
    },
    // 时间格式转化
    timeWeek (time) {
      return getWeek(time)
    },
    // 分页 stat
    handleSizeChange(val, item) {
      if (item.isCutDataConfig) {
        const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
        // this.$set(this.detailsPageSize, iid, val)
        this.detailsPageSize[iid] = val
        // this.$set(this.detailsCurrent, iid, 1)
        this.detailsCurrent[iid] = 1
      } else {
        this.pageSize = val;
        this.current = 1;
      }
    },
    handleCurrentChange(val, item) {
      if (item.isCutDataConfig) {
        const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
        // this.$set(this.detailsCurrent, iid, val)
        this.detailsCurrent[iid] = val
      } else {
        this.current = val;
      }
    },
    // 分页 end
    // 不包含本日的时间返回可选的开始时间
    nextMonthFun(val) {
      return thisNoTime(val);
    },
    // 时间限制
    pickerOptionsLimit(val) {
      if (this.modifyId) return "";
      let date = val.dayWeek;
      if (
        !val.dayWeek &&
        (val.limit === "week" ||
          val.limit === "nextWeek" ||
          val.limit === "dayWeek")
      )
        date = 7;
      return limitDate(val.limit || "", date);
    },
    sliceEncrypt(str, encrypt) {
      return sliceEncrypt(str, encrypt);
    },
    // 删除值用的
    orgChoiceMethodFun(res) {
      this.approvalProcess(res);
    },
    // 联动的
    onLinkageNewRel(e) {
      console.log('关联单选调用联动', e)
      for (let i = 0; i < e.length; i++) {
        this.linkageMethEach(this.ruleListChild, copyObj(e[i]), 0);
      }
    },
    onAssVisiblel(item, key) {
      
      let isshow = true;
      if (
        this.associationVisible &&
        this.associationVisible.key !== -1 &&
        this.associationVisible.key < key
      ) {
        //当前配置之后的全部控件
        isshow = false; //全部隐藏
        for (let i in this.associationVisible.select) {
          try {
            isshow =
              isshow ||
              this.associationVisible.select[i][
                this.associationVisible.value[i]
              ][item.title + "_" + item.type];
          } catch (err) {
            isshow = false;
          }
        }
      }
      return isshow;
    },
    onDetailsAssVisiblel(item) {
      return item;
    },
    onFormat(percentage) {
      let self = this;
      if (percentage < 80) {
        self.percentageVisible = true;
        this.countTimeFun = setTimeout(function() {
          let count = percentage + 1;
          self.percentage = count;
          self.onFormat(count);
        }, 100);
      } else if (percentage < 99) {
        this.countTimeFun = setTimeout(function() {
          let count = percentage + 1;
          self.percentage = count;
          self.onFormat(count);
        }, 1000);
      } else if (percentage == 99) {
        clearTimeout(self.countTimeFun);
        self.countTimeFun = null;
        self.percentage = 99;
      } else {
        clearTimeout(self.countTimeFun);
        self.countTimeFun = null;
        self.percentage = 100;
        self.percentageVisible = false;
      }
    },
    // 确定批量删除
    yesDel(index, item, formdata) {
      // 因为最后一条需要重置，所以检测是否全删，是的话走一次之前的删除方法 delWidget
      this.$confirm("是否确定删除该数据？", {
        confirmButtonClass: "el-button--yeprimary",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log("yesDel==",index, item, formdata)
        let dom = this.$refs[item.title + "table"];
        if (dom) {
          // batchDel
          let delArr = dom[0].batchDel(item.title);
          if (delArr.length === 0) {
            this.$message({
              type: "error",
              message: "请选择需要删除的内容"
            });
            return false;
          }
          let formdata = this.formdata[item.title + "_" + item.type];
          for (let i = 0; i < delArr.length; i++) {
            formdata.splice(delArr[i], 1);
            // 如果 userHide 存在对应数据就删除
            if (
              this.userHide[item.title] &&
              this.userHide[item.title][delArr[i]]
            ) {
              this.userHide[item.title].splice(delArr[i], 1);
            }
          }
          if (formdata.length === 0) formdata.push(momVal(item.list, "no"));
          // 批量删除后流程更新
          dom[0].upToAllFormdata();
          this.detailSummation(undefined, {
            key: item.title + "_" + item.type
          }); // 明细求和
        }
      }).catch(() => {
        // 用户点击取消按钮，不做任何操作
        console.log("用户取消删除操作");
      });
    },
    // 打开表格窗口
    goJexcel(item, value = []) {
      // 获取值
      this.$nextTick(function() {
        // 要用流程判断一下格式数据  !ctoArrayChild ? item.list : item.list[0]
        let items = copyObj(item);
        let vals = JSON.parse(JSON.stringify(value))
        if (item.isCutDataConfig) {
          const iid = this.detailsCutObj[item.title] || item.cutDataConfig[0].i
          vals = vals.filter(it => it.tip === iid)
        }
        this.$refs.jexcelTable.openJexcel(items, vals);
      });
    },
    retJexcel(e) {
      console.log('批量返回', e)
      // 用title 去比对
      const dil = this.ruleListChild.findIndex(it => it.title === e.title)
      // 如果条数超过限制，删掉多余的
      let type = e.title + "_" + e.type;
      const detailsIt = dil !== -1 ? this.ruleListChild[dil] : ''
      let iid = ''
      /*
      if (e.detailsNum > 0 && e.date && e.date.length > Number(e.detailsNum)) {
        e.date = e.date.slice(0, e.detailsNum);
      }
    */
      // 两组数据再次进行比对
      let dates = copyObj(this.formdata[type]);
      if (detailsIt && detailsIt.isCutDataConfig) {
        iid = this.detailsCutObj[detailsIt.title] || detailsIt.cutDataConfig[0].i
        dates = dates.filter(it => it.tip === iid)
      }
      // 如果原有数据条数大于编辑条数，则裁剪原有数据条数为更新条数一致
      if (e.date.length < dates.length) {
        dates = dates.slice(0, e.date.length);
      }
      // 判断如果存在单选关联字段，则传空数组（双十bug）
      const hasNewRelRadio = e.list.some(item => item.type && item.type === 'new-rel-radio');
      if(hasNewRelRadio){
        dates = []
      }
      // 数据比对
      for (let i = 0; i < e.date.length; i++) {
        // 原数据存在的话，用元数据进行修改，不存在就直接赋值过去
        let dateE = e.date[i];
        // let dateE = copyObj(e.date[i]);

        //- 给对应数据增加参数 (这里要做一个 radio 选择值为其他的值匹配)
        for (let a = 0; a < e.list.length; a++) {
          if (e.list[a].per !== 2 && e.list[a].per !== 3) {
            const types = e.list[a].title + "_" + e.list[a].type;
            // 屏蔽掉当前类型为 图片和附件的
            if (
              dates[i] &&
              e.list[a].type !== "image" &&
              e.list[a].type !== "file"
            ) {
              dates[i][types] = dateE[types];
            }

            // 是否其他重置或者初始化值
            if (e.list[a].others && e.list[a].type === "radio") {
              // 查找 othersObj 里面是否存在 不存在的话给到值
              if (dateE[types] === "others其他") {
                if (!this.othersObj[type]) this.othersObj[type] = [];
                if (!this.othersObj[type][i]) this.othersObj[type][i] = {};
                if (!this.othersObj[type][i][types]) {
                  this.othersObj[type][i][types] = "";
                }
              } else {
                try {
                  delete this.othersObj[type][i][types];
                } catch (err) {
                  console.log("删除明细其他错误", err);
                }
              }
            }
          }
        }

        if (!dates[i]) {
          dates.push(dateE);
        }
      }
      if (dates.length === 0) {
        // 空数据提交
        // this.$set(this.formdata, type, [momVal(e.list)])
        this.formdata[type] = [momVal(e.list)];
      } else {
        if (detailsIt && detailsIt.isCutDataConfig) {
          dates = dates.map(it => {
            it.tip = iid
            return it
          })
          const detailsFormdata = this.formdata[type].filter(it => it.tip !== iid).concat(dates)
          // this.$set(this.formdata, type, detailsFormdata)
          this.formdata[type] = detailsFormdata
        } else {
          // this.$set(this.formdata, type, dates)
          this.formdata[type] = dates
        }

        // this.$set(this.formdata, type, dates)
        // this.formdata[type] = dates;
      }
      if (e.date.length !== 0) {
        let dom = this.$refs[e.title + "table"];
        if (dom) {
          dom[0].upToAllFormdata();
        }
      }
      //如果批量需要联动，就走下面那个方法
      this.linkedDetailedBatch(e, -1);
    },
    // 聚焦搜索
    autocompleteFun(val, bindinf) {
      this.inputChange = false;
      //如果单行输入框设置了联动，非关联单选
      this.autocompleteFunText = null;
      console.log("autocompleteFun==",val, bindinf)
      if (
        this.ruleListChildType != 3 &&
        val.dataconfig &&
        val.dataconfig.setUpValue != 2 &&
        val.dataconfig.linked &&
        val.dataconfig.linked.conditional.length > 0
      ) {
        this.autocompleteFunText = val;
      }
      if (val.sels && val.sels.length > 0) {
        this.restaurants = JSON.parse(val.sels).map(val => {
          return { value: val };
        });
      } else {
        this.restaurants = [];
      }
    },
    autoinputFun(val, item) {
      this.inputChange = true;
      if(item && item.type === 'text' && Number(item.disSearch) === 2){
        // 只允许数字、负号、小数点
        const valid = /^-?\d*(\.\d*)?$/.test(val);
        if (!valid && val !== ''){
          console.log("233123")
          const type = item.title + "_" + item.type;
          this.$message.error('输入错误，只能输入数字.-');
          // this.$set(this.formdata, type, null);
          this.formdata[type] = null
          return;
        }
      }
    },
    bulorList(item, val, formdata) {
      let type = item.title + "_" + item.type;
      formdata[type] = val;
      this.textareaRelShow = false
    },
    async upTextarea(item, event) {
      if (item.dataconfig && item.dataconfig.linked && item.dataconfig.linked.conditional.length === 0 && item.dataconfig.linked.resultdata.length > 0) {
        this.conditionLink(item)
        // const res = await getlinkeddatalist({type: false, dataconfig: item.dataconfig}).catch(err => { console.log(err) })
        // if (res.code === 0) {
        //   this.$set(item, 'sels', JSON.stringify(res.data) || '[]')
        // }
      } else {
        this.selschange(true, item);
      }
      try {
        let height = (event.path && event.path[0] || event.target).offsetHeight;
        // let str = "top:" + (height + 7) + "px;display:block;height:150px;";
        let str = "top:" + (height + 7) + "px;";
        // 如果不存在的话，定时器轮询三个查找
        if (!document.querySelector("." + item.title)) {
          this.domStyleTime("." + item.title, str, 0);
        } else {
          document.querySelector("." + item.title).style.cssText = str;
        }
      } catch (e) {
        console.log(e);
      }
    },
    handleSignet(command) {
      console.log("command==",command);
      let fileobj = this.commandStr(command);
      console.log("fileobj==",fileobj);      
      if (command.command === "a") {
        if (fileobj.signet) {
          //如果签过
          if (command.item.signetWay) {
            this.$message({
              message: '恭喜你，签章成功',
              type: 'success'
            });
            // 没有模板，先隐藏该弹层
            // this.$refs.signetTemplateRef.fromParentMethod({
            //   ...command,
            //   fileobj: fileobj
            // });
          } else {
            // 在线签章
            // func.onsigncontracturl(fileobj);
            // 固定签章
            if(command.item.signetWay == 2){
              this.handlebeginsignet(fileobj,command);
            }
            // 关键字签章（现在需求还没明确，先调用固定签章接口）
            else if(command.item.signetWay == 1){
              this.handlebeginsignet(fileobj,command);
            }
          }
        } else {
          this.loadingpro = true;
          // 固定签章
          if(command.item.signetWay == 2){
            this.handlebeginsignet(fileobj,command);
          }
          // 关键字签章（现在需求还没明确，先调用固定签章接口）
          else if(command.item.signetWay == 1){
            this.handlebeginsignet(fileobj,command);
          }
        }
      } else if (command.command === "b") {
        //作废
        this.$confirm("作废文件将无法继续签署，请谨慎操作!!!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success"
        }).then(() => {
          this.handleInvaliddoc(fileobj, command);
        });
      }
    },
    async handlebeginsignet(fileobj, command) {
      this.$refs.loadprogressRef.fromParent({
        isShow: true,
        text: "文件签署发起中，请稍候…"
      });
      var x = await func.setServerStampBox(fileobj, command);
      if (x) {
        // this.$set(fileobj, "signet", x);
        fileobj.signet = x
        let e = await this.onupdateapproving(command);
        this.$refs.loadprogressRef.fromParent({ isShow: false });
        if (e) {
          this.handleSignet(command);
        }
      } else {
        this.$refs.loadprogressRef.fromParent({ isShow: false });
      }
    },
    signetListSetMethod(command, value) {
      if (command.details) {
        // this.$set(this.formdata[command.details.title + "_" + command.details.type][command.details.index], command.item.title + "_" + command.item.type, value)
        this.formdata[command.details.title + "_" + command.details.type][command.details.index][command.item.title + "_" + command.item.type] = value
      } else {
        // this.$set(this.formdata, command.item.title + "_" + command.item.type, value)
        this.formdata[command.item.title + "_" + command.item.type] = value
      }
      this.onupdateapproving(command);
      //数据操作成功后，执行父级
    },
    //联系人控件批量查找
    showBatchSearch(item){
      // 判断是否配置联动，如有配置就只搜索联动出来的人
      if (
        item.dataconfig &&
        item.dataconfig.setUpValue == 3 &&
        item.dataconfig.linked &&
        item.dataconfig.linked.conditional
      ) {
        // 条件不需要是必须有
        //  &&
        //  item.dataconfig.linked.conditional.length > 0
        let param = linkedSetEvent(item.dataconfig, this.formdata, {
          index: item.indexs
        }, null, this.customData);
        if (param) {
          if (item.maxCount) param.maxCount = item.maxCount
          console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
          param.approvalId = this.approvalId
          console.log(this.modifyId,this.approvingId)
          if(this.approvingId){
            param.approvingId = this.approvingId
          }
          if(this.modifyId && this.modifyId !== ''){
            param.approvingId = this.modifyId
          }
          getlinkeddatalist(param).then(res => {
            this.$refs.batchSearchRef.fromParentMethod(item,'', '', res.data[0]);
          })
        }
      }
      else{
        this.$refs.batchSearchRef.fromParentMethod(item);
      }
    },
    // 明细-联系人控件批量查找
    showDetailBatchSearch(param){
      this.$refs.batchSearchRef.fromParentMethod(param.data,param);
    },
    handleBatchSearchChild(param){
      let checkedUserArr = []
      let obj = {}
      this.relationUserDataO = param.data            
      
      if(param.detailInfo && Object.keys(param.detailInfo).length){
        this.relationUserDataO.finx = param.detailInfo.finx
        this.relationUserDataO.indexs = param.detailInfo.indexs
        this.linkedDetailsKey = param.detailInfo
        let finxList = this.ruleListChild[this.relationUserDataO.finx];
        let finxType = finxList.title + "_" + finxList.type;
        let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
        checkedUserArr = this.formdata[finxType][this.relationUserDataO.indexs][types] || []
      }
      else{
        const datas = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
        checkedUserArr = this.formdata[datas] || []
      }
      const newUsers = param.user.filter(newUser => 
        !checkedUserArr.some(existingUser => 
          existingUser.userId === newUser.userId
        )
      );
      if(param.data.singleIsUser === 0){
        obj = {
          checkedUserArr: param.user
        }
      }
      else{
        obj = {
          checkedUserArr: [...checkedUserArr, ...newUsers]
        }
      }
      this.orgChoiceMethod(obj)
    },
    async handleSignetTemplateChild(signetconfig, id) {
      this.$refs.loadprogressRef.fromParent({
        isShow: true,
        text: "文件签署中，请稍候…"
      });
      let x = true;
      if (signetconfig.item.signetWay == 1) {
        // 关键字
        x = await func.signdocbykeyword(signetconfig, id);
      } else {
        // 固定模板
        x = await func.signdocbyposition(signetconfig, id);
      }
      this.$refs.loadprogressRef.fromParent({ isShow: false });
      if (!x) {
        return false;
      }
      this.$confirm("是否完成文件的所有步骤签署，并将文件归档?", "提示", {
        confirmButtonText: "归档",
        cancelButtonText: "不，还要继续签署",
        type: "success"
      }).then(() => {
        this.$confirm("文件归档后，将无法继续签署，是否继续归档!!!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "success"
        }).then(() => {
          this.handleArchivedoc(signetconfig);
        });
      });
    },
    // 归档
    async handleArchivedoc(param) {
      let x = await func.archivedoc(param);
      if (param.details) {
        // this.$set(this.formdata[param.details.title + "_" + param.details.type][param.details.index][param.item.title + "_" + param.item.type][param.key], 'signet', x)
        this.formdata[param.details.title + "_" + param.details.type][param.details.index][param.item.title + "_" + param.item.type][param.key].signet = x
      } else {
        // this.$set(this.formdata[param.item.title + "_" + param.item.type][param.key], 'signet', x)
        this.formdata[param.item.title + "_" + param.item.type][param.key].signet = x
      }
      this.onupdateapproving(param);
      this.postdochashconf(param);
    },
    // 作废
    async handleInvaliddoc(fileobj, command) {
      let x = await func.refusesigndoc(fileobj);
      // this.$set(fileobj, "signet", x);
      fileobj.signet = x
      this.onupdateapproving(command);
    },
    //提交存证
    postdochashconf(command) {
      if (command.item.signetconf) {
        return func.dochashconf(this.commandStr(command));
      }
    },
    //获取存证
    async getdochashconf(command) {
      if (command.item.signetconf) {
        // 开启归档
        let fileobj = this.commandStr(command);
        let docId = [];
        docId.push(fileobj.signet.docId);
        let x = await func.docinfos({ docId: docId, pageSize: 50, pageNum: 1 });
        if (x.data && x.data[0] && x.data[0].encSaveId) {
          // 如果有存证
          this.downdochashconf(x.data[0].encSaveId);
        } else {
          // 如果没有存证
          let e = await this.postdochashconf(command);
          this.downdochashconf(e.confId);
        }
      }
    },
    //下载确认函
    downdochashconf(confId) {
      window.open(
        "http://139.9.73.65:8888/api/v1/enc/downconfirmation/" + confId
      );
      //凭证下载
    },
    commandStr(command, key) {
      //key=true获取当前文件的所有内容，false为获取当前点击的附件
      if (key) {
        return command.details
          ? this.formdata[command.details.title + "_" + command.details.type][
              command.details.index
            ][command.item.title + "_" + command.item.type]
          : this.formdata[command.item.title + "_" + command.item.type];
      } else {
        return command.details
          ? this.formdata[command.details.title + "_" + command.details.type][
              command.details.index
            ][command.item.title + "_" + command.item.type][command.key]
          : this.formdata[command.item.title + "_" + command.item.type][
              command.key
            ];
      }
    },
    signetdetailFun(command, list, isEdit = false) {
      //明细的数据操作
      if (list === 1) {
        this.handleListSignet(command);
      } else if (list === 2) {
        this.getdochashconf(command);
      } else if (list === 3) {
        //下载
        this.handleFileDown(command, isEdit);
      } else if (list === 4) {
        //预览
        this.file_pvw(command);
      } else {
        this.handleSignet(command);
      }
    },
    onupdateapproving(command) {
      let formdata = this.commandStr(command, true);
      return func.updateapprovingca(command, formdata, this.approvingId, this.approvalId);
    },
    handleListSignet(command) {
      this.$refs.signeListRef.fromParentMethod(command, this.formdata);
    },
    handleFileDown(file, isEdit = false) {
      const isDown = isEdit ? false : true
      filePreview(file, isDown, isEdit);
    },
    domStyleTime(dom, val, count) {
      if (count > 3) return false;
      count += 1;
      let that = this;
      this.styleTime = setTimeout(function() {
        let doms = document.querySelector(dom);
        if (!doms) {
          that.domStyleTime(dom, val, count);
        } else {
          try {
            doms.style.cssText = val;
          } catch (err) {
            console.log(err);
          }
        }
      }, 100);
    },
    async querySearchAsync(queryString, cb) {
      // 如果开启了数据选项
      if (this.conditionLinkObj) {
        // 从空间进入，需要传空间id
        if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
          this.conditionLinkObj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        const res = await getlinkeddatalist(this.conditionLinkObj).catch(err => { console.log(err) })
        if (res.code === 0) {
          const val = (res.data || []).map(its => { return {value: its} })
          let results = queryString
              ? val.filter(this.createFilter(queryString))
              : val;
            cb(results);
          // cb(val)
        } else {
          cb([])
        }
        return;
      }
      if (this.autocompleteFunText) {
        let param = linkedSetEvent(
          this.autocompleteFunText.dataconfig,
          this.formdata,
          null,
          null,
          this.customData
        );
        if (param) {
          console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
          param.approvalId = this.approvalId
          console.log(this.modifyId,this.approvingId)
          if(this.approvingId){
            param.approvingId = this.approvingId
          }
          if(this.modifyId && this.modifyId !== ''){
            param.approvingId = this.modifyId
          }
          // 从空间进入，需要传空间id
          if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
            param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
          }
          getlinkeddatalist(param).then(res => {
            res.data = linkedFormatConversion({ type: "checkbox" }, res.data);
            let valdata = res.data.map(vals => {
              return {
                value: vals
              };
            });
            // cb(valdata);
            // 2022.7.28预约控件走前端公式联动，单行输入框会过滤数组里多余的值，改成不过滤 （2023.08.11 欧总确认单行需要过滤）
            let results = queryString
              ? valdata.filter(this.createFilter(queryString))
              : valdata;
            cb(results);
          });
        } else {
          cb([]);
        }
      } else {
        let restaurants = this.restaurants;
        let results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        cb(results);
      }
    },
    createFilter(queryString) {
      return restaurant => {
        return new RegExp(queryString.toLowerCase()).test(
          restaurant.value.toString().toLowerCase()
        );
      };
    },
    momNewRelRadioFun(e) {
      console.log('关联耕读', e)
      if (!this.ruleListChild[this.isIndex].list) {
        return false;
      }
      let ruleItem = { ...this.ruleListChild[this.isIndex] }; // 明细模板
      let item = ruleItem.list; // 明细里面的列表数据
      let itemType = this.ruleListChild[this.isIndex].title + "_" + this.ruleListChild[this.isIndex].type;
      const list = item;
      let listY = list[this.isListIndex.y || 0];
      // 获取空值，遍历模板获取结果进行比对赋值
      let obj = momVal(list, "no");
      console.log('空置模板', obj, e, list, listY)
      // 如果是系统的
      const isSys = listY && listY.selectTable === 'sys' ? 'field' : listY && listY.selectTable === 'customization' && listY.isSource && listY.isSource === 2 ? 'name' : ''
      // 值
      for (let i = 0; i < e.length; i++) {
        let len = Number(this.isListIndex.x) + Number(i);
        if (!this.formdata[itemType][len]) {
          this.formdata[itemType].push(copyObj(obj));
        }
        // 记录明细里面的关联多选id end
        this.formdata[itemType][len][listY.title + "_" + listY.type] = isSys ? e[i][listY.list[0][isSys]] : e[i].自定义标题;
        // this.formdata[itemType][len][listY.title + "_" + listY.type] = e[i].自定义标题;
        if (listY.list && listY.list.length > 0) {
          for (let s = 0; s < listY.list.length; s++) {
            let eType = listY.list[s].title + "_" + listY.list[s].type;
            if (listY.list[s].type === "checkbox") {
              let checkboxVal = [];
              try {
                checkboxVal = JSON.parse(isSys ? e[i][listY.list[s][isSys]] : e[i][listY.list[s].titleId]);
                // checkboxVal = JSON.parse(e[i][listY.list[s].titleId]);
              } catch (se) {
                checkboxVal = isSys ? e[i][listY.list[s][isSys]] : e[i][listY.list[s].titleId];
                // checkboxVal = e[i][listY.list[s].titleId];
              }
              if (typeof checkboxVal === "string") {
                try {
                  checkboxVal = (isSys ? e[i][listY.list[s][isSys]] : e[i][listY.list[s].titleId]).split(",");
                  // checkboxVal = e[i][listY.list[s].titleId].split(",");
                } catch (e) {
                  // console.log('转格式错误')
                }
              }
              // this.$set(this.formdata[itemType][len], eType, checkboxVal)
              this.formdata[itemType][len][eType] = checkboxVal
            } else {
              const eVal = isSys ? e[i][listY.list[s][isSys]] : e[i][listY.list[s].titleId]
              // this.$set(this.formdata[itemType][len], eType, eVal)
              this.formdata[itemType][len][eType] = eVal
              // this.$set(this.formdata[itemType][len], eType, e[i][listY.list[s].titleId])
            }
            this.linkageMethEach(
              this.ruleListChild[this.isIndex].list,
              listY.list[s],
              0,
              { key: itemType, index: len }
            );
          }
        }
        // 如果是记取，就存数据
        if (item[this.isListIndex.y].datahided === 2) {
          let dates = {
            title: ruleItem.title,
            linkedApprovingId: e[i].approvingId
          };
          // 不存在就添加
          if (!this.userHide[ruleItem.title]) {
            this.userHide[ruleItem.title] = [];
          }
          if (!this.userHide[ruleItem.title][len]) {
            this.userHide[ruleItem.title][len] = {};
          }
          this.userHide[ruleItem.title][len][
            item[this.isListIndex.y].title
          ] = dates;
        }        
      }
      this.isListIndex = null;
      this.isIndex = 0;
      this.detailsNum = null;
    },
    // 关联单提交后隐藏删除方法 如果是明细的话 index 参数存在 title 传 明细.关联当选
    deleteUserHide(title, index) {
      if (index || index === 0) {
        let titleType = title.split(".");
        try {
          this.userHide[titleType[0]][index][titleType[1]] = "";
        } catch (err) {
          console.log("关联单提交后隐藏字段删除错误");
        }
      } else {
        this.userHide[title] = "";
      }
    },
    //css检测momnewrelradio
    classFun(e, val, othersVal) {
      return retClassName(
        e,
        this.isOne,
        this.$store.state.isOnlyTitle,
        val,
        othersVal
      );
    },
    returnImage(data, index) {
      let param = {
        dataImg: data,
        indexImg: index
      };
      this.$emit("previewPictureImg", param);
    },
    retPreviewPictureImg(e) {
      this.$emit("previewPictureImg", e);
    },
    recordFun(e) {
      this.$emit("record", e);
    },
    onUp(e) {
      let el = { ...e };
      let date = {
        name: el.name,
        type: el.type
      };
      if (el.type !== "details") {
        date.record = JSON.parse(JSON.stringify(el.record.reverse()));
      } else {
        date.details = this.analysis(
          JSON.parse(JSON.stringify(el.record)),
          el.list[0]
        ).reverse();
        if (date.details[0].length === 0) {
          date.details = JSON.parse(JSON.stringify(el.record.reverse()));
        }
      }
      this.$emit("record", date);
    },
    analysis(e, date) {
      // e 要解析的数组 date 对应的模板数据
      for (let i in e) {
        if (e[i].data && e[i].data.length > 0) {
          e[i].data = this.analysis(e[i].data, date);
        } else {
          let arr = [];
          for (let a in e[i]) {
            let jg = this.analysisList(a, date);
            let type = a.split("_");
            let ars = {
              name: jg,
              type: type[1]
            };
            try {
              ars.value = JSON.parse(e[i][a]);
            } catch (error) {
              ars.value = e[i][a];
            }
            arr.push(ars);
          }
          e[i] = arr;
        }
      }
      return e;
    },
    analysisList(e, date) {
      let name = null;
      for (let i in date) {
        let type = date[i].title + "_" + date[i].type;
        if (type === e) {
          return date[i].name;
        }
        if (date[i].list) {
          let names = this.analysisList(e, date[i].list);
          if (names) {
            return names;
          }
        }
      }
      return name;
    },
    //预约控件时间回调
    retTimeChildFun(res) {
      if (this.thisMMDate && this.thisMMDate.list && this.thisMMDate.list[2]) {
        let type = this.thisMMDate.title + "_" + this.thisMMDate.type;
        let thisType = this.thisMMDate.list[2].title + "_" + this.thisMMDate.list[2].type;
        if(res[1].length === 0){
          this.formdata[type][0][thisType] = res[0].map(val => {
            return {
              date: val.date,
              time: val.time,
            };
          });
        }else{
          this.formdata[type][0][thisType] = res[0].map(val => {
            return {
              date: val.date,
              time: val.time,
              optionsvalue: val.optionsvalue
            };
          });
        }
      }
    },
    // 获取自定义的时间段
    // customTime(val,min,max){
    //   if (val === undefined) {
    //     val = []
    //   }
    //   let tempArr = []
    //   let arr = []
    //   val.forEach(x => {
    //     if(x.checked) tempArr.push(x)
    //   })
    //   for(let i = 0; i < tempArr.length; i++){
    //     if( min<=i && i<=max){
    //       arr.push(tempArr[i])
    //     }
    //   }
    //   return arr
    // },
    //预约控件获取时间
    // timeDataFun(res) {
    //   console.log(res,'111111111111');
    //   this.$refs.selectionPeriodRef.customTime = []
    //   if (res.list[2].optionals) {
    //     if (this.$refs.selectionPeriodRef.customTime.length === 0) {
    //       res.list[2].optionals.forEach(x=>{
    //       if(x.checked){
    //           this.$refs.selectionPeriodRef.customTime.push(x)
    //         }
    //       })
    //     }
    //   }
    //   this.thisMMDate = res;
    //   let value = this.formdata[res.title + "_" + res.type][0][
    //     res.list[1].title + "_" + res.list[1].type
    //   ];
    //   let thisVal = this.formdata[res.title + "_" + res.type][0][
    //     res.list[2].title + "_" + res.list[2].type
    //   ];
    //   // 开始结束时间不能为空
    //   if (!value) {
    //     this.$message({
    //       type: "error",
    //       message: "开始结束时间不能为空"
    //     });
    //     return false;
    //   }
    //   const mmDate = res.list[1];
    //   //设置时间差。总的有几天
    //   let minDate = JSON.parse(JSON.stringify(value[0]));
    //   let maxDate = JSON.parse(JSON.stringify(value[1]));
    //   minDate = Date.parse(minDate);
    //   maxDate = Date.parse(maxDate);
    //   const ALB = maxDate - minDate;
    //   this.timeDistance = ALB / 86400000;
    //   if (value && value.length > 0) {
    //     let strType = this.formdata[res.title + "_" + res.type][0][
    //       res.list[0].title + "_" + res.list[0].type
    //     ];
    //     const paramDate = {
    //       approvalId: this.$route.query.approvalId
    //         ? this.$route.query.approvalId
    //         : this.approvalId,
    //       title: res.title,
    //       cg: strType,
    //       // cg:res.list[0].bindinf,
    //       startdate: value[0],
    //       enddate: value[1]
    //     };
    //     openapiGetapprovalreserve(paramDate)
    //       .then(resData => {
    //         if (resData.code == 0) {
    //           mmDate.disable = resData.data; //已经预约的数据3333333333333
    //           this.timeDataFunChil(res, value, thisVal);
    //         } else {
    //           this.$message.error("预约控件错误！");
    //         }
    //       })
    //       .catch(error => {
    //         console.log(error);
    //       });
    //   } else {
    //     this.$message.error(res.list[1].name + "不能为空");
    //   }
    // },
    // 数组分类
    groupBy(objectArray,property){
      return objectArray.reduce(function (acc, obj) {
        let key = obj[property]
        if (!acc[key]) {
          acc[key] = []
      }
        acc[key].push(obj)
        return acc
      },{})
    },
    //预约控件获取时间.构造
    timeDataFunChil(res, value, thisVal) {
      const mmDate = res.list[1];
      let customTimeVal
      if (thisVal) {
        customTimeVal = this.groupBy(thisVal,'date')
      }
      let param = [];
      let minDate = value[0];
      minDate = Date.parse(minDate);
      const dateLen = JSON.parse(JSON.stringify(this.timeDistance)) + 1;
      // 如果后台有设置可选时间段的话，需要把不可选的找出来灰掉
      let disableList = []
      const optional = res.list[2]
      if (optional.optional && optional.optional.length > 0) {
        const optionalOne = optional.optional[0] || 0
        const optionalTwo = optional.optional[1] || 0
        if (optionalOne) {
          disableList = Array.from(new Array(optionalOne).keys()).slice(0)
        }
        if (optionalTwo && optionalTwo < 48) {
          disableList = disableList.concat(Array.from(new Array(49).keys()).slice(optionalTwo + 1))
        }
      }

      for (let i = 0; i < dateLen; i++) {
        const dateS = formatDate(
          new Date(minDate + i * 86400000),
          "yyyy-MM-dd"
        )
        const timeObj = {
          date: dateS,
          time: [],
          disable: disableList,
          status: false
        }
        // 因为自定义时间段的处理方式不同所以预约的时间也分开处理
        let tempctime = []
        let ctime = []
        if(thisVal){
          customTimeVal[dateS].forEach(x=>{
            tempctime = [...tempctime, ...x.time]
          })
          ctime =Array.from(new Set(tempctime))
        }

        //预约控件设置旋转
        if ((thisVal && thisVal !== "") || (thisVal && thisVal.length > 0)) {
          if(this.$refs.selectionPeriodRef.customTime.length > 0 && thisVal){
            timeObj.time = JSON.parse(JSON.stringify(ctime));
          }else{
            timeObj.time = JSON.parse(JSON.stringify(thisVal[i].time));
          }
        }
        //满足以下为选过的时间区间
        if (mmDate.disable && mmDate.disable.length > 0) {
          //区间补足
          let _timeOrFun = function(paramArr) {
            let arr = [];
            let maxD = paramArr[1];
            let minD = paramArr[0];
            if (maxD < minD) {
              maxD = paramArr[0];
              minD = paramArr[1];
            }
            for (let t = minD; t < maxD + 1; t++) {
              arr.push(t);
            }
            return arr;
          };
          let disableOld = JSON.parse(JSON.stringify(mmDate.disable));
          let disableNewObj = {};
          disableOld.forEach(el => {
            //如果已经有就合并
            if (disableNewObj[el.date]) {
              disableNewObj[el.date] = disableNewObj[el.date].concat(
                _timeOrFun(el.time)
              );
            } else {
              disableNewObj[el.date] = _timeOrFun(el.time);
            }
          });
          timeObj.disable = timeObj.disable.concat(disableNewObj[timeObj.date])
        }
        param.push(timeObj);
      }
      let custom =  JSON.parse(JSON.stringify(thisVal))
      if(custom){
        custom.forEach(x=>{
          x.state = false
        })
      }
      this.$refs.selectionPeriodRef.selectionPeriodFun(param, custom)
    },
    //预约控件日期控件选择完成回调
    datasOnPickFun(data, res) {
      console.log('查时间', data, res)
      //data预约控件数据.res时间控件数据
      let dataType = data.title + "_" + data.type; // 外层
      let thisType = res.title + "_" + res.type; // 当前，时间控件
      let listType = data.list[2].title + "_" + data.list[2].type; // 预约时间段
      let selectType = data.list[0].title + "_" + data.list[0].type; // 选择
      //场馆必须判断
      if (this.formdata[dataType] && this.formdata[dataType][0] && this.formdata[dataType][0][thisType] && this.formdata[dataType][0][thisType] !== "" && !data.continuousMode) {
        if (!this.formdata[dataType][0][selectType]) {
          this.$message.error(data.list[0].name + "不能为空");
          this.formdata[dataType][0][thisType] = "";
        } else {
          let resValue = JSON.parse(JSON.stringify(this.formdata[dataType][0][thisType]));
          let minDate = JSON.parse(JSON.stringify(resValue[0]));
          let maxDate = JSON.parse(JSON.stringify(resValue[1]));
          minDate = Date.parse(minDate);
          maxDate = Date.parse(maxDate);
          const ALB = maxDate - minDate;
          this.timeDistance = ALB / 86400000;
          console.log('时长判断', res.lengthTime)
          // 中间不能有不可预约的时间
          if (data.weekConfig) {
            const arew = Object.keys(data.weekConfig)
            if (arew.length < 8) {
            console.log('中间有不可逾越的时间')
               const dd = this.getWeekEndTime(JSON.parse(JSON.stringify(minDate)), data.weekConfig)
               if (dd < maxDate) {
                 this.$message.error('请选择连续时间!')
                 // this.$set(this.formdata[dataType][0], thisType, this.widgetDate || "")
                 this.formdata[dataType][0][thisType] = this.widgetDate || ""
                this.widgetDate = ''
                return false
               }
            }
          }
          //最长时间
          if (res.lengthTime) {
            if (this.timeDistance > res.lengthTime - 1) {
              this.$message.error("选择时长不能超过" + res.lengthTime + "天");
              // this.$set(this.formdata[dataType][0], thisType, this.widgetDate || "")
              this.widgetDate = ''
              this.formdata[dataType][0][thisType] = this.widgetDate || "";
              return false;
            }
          }
        }
      }
      // this.formdata[data.title + "_" + data.type][0][listType] = [];
      // 构建一个已预约的空集合
      const iii = (data.list[2].optionals || []).findIndex(its => its.checked)

      if (data.list[2].timeType && data.list[2].timeType === 1 && iii !== -1) {
        // 自定义 空的直接过滤原来数据
        const ars = []
        const v1 = new Date(this.formdata[data.title + "_" + data.type][0][thisType][0]).getTime()
        const v2 = new Date(this.formdata[data.title + "_" + data.type][0][thisType][1]).getTime()

        for (const a of (this.formdata[data.title + "_" + data.type][0][listType] || [])) {
          const v = new Date(a.date).getTime()
          if (v1 <= v && v <= v2) ars.push(a)
        }
        console.log('对比后的赋值1', ars, listType)
        this.formdata[data.title + "_" + data.type][0][listType] = ars
      } else {
        // 自定义 空的直接过滤原来数据
        const ars = []
        const v1 = new Date(this.formdata[data.title + "_" + data.type][0][thisType][0]).getTime()
        const v2 = new Date(this.formdata[data.title + "_" + data.type][0][thisType][1]).getTime()

        for (const a of (this.formdata[data.title + "_" + data.type][0][listType] || [])) {
          const v = new Date(a.date).getTime()
          if (v1 <= v && v <= v2) ars.push(a)
        }
        console.log('对比后的赋值1', ars, listType)
        this.formdata[data.title + "_" + data.type][0][listType] = ars

        // 需要时间比对的，生成一个四件去比对
        // const ars = this.getWidget(this.formdata[data.title + "_" + data.type][0][data.list[1].title + '_' + data.list[1].type])
        // for (let a = 0; a < ars.length; a++) {
        //   const ate = ars[a]
        //   const v = (this.formdata[data.title + "_" + data.type][0][listType] || []).findIndex(its => its.date === ate.date)
        //   if (v !== -1) ars[a] = this.formdata[data.title + "_" + data.type][0][listType][v]
        // }
        // console.log('对比后的赋值', ars, listType)
        // this.formdata[data.title + "_" + data.type][0][listType] = ars
      }

      // this.formdata[data.title + "_" + data.type][0][listType] = data.list[2].timeType && data.list[2].timeType === 1 && iii !== -1 ? [] : this.getWidget(this.formdata[data.title + "_" + data.type][0][data.list[1].title + '_' + data.list[1].type])
      console.log('走')
      // 查询预约时间段的已预约数据
      this.getWidgetTime(data, this.formdata[data.title + "_" + data.type][0])
    },
    getWidget (val) {
      console.log('空值数据', val)
      const arr = []
      const v1 = new Date(JSON.parse(JSON.stringify(val[0]))).getTime()
      const v2 = new Date(JSON.parse(JSON.stringify(val[1]))).getTime()
      const c = ((v2 - v1) / 86400000) + 1
      for (let i = 0; i < c; i++) {
        const obj = {
          date: formatDate(new Date(86400000 * i + v1), "yyyy-MM-dd"),
          time: []
        }
        arr.push(obj)
      }
      return arr
    },
    //预约控件分条件.和选择事件
    widgetOneLayerEmitFun(data) {
      let type = data.title + "_" + data.type;
      let twoType = data.list[1].title + "_" + data.list[1].type;
      let sueType = data.list[2].title + "_" + data.list[2].type;
      if (data.continuousMode) {
        if (this.formdata[type][0].continueModel === undefined) {
          this.formdata[type][0].continueModel = 'week'
        }
        if (this.formdata[type][0].appointmentDays === undefined) {
          this.formdata[type][0].appointmentDays = 1
        }
        if (this.formdata[type][0].daysInterval === undefined) {
          this.formdata[type][0].daysInterval = 0
        }
      }
      if (this.formdata[type][0][twoType]) {
        // this.$set(this.formdata[type][0], twoType, [])
        this.formdata[type][0][twoType] = [];
      }
      if (this.formdata[type][0][sueType]) {
        // this.$set(this.formdata[type][0], sueType, [])
        this.$forceUpdate()
        this.formdata[type][0][sueType] = [];
      }
      this.approvalProcess(data);
    },
    detailsFilsFun(data) {
      let dataArr = [];
      data.forEach((el, index) => {
        let dataObj = {
          index: index,
          list: el
        };
        dataArr.push(dataObj);
      });
      this.detailsAllWidgetData = dataArr;
      return dataArr;
    },

    //明细关联
    detailsWidgetRelUersFunc(param) {
      //typeOr==2关联多选
      //type===1联系人控件弹窗组织架构，2联系人控件操作删除，3关联控件（单选）弹窗选择关联数据，4图片附件上传状态如上传完成与否
      if (param.type == "1") {
        // 当前这条的位置
        if (param.indexs > -1) {
          this.linkedDetailsKey = param;
        } else {
          this.linkedDetailsKey = null;
        }
        // 下标放到 data 备用
        param.data.indexs = param.indexs;
        param.data.finx = param.finx;   
        // 获取明细控件title，联动选择数据显示时用到
        let match = param.finxType.match(/(^.*?)_/)
        if (match) {
          this.detailTitle = match[1]
        }    
        console.log('param====',param,param.finxType)
        this.relationUserChoice(
          param.data,
          3,
          this.formdata[param.finxType][param.indexs][param.data.title + '_' + param.data.type],
          param.indexs > -1 ? true : false,
          param.fromBtn === 'orgBtn' ? 'orgBtn' : param.fromBtn === 'defaultSearch' ? 'defaultSearch' : '',
          param.searchKey ? param.searchKey : ''
        );
      } else if (param.type == "2") {
        if (param.indexs > -1) {
          this.linkedDetailsKey = param;
        } else {
          this.linkedDetailsKey = null;
        }
        // 下标放到 data 备用
        param.data.finx = param.finx;
        param.data.indexs = param.indexs;
        this.handleCloseFlow(
          param.data,
          param.index,
          3,
          this.linkedDetailsKey ? this.linkedDetailsKey : null
        );
      } else if (param.type == "3") {
        //因为是明细关联多选，所以加一个字段表示
        param.data.isDetail = true;
        if (param.typeOr && param.typeOr == 2) {
          let finxType =
            this.ruleListChild[param.finx].title +
            "_" +
            this.ruleListChild[param.finx].type;
          this.associatedControls(
            param.data,
            2,
            this.formdata[finxType][param.indexs]
          );
        } else {
          if (param.index) this.isIndex = param.index;
          if (param.listIndex) this.isListIndex = param.listIndex;
          if (param.detailsNum)
            this.detailsNum =
              Number(param.detailsNum) - Number(param.listIndex.x); // 换一下
          // let finxType =
          //   this.ruleListChild[param.index].title +
          //   "_" +
          //   this.ruleListChild[param.index].type;
          // 给data 参数添加两个值 findex 父级下标 thisIndex 当前行下标
          let datas = JSON.parse(JSON.stringify(param.data));
          datas.findex = param.index;
          datas.thisIndex = param.listIndex.x;
          // 配置联动后，联动的数据并非明细组件内的，this.formdata[finxType]会导致只获取到明细内的数据，先这么改，后面有问题再根据实际情况排查 hj 25.10.17
          // this.associatedControls(datas, 1, this.formdata[finxType]);
          this.associatedControls(datas, 1, this.formdata);
        }
      } else if (param.type == 4) {
        this.$emit("widgetOneLayerEmit", param);
      } else if (param.type == 5) {
        //明细关联单选联动获取配置条件
        param.param = this.onCondition(param.param);
      }
    },
    addWidget(data, index) {
      //最大新增条数判断
      let type = data.title + "_" + data.type;
      let len = this.formdata[type].length
      let detailsValue = []
      const iid = data.isCutDataConfig ? (this.detailsCutObj[data.title] || data.cutDataConfig[0].i) : ''
      console.log('index==', index)
      if (data.isCutDataConfig) {
        detailsValue = this.formdata[type].filter(it => it.tip === iid)
        len = detailsValue.length
      }
      if (this.formdata[type] && data.detailsNum && data.detailsNum <= len) {
        this.$message({
          message: data.name + "最多只能有" + data.detailsNum + "条数据哦！",
          type: "warning"
        });
        return false;
      }
      // 判断是否开启OCR
      if(data.ocrinfo && data.ocrinfo.switch){
        // 初始状态下，只有一条数据，并且数据为空
        const obOneVal = data.isCutDataConfig ? detailsValue[0] : this.formdata[type][0]
        if(len == 1 && Object.values(obOneVal).every(value => value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0))){
        // if(len == 1 && Object.values(this.formdata[type][0]).every(value => value === '' || value === null || value === undefined || (Array.isArray(value) && value.length === 0))){
          this.$emit("detailGoOcr",{ocrInfo: data.ocrinfo, type: type, idx: len-1})
        } else{
          // 用模板换结构
          let list = momVal(data.list);
          if (data.isCutDataConfig) list.tip = iid
          //明细新增
          this.formdata[data.title + "_" + data.type].push(list);
          this.linkedDetailedBatch(
            data,
            -1,
            this.formdata[data.title + "_" + data.type].length - 1
          );
          this.$emit("detailGoOcr",{ocrInfo: data.ocrinfo, type: type, idx: len})
        }
        return false
      }
      else{
        // 用模板换结构
        let list = momVal(data.list);
        if (data.isCutDataConfig) list.tip = iid
        //明细新增
        this.formdata[data.title + "_" + data.type].push(list);
        this.linkedDetailedBatch(
          data,
          -1,
          this.formdata[data.title + "_" + data.type].length - 1
        );
      }
    },
    scanOcr(val){
      console.log("va;==",val);
      const data = val.detailsInfo
      let type = data.title + "_" + data.type;
      this.$emit("detailGoOcr",{ocrInfo: data.ocrinfo, type: type, idx: val.idx})
    },
    //- 明细控件内部删除当前控件操作
    delWidget(res, index, formdata) {
      formdata.splice(index, 1);
      if (formdata.length === 0) {
        formdata.push(momVal(res.list, "no"));
      }
    },
    inputBlur(item) {
      if (item.title) {
        this.restaurantsFun = setTimeout(function() {
          try {
            document.querySelector("." + item.title).style = "";            
          } catch (e) {
            console.log(e);
          }
        }, 150);
      }
      if(item.type === 'textarea'){
        setTimeout(() => {
          this.textareaRelShow = false
        }, 150);
      }
    },
    /**
     * 联动一共需要初始化联动，大明细联动，小明细联动和明细批量联动这些联动方式
     *
     */
    async linkageInitiali(key) {
      console.log('ddddddddddas')
      for (let [i, ele] of this.ruleListChild.entries()) {
        // 明细单独新增一个多联动项(明细打开了切页联动则原先默认的失效)(此时，自定义、默认值，两个选项可以直接不走联动)
        if (ele.type === 'details' && ele.isCutDataConfig && i > key && !ele.memoryData) {
          console.log('切页联动走', ele, i)
          for (const a of ele.cutDataConfig || []) {
            console.log('切页联动判断走', a.dataconfig.setUpValue === 1 && a.dataconfig.linked && a.dataconfig.linked.conditional, a.dataconfig.setUpValue < 1)
            if (a.dataconfig.setUpValue === 1 && a.dataconfig.linked && a.dataconfig.linked.conditional) {
              let param = linkedSetEvent(a.dataconfig, this.formdata, { types: "details" }, null, this.customData);
              if (param) {
                let x = await this.awaitGetlinkeddatalist(param);
                this.detailsLinkeddataResult(ele, x, a);
              }
            } else if (a.dataconfig.setUpValue < 1) {
              console.log('a.dataconfig.setUpValue < 1----------')
              // this.linkedDetailedBatch(ele, -1, 0);
              // this.linkedDetailedBatch(ele, -1, 0);
            }
          }
        } else if (ele.dataconfig && ele.type !== "new-rel-radio" && i > key && !ele.memoryData) {
          //memoryData 记取，不是记取的
          // 配置了公式
          if (ele.dataconfig.setUpValue === 4 && ele.dataconfig.formula) {
            let itemKey = ele.dataconfig.formula.type
              ? ele.dataconfig.formula.airTime
              : ele.dataconfig.formula.controls;
            this.onFormulaResult(this.formdata, { key: itemKey }, ele);
          }
          if (ele.dataconfig.setUpValue === 1 && ele.dataconfig.linked && ele.dataconfig.linked.conditional) {
            //如果是大明细联动需要新增一个types=details为区分
            let param = linkedSetEvent(ele.dataconfig, this.formdata, {
              types: ele.type == "details" ? "details" : false
            }, null, this.customData);
            if (param) {
              let x = await this.awaitGetlinkeddatalist(param);
              // 如果是数字，并且联动回来的值为空则不重置2024-7-8
              if (ele.type === 'number' && (!x && x !== 0 || x.length === 0)) {
                x = [ele.bindinf]
              }
              this.linkeddataResult(ele, x);
            }
          } else if (ele.type === "details" && ele.dataconfig.setUpValue < 1) {
            this.linkedDetailedBatch(ele, -1, 0);
          }
        } else if (ele.dataconfig && ele.type === "new-rel-radio" && i > key && !ele.memoryData) {
          if (ele.dataconfig.setUpValue == 7) await this.getNewRelRadioSet(ele, this.formdata, { detailsType: false, newIndex: '', scopeIndex: '' })
          if (ele.list && ele.list.length > 0) {
            for (const elei of ele.list || []) {
              if (elei.dataconfig && !elei.memoryData) {
                // 配置了公式
                if (elei.dataconfig.setUpValue === 4 && elei.dataconfig.formula) {
                  let itemKey = elei.dataconfig.formula.type
                    ? elei.dataconfig.formula.airTime
                    : elei.dataconfig.formula.controls;
                  this.onFormulaResult(this.formdata, { key: itemKey }, elei);
                }
                if (elei.dataconfig.setUpValue === 1 && elei.dataconfig.linked && elei.dataconfig.linked.conditional) {
                  //如果是大明细联动需要新增一个types=details为区分
                  let param = linkedSetEvent(elei.dataconfig, this.formdata, {
                    types: elei.type == "details" ? "details" : false
                  }, null, this.customData);
                  if (param) {
                    let x = await this.awaitGetlinkeddatalist(param);
                    // 如果是数字，并且联动回来的值为空则不重置2024-7-8
                    if (elei.type === 'number' && (!x && x !== 0 || x.length === 0)) {
                      x = [elei.bindinf]
                    }
                    this.linkeddataResult(elei, x);
                  }
                }
              }
            }
          }
        }
      }
    },
    async getNewRelRadioSet (relConfig, formdata, {detailsType = false, newIndex, scopeIndex}) {
      console.log('开始getNewRelRadioSet', relConfig)
      let relRadio = JSON.parse(JSON.stringify(relConfig));
      if (detailsType) {
        relRadio.findex = newIndex;
        relRadio.thisIndex = scopeIndex;
      }
      const res = await getNewRelRadioRes(relRadio, this.approvalId, formdata, this.AuditList)
      console.log('联动返回的具体值', res)
      if (res) {
        if (!detailsType) {
          for (const i in res) {
            if (i.includes('checkbox')) {
              const te = Array.isArray(res[i]) ? res[i] : res[i] ? [res[i]] : []
              // this.$set(this.formdata, i, te)
              this.formdata[i] = te
            } else {
              // this.$set(this.formdata, i, res[i])
              this.formdata[i] = res[i]
            }
          }
        } else {
          console.log('明细里面的关联')
        }
      }
    },
    // 做返回结构
    tObj (arr, obj, value) {
      if (!arr || arr.length === 0) return value
      const key = arr[0]
      obj[key] = arr.length > 1 ? this.tObj(arr.slice(1), {}, value) : value
      return obj
    },
    // 扁平化数据
    sObj (val, config) {
      for (const i in val) {
        if (typeof val[i] === 'object' && typeof config[i] === 'object') {
          val = {
            ...this.sObj(val[i], config[i]),
            ...val
          }
        } else {
          val[config[i]] = val[i]
        }
      }
      return val
    },
    awaitGetlinkeddatalist(pargam) {
      const self = this
      return new Promise(function(resolve) {
        // console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)

        pargam.approvalId = self.approvalId
        // console.log(this.modifyId,this.approvingId)
        if(self.approvingId){
          pargam.approvingId = self.approvingId
        }
        if(self.modifyId && self.modifyId !== ''){
          pargam.approvingId = self.modifyId
        }
        // 从空间进入，需要传空间id
        if (self.$route.query.upaceid || (self.$route.query.upace && localStorage.getItem('upaceid'))) {
          pargam.upaceid = self.$route.query.upaceid || localStorage.getItem('upaceid')
        }
        getlinkeddatalist(pargam).then(res => {
          resolve(res.data);
        });
      });
    },
    // vue3 更新formdata
    updateFormdata(item, val) {
      const key = item.title + '_' + item.type
      // Vue3：不直接改 prop，通知父级更新
      this.$emit('update:formdata', { ...this.formdata, [key]: val })
    },
    handleFormdataUpdata(item, value) {
      console.log("item, value==",item, value);
      const key = item.title + '_' + item.type
      // 更新特定的字段
      this.formdata[key] = value
    },
    // 预约控件重置日期
    handleValueTimeUpdate(item, reaM, newValue) {
      console.log('valueTime update triggered:', newValue)
      const key = item.title + '_' + item.type
      const subKey = reaM.title + '_' + reaM.type
      this.formdata[key][0][subKey] = newValue
    },
    changeValueTime(item, reaM, newValue){
      const key = item.title + '_' + item.type
      const subKey = reaM.title + '_' + reaM.type
      const dates = item.list.find(i => i.type === 'dates')
      const dateKey = dates.title + '_' + dates.type
      const dateValue = this.formdata[key][0][dateKey]
      const li = []
      for (const ele of dateValue) {
        for (const cele of newValue) {
          const obj = { ...cele }
          obj.date = ele
          li.push(obj)
        }
      }
      this.formdata[key][0][subKey] = li
    },
    handleSeTimeUpdate(item, newValue) {
      console.log('seTime update triggered:', newValue)
      const key = item.title + '_' + item.type
      const subKey = item.list[1].title + '_' + item.list[1].type
      console.log(newValue,'newValuenewValue')
      this.formdata[key][0][subKey] = newValue
    },
    handleNumKeyup(e, item) {
      const inputEl = e.target.querySelector('.el-input__inner') || e.target;
      console.log("e===",e)
      const val = inputEl.value;
      console.log("val===",val,inputEl)
      this.$emit('updateNumData', item, val)
      this.approvalProcess(item, val, this.formdata);
    },
    approvalProcess (item, val, formdata) {
      this.arithmetic(item)
      // item 模板数据 val 值 formdata 值合集
      // 如果仅查看，不需要任何回调。并重置值为空， fromdata 对象
      if ((item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && ((item.type === 'radio' && item.dataconfig.setUpValue === 1) || (item.type !== 'radio' && item.dataconfig.setUpValue === 3))) || item.type === 'query') {

      // if ((item.queryOnly && item.dataconfig && item.dataconfig.setUpValue && ((item.type === 'radio' && item.dataconfig.setUpValue === 1) || (item.type !== 'radio' && item.dataconfig.setUpValue === 3))) || (item.dataconfig && item.dataconfig.setUpValue && ((item.type === 'query' && item.dataconfig.setUpValue === 1) || (item.type !== 'query' && item.dataconfig.setUpValue === 3)))) {

        formdata[item.title + '_' + item.type] = null;
        return;
      }
      // val 是单选框选择其他时用的
      // 如果启用了其他，并选择了其他
      if (item.type === "radio" && item.others && val === "others其他") {
        item.othersVal = item.othersVal || "";
      } else {
        if (item.othersVal || item.othersVal === "") delete item.othersVal;
      }
      if (
        item.associationVisible &&
        item.associationVisible.associationswitch &&
        this.associationVisible
      ) {
        this.associationVisible.value[item.title + "_" + item.type] =
          val == "others其他"
            ? item.othersVal
            : this.formdata[item.title + "_" + item.type];
      }
      if (this.ruleListChildType == 3) {
        //如果是关联单选
        this.$emit("linkageMethEmit", null, item, 0);
      } else {
        if (!this.inputChange && item.type == "text") {
          return false;
        }
        this.linkageMeth(this.ruleListChild, item);
      }
      // 固定画布的提交和修改有联动修改他表的功能 类似前端公式的等于
      if (this.isFiexdCanvas && item) {
        this.$emit('updateOtherAppData', item, this.formdata[item.title + '_' + item.type])
      }
    },
    // 明细的回调
    linkageMethChild(items, item, i, detailKey) {
      this.detailSummation(item, detailKey); // 明细求和
      this.linkageMethEach(items, item, i, detailKey); // 联动
    },
    // 联动方法(执行一次approvalProcess，只会循环触发一次该联动)
    linkageMeth(items, item) {
      for (let [i, el] of items.entries()) {
        // 匹配字段名title，如果title相同，则执行下列方法
        if (el.title == item.title) {
          this.linkageMethEach(items, item, i);
        }
      }
      this.$emit("widgetOneLayerEmit", { type: 1 });
    },
    async linkageMethEach (items, item, i, detailKey) {
      console.log('走关联单选',items,item,i, detailKey)
      // items模板，item，模板，i当前模板下标，detailKey存明细的信息
      // items 为空不走

      if (!items) return false;
      for (let [ie, ez] of items.entries()) {
        if (ez.dataconfig && ie > i) {
          //公式的判断
          // 配置了公式
          this.onFormulaResult(this.formdata, item, ez, detailKey);
          // 明细、并开启了多选项卡联动
          if (ez.type === 'details' && ez.isCutDataConfig) {
            let detailsFormdata = this.formdata[ez.title + '_' + ez.type] ? JSON.parse(JSON.stringify(this.formdata[ez.title + '_' + ez.type])) : []
            let isLink = false

            for (let r = 0; r < (ez.cutDataConfig || []).length; r++) {
              const a = ez.cutDataConfig[r]
              console.log('判断是否走联动', !ez.dataconfig.linked)
              if (!a.dataconfig.linked) continue
              console.log('查联动关系配置', a.dataconfig, item)
              let isinclude = onIsinclude(a.dataconfig, item); //大于-1就是有关系
              if (isinclude != -1) {
                //如果有关系
                let param = linkedSetEvent(
                  a.dataconfig,
                  this.formdata,
                  { types: "details" },
                  null,
                  this.customData
                );
                console.log('点击联动数据查询', JSON.parse(JSON.stringify(param)))
                if (param) {
                  param.approvalId = this.approvalId
                  console.log(this.modifyId,this.approvingId)
                  if(this.approvingId){
                    param.approvingId = this.approvingId
                  }
                  if(this.modifyId && this.modifyId !== ''){
                    param.approvingId = this.modifyId
                  }
                  // 跑联动的时候做一个累加，当累加为 0 则联动跑完
                  if (!isLink) {
                    this.readcardCount += 1
                    isLink = true
                  }
                  this.$emit("widgetOneLayerEmit", {
                    type: 6,
                    linkageLoading: true
                  });
                  if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
                    param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
                  }
                  const rr = await getlinkeddatalist(param).catch(err => {
                    console.log('联动错误', err)
                    // this.readcardCountLink()
                  });
                  console.log('联动返回的数据', rr)
                  // rr.data = rr.data.map(it => {
                  //   it.tip = a.i
                  //   return it
                  // })
                  // detailsFormdata = detailsFormdata.filter(it => it.tip !== a.i).concat(rr.data)
                  this.linkageMethEach(
                    items,
                    this.detailsLinkeddataResult(items[ie], rr.data, a),
                    ie,
                    detailKey
                  );
                  this.$emit("widgetOneLayerEmit", {
                    type: 6,
                    linkageLoading: false
                  });

                }
                console.log('当前的明细数据', detailsFormdata)
              }
            }
            if (isLink) {
              

              this.readcardCountLink()
            }

          } else if (ez.dataconfig.linked) {
          // } else if (ez.dataconfig.linked && ez.type !== "new-rel-radio") {
            //先确认当前点击项以后的项有没有包含当前点击整个项
            let isinclude = onIsinclude(ez.dataconfig, item); //大于-1就是有关系
            if (isinclude != -1) {
              //如果有关系
              let param = linkedSetEvent(
                ez.dataconfig,
                this.formdata,
                ez.type == "details" ? { types: "details" } : detailKey,
                null,
                this.customData
              );
              console.log('点击联动数据查询', JSON.parse(JSON.stringify(param)))
              if (!param) {
                //有空数据，不走接口
                const value = await this.linkeddataResult(items[ie], null, detailKey)
                this.linkageMethEach(
                  items,
                  value,
                  ie,
                  detailKey
                );
              } else {
                console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
                param.approvalId = this.approvalId
                console.log(this.modifyId,this.approvingId)
                if(this.approvingId){
                  param.approvingId = this.approvingId
                }
                if(this.modifyId && this.modifyId !== ''){
                  param.approvingId = this.modifyId
                }
                this.$emit("widgetOneLayerEmit", {
                  type: 6,
                  linkageLoading: true
                });
                if (ez.type === "new-rel-radio" && ez.dataconfig.setUpValue === 7) {
                  await this.getNewRelRadioSet(ez, this.formdata, { detailsType: false, newIndex: '', scopeIndex: '' })
                  // 查询关联单选内部子项是否有需要联动的
                  if (ez.list && ez.list.length > 0) {
                    for (let iei = 0; iei < ez.list.length; iei++) {
                      const ezi = ez.list[iei]
                      if (ezi.dataconfig.linked) {
                        const ss = linkedSetEvent(
                          ezi.dataconfig,
                          this.formdata,
                          ezi.type == "details" ? { types: "details" } : detailKey,
                          null,
                          this.customData
                        );
                        try {
                          if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
                            ss.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
                          }
                          const ssRes = await getlinkeddatalist(ss).catch(err => { console.log(err) })
                          if (ssRes.code === 0) {
                              const value = await this.linkeddataResult(ezi, ssRes.data, detailKey)
                              this.linkageMethEach(
                                ez.list,
                                value,
                                iei,
                                detailKey
                              );
                            this.readcardCountLink()
                          }
                        } catch (errr) { console.log(errr) }
                      }
                    }
                  }
                  this.$emit("widgetOneLayerEmit", {
                    type: 6,
                    linkageLoading: false
                  });
                } else {
                  // 跑联动的时候做一个累加，当累加为 0 则联动跑完
                  this.readcardCount += 1
                  if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
                    param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
                  }
                  const res = await getlinkeddatalist(param).catch(err => {
                    console.log('联动错误', err)
                    this.readcardCountLink()
                  });
                  // 如果被联动的数据是空的，并且为数字控件。则使用默认值覆盖 2024-7-8
                  if (items[ie].type === 'number' && (!res.data && res.data !== 0 || res.data.length === 0)) {
                    // 当前使用已有值覆盖联动回来的值
                    res.data = [items[ie].bindinf]
                  }
                  // 联动跑的时候，处理显示隐藏
                  this.$emit("widgetOneLayerEmit", {
                    type: 6,
                    linkageLoading: false
                  });
                  const value = await this.linkeddataResult(items[ie], res.data, detailKey)
                  await this.linkageMethEach(
                    items,
                    value,
                    ie,
                    detailKey
                  );
                  this.readcardCountLink()
                }
                
              }
            }
          } else if (ez.type === 'details' && ez.dataconfig && ez.dataconfig.setUpValue && ez.dataconfig.setUpValue === 6 && ez.abilityId && ez.abilityConfig) {
            // 如果是明细，并且选择了能力联动（能力联动只有明细有，所以它没有明细内的逻辑，并且没有后续逻辑，只需要把对标接口放过来就行了）
            const queryObj = {}
            for (const ae of ez.abilityConfig.getConfig) {
              const values = this.formdata[ae.setKey]
              queryObj[ae.getKey] = values
            }
            console.log('能力联动的',queryObj, this.$apiurl)

            const detailsLink = await patentFun({query: queryObj, api: this.$apiurl}).catch(e => { console.log('明细能力联动出错', e) })
            console.log('明细能力联动', detailsLink)
            if (detailsLink.code == 200) {
              // 这里对明细走一次赋值
              // keyObj
              const detailsForm = []
              for (const ee of detailsLink.data) {
                const mathObs = {}
                for (const aa of ez.abilityConfig.matchConfig) {
                  mathObs[aa.setKey] = ee[aa.getKey]
                }
                detailsForm.push(mathObs)
              }
              // this.$set(this.formdata, ez.title + '_' + ez.type, detailsForm)
              this.formdata[ez.title + '_' + ez.type] = detailsForm
            }

          }
        }
      }
    },
    // 判断 联动无条件状态下条件是否匹配
    getLinkedResultdata (config, title) {
      if (config.linked.resultdata) {
        for (const i of config.linked.resultdata) {
          if (i.objectfeild.includes(title)) return true
        }
      }
    },
    readcardCountLink () {
      this.readcardCount -= 1
      // 判断是否开启了刷卡提交
      if (this.readcardCount <= 0 && this.readcardLinked) {
        this.$emit('submit')
        this.readcardCount = 0
        this.readcardLinked = false
      }
    },
    detailSummation(item, detailKey) {
      // 明细求和
      if (!item) {
        // 整条数据操作，直接走整个明细
        this.ruleListChild.forEach(el => {
          if (el.title + "_" + el.type === detailKey.key) {
            el.list.forEach(ele => {
              this.detailSummation(ele, detailKey);
            });
          }
        });
      } else if (detailKey && item.type === "number") {
        //当前点击的控件为数字，那么就需要循环一级去匹配
        this.ruleListChild.forEach(el => {
          if (
            el.dataconfig &&
            el.dataconfig.setUpValue === 4 &&
            el.dataconfig.formula &&
            el.dataconfig.formula.type === 2 &&
            el.dataconfig.formula.controls ===
              detailKey.key + "." + item.title + "_" + item.type
          ) {
            // 如果当前一级控件为数字，并且配置了公式
            this.formulaResult(
              el,
              onDigitCount(this.formdata[detailKey.key], item, el),

            );
          }
        });
      }

    },
    // 公式使用
    formulaResult(el, value, detailKey) {
      console.log(el, value, detailKey,'el, value, detailKey');
      
      if (detailKey) {
        this.formdata[detailKey.key][detailKey.index][
          el.title + "_" + el.type
        ] =
          el.type === "text" ? (value || value == 0 ? "" + value : "") : value;
      } else {
        if (value && typeof value[0] === 'object') {
          for (var keyname in value[0]){
              if(keyname.search("radio") !== -1){
                value = value[0][keyname]
              }
            }
          this.formdata[el.title + "_" + el.type] = value === null ? '' : value
          this.autoinputFun()
          this.approvalProcess(el,'',this.formdata);
        }else{
          this.formdata[el.title + "_" + el.type] = el.type === "text" ? (value || value == 0 ? "" + value : "") : value;
        }

      }
      this.$emit("widgetOneLayerEmit", { type: 1 });
    },
    onFormulaResult(formdata, item, ez, detailKey) {
      // formdata数据，item当前触发的项，ez，循环到当前，detailKey明细
      if (ez.dataconfig.setUpValue === 4 && ez.dataconfig.formula) {
        formdata = { ...formdata };
        let formula = ez.dataconfig.formula;
        let controlKey = formula.controls;
        let airTimeKey = formula.airTime;
        let endTimeKey = formula.endTime;
        let itemKey = item.key ? item.key : item.title + "_" + item.type;
        if (detailKey) {
          // 明细
          if (detailKey.index === undefined) {
            // 明细批量
            detailKey = { ...detailKey };
            formdata[detailKey.key].forEach((ele, ind) => {
              detailKey.index = ind;
              this.onFormulaResult(formdata, item, ez, detailKey);
            });
          } else {
            //明细单项
            if (
              formula.type === 0 &&
              controlKey === detailKey.key + "." + itemKey
            ) {
              // 等于1
              let value = formdata[detailKey.key][detailKey.index][controlKey.split(".")[1]]
              if (formula.toType && formula.toType === 'initial') {
                value = getPinyin(value)
              }
              this.formulaResult(ez, value, detailKey);
            } else if (
              formula.type === 1 &&
              (airTimeKey === detailKey.key + "." + itemKey ||
                endTimeKey === detailKey.key + "." + itemKey)
            ) {
              // 求时间差
              let val = onTimeDifference(
                formdata[detailKey.key][detailKey.index][
                  airTimeKey.split(".")[1]
                ],
                formdata[detailKey.key][detailKey.index][
                  endTimeKey.split(".")[1]
                ],
                formula.calculation,
                formula.digital
              );
              this.formulaResult(ez, val, detailKey);
            } else if (formula.type === 4 && formula.drageFormula) {
              //函数公式
              // 新增数据的时候，数据是空的
              try {
                //表达式结构
                let conditionStr = formula.drageFormula.condition;
                // 使用正则表达式匹配大写字母和括号内的内容
                let strFilter = conditionStr.match(/([A-Z]+)\((.*)\)/);
                // 计算结果
                if (strFilter && strFilter.length >= 3) {
                  let mathFun = strFilter[1];
                  let nameVal = strFilter[2];
                  console.log("函数方法:", mathFun);
                  console.log("表达式内容:", nameVal);
                  let val = this.dragResule(nameVal,formdata[detailKey.key][detailKey.index],detailKey)
                  let resultVal = this.mathFunRun(val, mathFun)
                  this.formulaResult(ez, resultVal, detailKey);
                } else {
                    console.log("未找到匹配的内容。");
                }
              } catch (error) {
                console.log("error",error)
              }
            }
          }
        } else {
          //一级
          if (formula.type === 0 && controlKey === itemKey) {
            // 等于
            let value = formdata[controlKey]
            if (formula.toType && formula.toType === 'initial') {
              value = getPinyin(value)
            }
            this.formulaResult(ez, value);
          } else if (
            formula.type === 1 &&
            (airTimeKey === itemKey || endTimeKey === itemKey)
          ) {
            //求时间差
            this.formulaResult(
              ez,
              onTimeDifference(
                formdata[airTimeKey],
                formdata[endTimeKey],
                formula.calculation,
                formula.digital
              )
            );
          } else if (formula.type === 4 && formula.drageFormula) {
            //函数公式
            // 新增数据的时候，数据是空的
            try {
              //表达式结构
              let conditionStr = formula.drageFormula.condition;
              // 使用正则表达式匹配大写字母和括号内的内容
              let strFilter = conditionStr.match(/([A-Z]+)\((.*)\)/);
              // 计算结果
              if (strFilter && strFilter.length >= 3) {
                let mathFun = strFilter[1];
                let nameVal = strFilter[2];
                console.log("函数方法:", mathFun);
                console.log("表达式内容:", nameVal);
                let val = this.dragResule(nameVal,formdata)
                let resultVal = this.mathFunRun(val, mathFun)
                console.log("函数公式计算结果=",resultVal);
                // setTimeout(() => {
                  this.formulaResult(ez, resultVal);
                // }, 300);
              } else {
                  console.log("未找到匹配的内容。");
              }
            } catch (error) {
              console.log("error",error)
            }
          }
        }
      }
    },
    // 函数公式计算 formula:函数计算公式  formdata：所有字段的值
    dragResule(formula, formdata,detailKey){
      let that = this
      // let inputString = formula.toLowerCase(); //方法名改成小写
      let dataArr = []
      // 明细控件-函数计算
      if(detailKey){
        const nn = []
        for (const value of this.ruleListChild) {
          if (detailKey.key == value.title + '_' + value.type) {
            if (value.list && value.list.length > 0) {
              for (const d of value.list) {
                // 如果有关联单选并且里面有子控件的话，提出来
                if (d.type === 'new-rel-radio' && d.list && d.list.length > 0) {
                  for (const ee of d.list) {
                    const eea = JSON.parse(JSON.stringify(ee))
                    eea.name = d.name + '.' + eea.name
                    nn.push(eea)
                  }
                }
              }
            }
            dataArr.push(JSON.parse(JSON.stringify(value)))
          }
        }
        // dataArr = that.ruleListChild.filter(value => {
        //   console.log('遍历函数控件', value, value.type)
        //   // 如果有关联单选并且里面有子控件的话，提出来
        //   if (detailKey.key == value.title + '_' + value.type && value.list && value.list.length > 0) {
        //     for (const d of value.list) {
        //       if (d.type === 'new-rel-radio' && d.list && d.list.length > 0) {
        //         for (const ee of d.list) {
        //           const eea = JSON.parse(JSON.stringify(ee))
        //           eea.name = d.name + '.' + eea.name
        //           nn.push(eea)
        //         }
        //       }
        //     }
        //   }
        //   return detailKey.key == value.title + '_' + value.type
        // });
        if (nn.length > 0) {
          console.log('添加的', nn)
          dataArr[0].list = dataArr[0].list.concat(nn)
        }
      } else{
        for (const aa of that.ruleListChild) {
          dataArr.push(aa)
          if (aa.type === 'new-rel-radio' && aa.list && aa.list.length > 0) {
            for (const aae of aa.list) {
              const eeaa = JSON.parse(JSON.stringify(aae))
              eeaa.name = aa.name + '.' + eeaa.name
              dataArr.push(eeaa)
            }
          }
        }
        // dataArr = that.ruleListChild
      }
      console.log('执行111', formula)
      // 遍历数组并构建表达式
      let expression = formula.replace(/<([^>=<]+)>/g, function(match, group) {
        let valName = group;
        
        // 在 JSON 数据中查找与变量名称匹配的属性
        let foundItem = ''
        if(detailKey){
          foundItem = dataArr[0].list.find(function(item) {
            return valName === dataArr[0].name + '.' + item.name
          });
        } else{
          foundItem = dataArr.find(function(item) {
            return valName === item.name
          });
        }
        console.log('函数遍历表达112221', foundItem)
        if (foundItem) {
            // 如果找到匹配的属性，构建相应的表达式部分
            // return `formdata['${foundItem.title + '_' + foundItem.type}']`; 完整字段名
            // 直接返回对应字段的值
            return formdata[foundItem.title +  '_' + foundItem.type]
        } else {
            // 如果找不到匹配的属性，保持原始字符串
            // return match;
            // 如果找不到则返回0或者空字符
            if(foundItem.type === 'number'){
              return 0
            } else{
              return ''
            }
        }
      });
      console.log("函数公式==",expression)
      return `${expression}`;
    },
    // 函数计算-所有函数列表
    mathFunRun(val, mathFun){
      // 多个文本合并，使用数组进行拼接
      let countArr = val.split(",")
      let concatenatedString = ''
      let resultVal = ''
      let undefinedLen = 0
      for(let i = 0; i < countArr.length; i++){
        if(countArr[i] != 'undefined'){
          concatenatedString += countArr[i]
        }
        else undefinedLen++
      }
      if(undefinedLen == countArr.length){
        return resultVal = undefined
      }
      switch (mathFun) {
        case "IF":
          // IF三元运算
          resultVal = this.evaluateCondition(countArr)
          break;
        case "SUM":
          // 求和
          resultVal = math.evaluate('sum('+val+')')
          break;
        case "MAX":
          // 最大数
          resultVal = math.evaluate('max('+val+')')
          break;
        case "MIN":
          // 最小数
          resultVal = math.evaluate('min('+val+')')
          break;
        case "MOD":
          // 两数相除的余数
          resultVal = math.evaluate('mod('+val+')')
          break;
        case "AVG":
          // 平均值
          resultVal = math.evaluate('mean('+val+')')
          resultVal = resultVal.toFixed(2)
          break;
        case "ABS":
          // 绝对值
          resultVal = math.evaluate('abs('+val+')')
          break;
        case "CONCAT":
          if(this.containsOperator(val)){						
            // 检查是否包含日期时间相关的字符串操作
            if(val.includes('substr') || val.includes('abs') || val.includes('?') || val.includes(':')) {
              // 对于包含字符串操作的表达式，需要特殊处理
              resultVal = this.evaluateStringExpression(val)
              console.log("resultVal11==",resultVal)
            } else {
              // 加减乘除计算
              resultVal = math.evaluate(val)
              console.log("resultVal22==",resultVal)
            }
          }
          else{
            // 多个文本合并
            resultVal = math.concat(concatenatedString)
          }
          break;
        case "MID":          
          if (val && typeof val === 'string') {
            const midParts = val.split(',');
            if (midParts.length === 3) {
              const midText = midParts[0].trim();
              const midStart = parseInt(midParts[1].trim(), 10);
              const midLen = parseInt(midParts[2].trim(), 10);
              console.log("midText==",midText,midStart,midLen)
              if (midText == null || midText === undefined || midText === 'null' || midText === '') {
                resultVal = '';
                break;
              }
              if (!isNaN(midStart) && !isNaN(midLen) && midStart >= 1) {
                resultVal = midText.substring(midStart - 1, midStart - 1 + midLen);
              } else {
                resultVal = '';
              }
            } else {
              resultVal = '';
            }
          } else {
            resultVal = '';
          }
          break;
        case "ROUND": {
          // 小数点格式化
          const index = val.indexOf(',');
          if (index === -1) {
            // 字符串中不包含逗号
            resultVal = math.round(val)
          } else {
            const before = val.substring(0, index);
            const after = val.substring(index + 1);
            resultVal = math.round(before, after)
          }
          break;
        }
        case "DIFFDATE":
          // 计算两个时间的时差
          if (val && typeof val === 'string') {
            const parts = val.split(',');
            if (parts.length === 3) {
              const timeType = parts[0].toLowerCase(); // d, h, i, m, y
              const startTime = parts[1].trim();
              const endTime = parts[2].trim();
              // 根据时间类型确定calculation参数
              let calculation = 0; // 默认天数
              let digital = 0; // 精确单位
              switch(timeType) {
                case 'd': calculation = 0; digital = 3; break; // 天数
                case 'h': calculation = 1; break; // 小时
                case 'i': calculation = 2; break; // 分钟
                case 'm': calculation = 3; break; // 月份
                case 'y': calculation = 4; digital = 3; break; // 年份
                default: calculation = 0; break;
              }
              // 调用onTimeDifference函数计算时间差
              resultVal = onTimeDifference(startTime, endTime, calculation, digital);
            } else {
              resultVal = 0;
            }
          } else {
            resultVal = 0;
          }
          break;
        default:
          break;
      }
      return resultVal;
    },
    // 处理字符串表达式
    evaluateStringExpression(expression) {
      try {
        // 提取三元运算符中的 true 和 false 值
        const ternaryMatch = expression.match(/\(([^?]+)\?\s*'([^']+)'\s*:\s*'([^']+)'\)/)
        if (ternaryMatch) {
          const condition = ternaryMatch[1]  // abs('2025-09-08 12:00'.substr(11,2)) < 12
          const trueValue = ternaryMatch[2]  // ' 12:00'
          const falseValue = ternaryMatch[3] // ' 23:59'
          
          // 解析条件中的 abs 和 substr 操作
          const absMatch = condition.match(/abs\('([^']+)'\.substr\((\d+),(\d+)\)\)/)
          if (absMatch) {
            const dateTimeStr = absMatch[1]
            const start = parseInt(absMatch[2])
            const length = parseInt(absMatch[3])
            const extractedValue = dateTimeStr.substring(start, start + length)
            const hour = parseInt(extractedValue)
            
            // 判断条件是否成立
            const conditionResult = Math.abs(hour) < 12
            const secondResult = conditionResult ? trueValue : falseValue
            
            // 提取第一个参数：'2025-09-08 12:00'.substr(0,10)
            const firstParamMatch = expression.match(/'([^']+)'\.substr\((\d+),(\d+)\)/)
            if (firstParamMatch) {
              const dateTimeStr2 = firstParamMatch[1]
              const start2 = parseInt(firstParamMatch[2])
              const length2 = parseInt(firstParamMatch[3])
              const firstResult = dateTimeStr2.substring(start2, start2 + length2)
              
              // 拼接结果
              return firstResult + secondResult
            }
          }
        }
        
        return expression
      } catch (error) {
        console.error('字符串表达式计算错误:', error)
        return expression
      }
    },
    // 正则表达式匹配 +、-、* 或 /
    containsOperator(str) {
      // 匹配：数字（可能为负数、小数） + 运算符 + 数字
      return /[+\-*/]/.test(str);
      // return /^-?\d+(\.\d+)?(\s*[+\-*\/]\s*-?\d+(\.\d+)?)+$/.test(str);
    },
    // 函数运算if三元运算
    evaluateCondition(arr) {
      const condition = arr[0];
      const trueValue = arr[1].replace(/"/g, '');
      const falseValue = arr[2].replace(/"/g, '');
      let result;
      if (condition.includes('>') && !condition.includes('>=')) { //大于
        const operands = condition.split('>');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue)
      } else if (condition.includes('>=')) { //大于等于
        const operands = condition.split('>=');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue, '>=')
      } else if (condition.includes('<') && !condition.includes('<=')) { //小于
        const operands = condition.split('<');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue, '<')
      } else if (condition.includes('<=')) { //小于等于
        const operands = condition.split('<=');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue, '<=')
      } else if (condition.includes('!=')) { //不等于
        const operands = condition.split('!=');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue, '!=')
      } else if (condition.includes('=')) { //等于
        const operands = condition.split('=');
        result = this.getContrastVal(operands[0], operands[1], trueValue, falseValue, '=')
      } else {
        // 未知条件
        console.log("所有IF条件都不匹配，请重试");
      }
      return result;
    },
    //IF比较
    getContrastVal(val1, val2, trueValue, falseValue, operator = '>'){
      let result;
      // 运算符映射
      const ops = {
        '>':  (a, b) => a >  b,
        '>=': (a, b) => a >= b,
        '<':  (a, b) => a <  b,
        '<=': (a, b) => a <= b,
        '!=': (a, b) => a != b,
        '=': (a, b) => a == b,
      };
      if (this.isDateTimeString(val1) && this.isDateTimeString(val2)) {
        // 处理纯时间格式，如果是纯时间格式，需要补充日期部分
        const processTimeValue = (val) => {
          if (/^\d{2}:\d{2}(:\d{2})?$/.test(val)) {
            // 如果是纯时间格式，加上今天的日期
            const today = new Date().toISOString().split('T')[0];
            return `${today} ${val}`;
          }
          // 如果只有日期，加上时间00:00:00
          if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
            return `${val} 00:00:00`;
          }
          return val;
        };

        const leftDateTime = new Date(processTimeValue(val1));
        const rightDateTime = new Date(processTimeValue(val2));

        if (isNaN(leftDateTime.getTime()) || isNaN(rightDateTime.getTime())) {
          result = '';
        } else {
          result = ops[operator] ? ops[operator](leftDateTime, rightDateTime) ? trueValue : falseValue : '';
        }
      } else {
        // 原有的数值比较逻辑
        const leftOperand = parseFloat(val1);
        const rightOperand = parseFloat(val2);
        if(isNaN(leftOperand) || isNaN(rightOperand)) {
            result = '';
        } else {
            result = ops[operator] ? ops[operator](leftOperand, rightOperand) ? trueValue : falseValue : '';
        }
      }
      return result
    },
    // IF日期、时间等格式比较
    isDateTimeString(str) {
      // 日期格式 YYYY-MM-DD
      const datePattern = /^\d{4}-\d{2}-\d{2}$/;
      // 时间格式 HH:mm:ss
      const timePattern = /^\d{2}:\d{2}(:\d{2})?$/;
      // 日期时间格式 YYYY-MM-DD HH:mm:ss
      const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/;
      
      return datePattern.test(str) || timePattern.test(str) || dateTimePattern.test(str);
    },
    // 明细开启了切页选项的联动方法
    detailsLinkeddataResult (item, res, cutConfig) {
      console.log('返回联动1', item, res, cutConfig)
      //item当前明细，res数据
      if (item.type == "details") {
        let list = momVal(item.list);
        list.tip = cutConfig.i
        //- 明细新增
        let formdataList = this.formdata[item.title + "_" + item.type] ? JSON.parse(JSON.stringify(this.formdata[item.title + "_" + item.type])) : []
        // 清掉明细联动里面关于当前切页的数据
        formdataList = formdataList.filter(it => it.tip && it.tip !== cutConfig.i)
        this.formdata[item.title + "_" + item.type] = formdataList
        // this.formdata[item.title + "_" + item.type] = [];
        if (res && res.length > 0) {
          //这里需要做个数据处理，然后走个方法，进入明细批量处理（也许那个批量处理和明细内部处理能用同一个）
          let linkedDetailsList = linkedDetailsKeyMap(res);
          // console.log('联动数据回来linkedDetailsList', linkedDetailsList)
          const ddFormdata = []
          for (let i in linkedDetailsList) {
            if (item.detailsNum && Number(item.detailsNum) > 0 && Number(item.detailsNum) <= linkedDetailsList.length) {
              this.$message({
                message:
                  item.name + "最多只能有" + item.detailsNum + "条数据哦！",
                type: "warning"
              });
              break;
            } else {
              // this.formdata[item.title + "_" + item.type].push(assignFormdata(copyObj(list), linkedDetailsList[i], { tip: cutConfig.i }));
              ddFormdata.push(assignFormdata(copyObj(list), linkedDetailsList[i], { tip: cutConfig.i }))
            }
          }
          this.$set(this.formdata, item.title + "_" + item.type, (this.formdata[item.title + "_" + item.type] || []).concat(ddFormdata))
          this.linkedDetailedBatch(item, -1);
        } else {
          this.formdata[item.title + "_" + item.type].push(list);
        }        
      }
      console.log('detailsLinkeddataResult执行结束', this.formdata[item.title + "_" + item.type], cutConfig.i)
    },
    //- 联动后返回需要加入formdata关联一级控件或者明细控件的数据
    async linkeddataResult(item, res, iy) {
      console.log('返回联动', item, res, iy)
      //item当前项，iy明细信息，子明细联动使用，res数据
      if (item.type == "details") {
        let list = momVal(item.list);
        //- 明细新增
        this.formdata[item.title + "_" + item.type] = [];
        if (res && res.length > 0) {
          //这里需要做个数据处理，然后走个方法，进入明细批量处理（也许那个批量处理和明细内部处理能用同一个）
          let linkedDetailsList = linkedDetailsKeyMap(res);
          for (let i in linkedDetailsList) {
            if (
              item.detailsNum &&
              Number(item.detailsNum) > 0 &&
              Number(item.detailsNum) <=
                this.formdata[item.title + "_" + item.type].length
            ) {
              this.$message({
                message:
                  item.name + "最多只能有" + item.detailsNum + "条数据哦！",
                type: "warning"
              });
              break;
            } else {
              this.formdata[item.title + "_" + item.type].push(
                assignFormdata(copyObj(list), linkedDetailsList[i])
              );
            }
          }
          this.linkedDetailedBatch(item, -1);
        } else {
          this.formdata[item.title + "_" + item.type].push(list);
        }
        this.$forceUpdate()
      } else {
        //- 控件后台给的数据错误少了一个层级
        if ((item.type == "radio" || item.type == "checkbox" || item.type == "query") && res !== null) {
          // 不是填充联动不走以下
          if (item.dataconfig && item.dataconfig.setUpValue === 1) {
            const val = item.type == "checkbox" ? res : (typeof res === 'string' ? res : res[0])
            if (iy) {
              this.formdata[iy.key][iy.index][item.title + "_" + item.type] = val
            } else {
              this.formdata[item.title + "_" + item.type] = val
            }
          }
          // 选项联动，清空下拉菜单已选中的值
          else{
            if (iy) {
              this.formdata[iy.key][iy.index][item.title + "_" + item.type] = ""
            } else {
              this.formdata[item.title + "_" + item.type] = ""
            }
          }
        } else {
          if (iy) {
            if (item.type === "relation-user") {
              this.relationUserDataO = item;
              this.relationUserDataO.finxType = iy.key;
              this.relationUserDataO.indexs = iy.index;
              this.orgChoiceMethod({
                checkedUserArr:
                  res && res.length > 0 && item.dataconfig.setUpValue == 1
                    ? res[0]
                    : []
              });
            } else if (item.type === "file" || item.type === "image") {
              this.$set(this.formdata[iy.key][iy.index], item.title + "_" + item.type, uploaderFun((res && res[0]) || [],item.type))
            } else {
             // 数字控件联动回来的值为空直接不走数据替换逻辑（2024-7-8）
              const resVal = res && res.length > 0 && item.dataconfig.setUpValue == 1 ? linkedFormatConversion(item, res) : ""
              let rrvv = item.type === 'number' ? Number(resVal) : resVal
              if (item.type === 'number' && (!res && res !== 0 || res.length === 0)) {
                rrvv = [item.bindinf]
              }
              this.$set(this.formdata[iy.key][iy.index], item.title + "_" + item.type, rrvv)

              // 如果回填的为数字控件，那么就跑一次公式明细求和
              this.detailSummation(item, iy);
            }
          } else {
            if (item.type === "relation-user") {
              this.relationUserDataO = item;
              await this.orgChoiceMethod({
                checkedUserArr:
                  res && res.length > 0 && item.dataconfig.setUpValue == 1
                    ? res[0]
                    : []
              });
            } else if (item.type === "file" || item.type === "image") {
              // this.$set(this.formdata, item.title + "_" + item.type, uploaderFun(res[0] || [],item.type))
              this.formdata[item.title + "_" + item.type] = uploaderFun(res[0] || [],item.type)
            } else {
              // 数字控件联动回来的值为空直接不走数据替换逻辑（2024-7-8）
              // const resVal = res && res.length > 0 && item.dataconfig.setUpValue == 1 ? linkedFormatConversion(item, res) : ""
              let rrvv = res && res.length > 0 && item.dataconfig.setUpValue == 1 ? linkedFormatConversion(item, res) : ""
              console.log('覆盖值1', item, rrvv, res, item.type === 'number' , (!res && res !== 0 || res.length === 0))
              console.log('覆盖值12', res, '--', !res , res !== 0 || res.length === 0)
              if (item.type === 'number' && (!res && res !== 0 || res.length === 0)) {
                rrvv = [item.bindinf]
              }
                              console.log('覆盖值11',  rrvv)
              // this.$set(this.formdata, item.title + "_" + item.type, rrvv)
              this.formdata[item.title + "_" + item.type] = rrvv
            }
          }
        }
      }
      if ((res && !iy) || (res && iy && item.type === "relation-user")) {
        //一级控件有值，和明细控件有值，并且为联系人，跑流程
        this.$emit("widgetOneLayerEmit", { type: 1 });
      }
      return item;
    },
    // 明细联动返回值格式转换
    // async linkedDetailedBatch(item, itemIndex, addIndex) {
    //   //明细批量处理,item当前明细模板，itemindex当前横向坐标，addIndex,如果这个有值，就是新增的联动
    //   for (let [ie, el] of item.list.entries()) {
    //     //批量跑的时候，联动为true
    //     if (
    //       el.dataconfig &&
    //       el.dataconfig.linked &&
    //       el.dataconfig.linked.conditional &&
    //       el.dataconfig.setUpValue == 1 &&
    //       el.type !== "new-rel-radio" &&
    //       el.type !== "radio" &&
    //       el.type !== "checkbox" &&
    //       el.type !== "query" &&
    //       ie > itemIndex
    //     ) {
    //       let param = linkedSetEvent(el.dataconfig, this.formdata, null, true);
    //       //如果是新增，获取明细批量里面的最后一条如果没有数据，就不跑联动
    //       if (param && addIndex > -1) {
    //         for (let i in param) {
    //           let valKey =
    //             i.indexOf("_details.") > -1
    //               ? JSON.parse(param[i])[JSON.parse(param[i]).length - 1]
    //               : param[i];
    //           if (
    //             (i.indexOf("_details.") !== -1 && !valKey) ||
    //             (valKey && valKey.length == 0) ||
    //             (i.indexOf("number") !== -1 && valKey == 0)
    //           ) {
    //             //包含
    //             param = false;
    //             break;
    //           }
    //         }
    //       }
    //       if (param) {
    //         this.$emit("widgetOneLayerEmit", { type: 6, linkageLoading: true });
    //         let resData = await this.awaitGetlinkeddatalist(param);
    //         this.$emit("widgetOneLayerEmit", {
    //           type: 6,
    //           linkageLoading: false
    //         });
    //         //返回成功，进行数据处理渲染
    //         resData.forEach((ele, index) => {
    //           if (!addIndex || (addIndex && addIndex == index)) {
    //             //这里写判断，对文件和图片的格式处理 (对联系人格式走一次同步逻辑)
    //             let value = typeof ele !== "object" ? ele : ele[item.title + "_" + item.type + "." + el.title + "_" + el.type];
    //             if (!this.formdata[item.title + "_" + item.type][index]) this.$set(this.formdata[item.title + "_" + item.type], index, {})
    //             if (el.type === "file" || el.type === "image") {
    //               this.$set(this.formdata[item.title + "_" + item.type][index], el.title + "_" + el.type, uploaderFun(value,el.type))
    //               // this.formdata[item.title + "_" + item.type][index][
    //               //   el.title + "_" + el.type
    //               // ] = uploaderFun(value,el.type);
    //             } else {
    //               this.$set(this.formdata[item.title + "_" + item.type][index], el.title + "_" + el.type, value == 0 ? value : value || "")
    //               // this.formdata[item.title + "_" + item.type][index][
    //               //   el.title + "_" + el.type
    //               // ] = value == 0 ? value : value || "";
    //             }
    //           }
    //         });
    //         // 如果当前是联系人控件,组合去重一次值
    //         this.$emit("widgetOneLayerEmit", { type: 1 }); //批量联动结束跑一次流程
    //       }
    //     }
    //     // 配置了公式
    //     let detailKey = { key: item.title + "_" + item.type, index: addIndex };
    //     if (
    //       el.dataconfig &&
    //       el.dataconfig.setUpValue === 4 &&
    //       el.dataconfig.formula
    //     ) {
    //       let itemKey = el.dataconfig.formula.type
    //         ? el.dataconfig.formula.airTime.split(".")[1]
    //         : el.dataconfig.formula.controls.split(".")[1];
    //       this.onFormulaResult(this.formdata, { key: itemKey }, el, detailKey);
    //     }
    //     // 明细求和
    //     this.detailSummation(el, detailKey);
    //   }
    // },
    //联动返回值格式转换
    async linkedDetailedBatch(item, itemIndex, addIndex) {
      console.log('linkedDetailedBatch', item, itemIndex, addIndex)
      //明细批量处理,item当前明细模板，itemindex当前横向坐标，addIndex,如果这个有值，就是新增的联动
      for (let [ie, el] of item.list.entries()) {
        //批量跑的时候，联动为true
        if (
          el.dataconfig &&
          el.dataconfig.linked &&
          el.dataconfig.linked.conditional &&
          el.dataconfig.setUpValue == 1 &&
          el.type !== "new-rel-radio" &&
          el.type !== "radio" &&
          el.type !== "checkbox" &&
          el.type !== "query" &&
          ie > itemIndex
        ) {
          let param = linkedSetEvent(el.dataconfig, this.formdata, null, true, this.customData);
          //如果是新增，获取明细批量里面的最后一条如果没有数据，就不跑联动
          if (param && addIndex > -1) {
            for (let i in param) {
              let valKey =
                i.indexOf("_details.") > -1
                  ? JSON.parse(param[i])[JSON.parse(param[i]).length - 1]
                  : param[i];
              if (
                (i.indexOf("_details.") !== -1 && !valKey) ||
                (valKey && valKey.length == 0) ||
                (i.indexOf("number") !== -1 && valKey == 0)
              ) {
                //包含
                param = false;
                break;
              }
            }
          }
          if (param) {
            this.$emit("widgetOneLayerEmit", { type: 6, linkageLoading: true });
            let resData = await this.awaitGetlinkeddatalist(param);
            this.$emit("widgetOneLayerEmit", {
              type: 6,
              linkageLoading: false
            });
            //返回成功，进行数据处理渲染
            resData.forEach((ele, index) => {
              if (!addIndex || (addIndex && addIndex == index)) {
                //这里写判断，对文件和图片的格式处理 (对联系人格式走一次同步逻辑)
                let value = typeof ele !== "object" ? ele : ele[item.title + "_" + item.type + "." + el.title + "_" + el.type];
                if (!this.formdata[item.title + "_" + item.type][index]) 
                // this.$set(this.formdata[item.title + "_" + item.type], index, {})
                this.formdata[item.title + "_" + item.type][index][el.title + "_" + el.type] = value == 0 ? value : value || ""
                if (el.type === "file" || el.type === "image") {
                  // this.$set(this.formdata[item.title + "_" + item.type][index], el.title + "_" + el.type, uploaderFun(value,el.type))
                  this.formdata[item.title + "_" + item.type][index][el.title + "_" + el.type] = uploaderFun(value,el.type)
                } else {
                  // this.$set(this.formdata[item.title + "_" + item.type][index], el.title + "_" + el.type, value == 0 ? value : value || "")
                  this.formdata[item.title + "_" + item.type][index][el.title + "_" + el.type] = value == 0 ? value : value || ""
                }
              }
            });
            // 如果当前是联系人控件,组合去重一次值
            this.$emit("widgetOneLayerEmit", { type: 1 }); //批量联动结束跑一次流程
          }
        }
        // 配置了公式
        let detailKey = { key: item.title + "_" + item.type, index: addIndex };
        if (
          el.dataconfig &&
          el.dataconfig.setUpValue === 4 &&
          el.dataconfig.formula
        ) {
          let itemKey = el.dataconfig.formula.type
            ? el.dataconfig.formula.airTime.split(".")[1]
            : el.dataconfig.formula.controls.split(".")[1];
          this.onFormulaResult(this.formdata, { key: itemKey }, el, detailKey);
        }
        // 明细求和
        this.detailSummation(el, detailKey);
      }
    },
    onselschange(show, item, detailKey) {
      console.log('onselschange==',show, item, detailKey, JSON.parse(JSON.stringify(item.sels)))
      // this.$set(this.radioBlur,item.title+'_'+item.type,show?true:false)
      this.radioBlur[item.title+'_'+item.type] = show?true:false
      // 单多选--填充联动--自定义和字典不走这个逻辑
      if ((item.type === 'radio' || item.type === 'checkbox') && item.dataconfig && item.dataconfig.setUpValue && item.dataconfig.setUpValue === 1 && item.dataconfig.downType && (item.dataconfig.downType === 'customize' || item.dataconfig.downType === 'dictionary')) return false
      console.log('onselschange下来')
      item.sels = this.selschange(show, item, detailKey);
    },
    selschange(show, item, detailKey) {
      //审批和修改的时候点击选项使用的，show为下拉框显示，item为当前项目，detailKey是给子明细使用
      let sels = item.sels;
      if (
        show &&
        item.dataconfig &&
        item.dataconfig.setUpValue != 2 &&
        item.dataconfig.linked &&
        item.dataconfig.linked.conditional.length > 0
      ) {
        let param = linkedSetEvent(item.dataconfig, this.formdata, detailKey, null, this.customData);
        sels = "[]";
        if (param) {
          console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
          param.approvalId = this.approvalId
          console.log(this.modifyId,this.approvingId)
          if(this.approvingId){
            param.approvingId = this.approvingId
          }
          if(this.modifyId && this.modifyId !== ''){
            param.approvingId = this.modifyId
          }
          // 从空间进入，需要传空间id
          if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
            param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
          }
          getlinkeddatalist(param).then(res => {
            res.data = linkedFormatConversion({ type: "checkbox" }, res.data);
            sels = res.data ? JSON.stringify(res.data) : "[]";
            // this.$set(item, "sels", sels);
            item.sels = sels
            if(item.type === 'textarea' && res.data.length > 0){
              this.textareaRelShow = true
            }
          });
        }
      }
      return sels;
    },
    objSels(data, item) {
      // 如果有开启选项卡模式，先筛选一次过滤下
      let date = data ? JSON.parse(JSON.stringify(data)) : []
      if (item && item.dataconfig && item.dataconfig.setUpValue && (item.dataconfig.setUpValue === 2 || item.dataconfig.setUpValue === 1 && item.dataconfig.downType && item.dataconfig.downType === 'dictionary')) {
        if (typeof date === 'string') {
          try {
            date = JSON.parse(date)
          } catch (err) { console.log(err) }
        }
        if (item.type === 'checkbox') {
          if (item.dictionary && item.dictionary.length > 0) {
            date = date.concat(item.dictionary.map(it => it.value))
          }
        } else {
          date = date.concat(item.dictionary)
        }
      }
      if (item && item.isCut && this.cutObj[item.title]) {
        const ind = item.cutList.findIndex(its => its.label === this.cutObj[item.title])
        if (ind !== -1) {
          const s = item.cutList[ind].value
          if (typeof date === 'string') {
            try {
              date = JSON.parse(date)
            } catch(e) { console.log(e) }
          }
          date = date.filter(its => s[its.value || its])
        }
      }
      // 过滤数组对象中的undefined
      if(Array.isArray(date)){
        date = date.filter(item => item !== undefined);
      }
      return widgetJs.objSels(date).filter(it => it || it === 0);
    },
    //关联单选 <->
    associatedControls(item, typeOr, value) {
      console.log('关联打开', item, typeOr, value)
      // openAssForm
      this.openAssForm = item
      // value 为fromdata 的值
      //typeOr=1单选。2多选
      if (typeOr == 1) {
        this.associatedControlsData = item;
      }
      let OtherObj = {
        valOrNew: 0,
        relWidDataLook: 1
      };

      if (item.type == "new-rel-radio") {
        //新关联控件获取数据不同titleId，
        OtherObj.valOrNew = 1;
        if (item.relWidDataLook) {
          OtherObj.relWidDataLook = item.relWidDataLook;
        }
      }
      let onCondition = this.onCondition(item);
      if (onCondition.condition) {
        OtherObj.dataconfig = item.dataconfig;
        OtherObj.condition = item.condition;
      }
      // 如果配置了组织和用户的去另外选择
      if (item.selectTable && item.selectTable === 'sys') {
        this.$refs.sysUser.open(item, OtherObj, value)
      } else {
        this.$refs.oaExamineAssFormRef.oaExamineAssChildMethod(
          item,
          OtherObj,
          value,
          this.AuditList
        );
      }
    },
    onRelCondition() {
      // param = this.onCondition(param);
    },
    //关联单选聚焦触发
    onCondition(item) {
      if (item.dataconfig && item.dataconfig.setUpValue == 1 || item.type === 'new-rel-radio' && item.dataconfig && item.dataconfig.setUpValue == 7) {
        //如果有配置联动
        let param = false;
        if (item.dataconfig.linked && item.dataconfig.linked.conditional) {
          param = linkedSetEvent(item.dataconfig, this.formdata, {
              index: item.thisIndex
            },
            null,
            this.customData
          );
          if (param) {
            delete param.dataconfig;
          }
        }
        item.condition = param ? param : {}; //有配置联动，数据没填完使用
      }
      return { ...item };
    },
    debounceRelationUserChoice: debounce(function(...arg) {
      this.relationUserChoice(...arg)
    }, 400),
    handleContactList(data) {
      this.contactList = data
    },
    // 处理键盘事件
    handleKeyup(event, item, formdata, linkedWd) {
      // 判断按下Enter键，并且联系人有值的话默认选择第一个人
      if ((event.key === 'Enter' || event.keyCode === 13) && this.contactList.length > 0) {
        this.relationUserDataO = item
        const obj = {
          checkedUserArr: [this.contactList[0]]
        }
        this.orgChoiceMethod(obj)
        this.linkedWd = {}
      } else {
        // 其他按键触发原来的搜索逻辑
        this.contactList = []
        this.debounceRelationUserChoice(item, 1, formdata, false, 'defaultSearch', linkedWd);
      }
    },
    //联系人控件，组织控件，角色控件
    relationUserChoice(data, type, val, items, fromBtn, searchKey) {
      console.log("relationUserChoice=",data, type, val, items, fromBtn, searchKey);
      //items为true明细联动
      if (data.exhibiIs) {
        //展示控件不允许修改
        return false;
      }
      // 如果存在值（暂用）
      if (val) data.bindinf = val;
      this.dataParenTy = type; //区分明细。关联单选控件。
      var param = {}
      param.onlyUser = true; //只选用户
      param.isLook = data.lookRMSIsUser; //查看范围。1:本部门不含子部门,2:本部门及其子部门,3:全部部门,4:自定义,5:无,6: 我管理的,
      param.isGroup = data.isGroup; // 是否显示自定义分组
      param.iManageIt = data.iManageIt || []; // 我管理的组织标签
      if (this.baseSet) {
        param.grouping = this.baseSet.grouping; // 常用分组调用平台&应用
      }
      param.showBatch = true; //是否显示批量操作
      param.isShowID = data.isShowID; // 是否显示用户身份证
      param.approvalId = this.approvalId; // 应用id
      this.relationUserDataO = data; //当前暂存值
      // var isMany = data.singleIsUser; //是否可以多选。为1可以多选
      param.radio_ = data.singleIsUser ? false : true;
      if (data.lookRMSIsUser == "4") {
        if (data.lookCustomArr.length > 0) {
          param.lookCustomArr = JSON.parse(data.lookCustomArr); //自定义
        }
        // 联系人控件-自定义，勾选数据显示
        if (data.type === 'relation-user' && data.dataShow && fromBtn !== 'orgBtn') {
          console.log("2111");
          
          if(data.lookCustomArr.length === 0){
              this.$message.error("请先选择部门查看范围");
              return
          }
          if(Number(data.maxCount) <= data.bindinf.length){
            this.$message.warning('最多只能选择' + data.maxCount + '人员');
            return
          }
          if(items){
            let detailRef = this.detailTitle + 'table';
            if(fromBtn && fromBtn === 'defaultSearch'){
              // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
              this.$refs[detailRef][0].showUserList(data, JSON.parse(data.lookCustomArr), {channel: 'newList'}, searchKey);              
            }
            else{
              if (this.linkedWd && Object.keys(this.linkedWd).length !== 0 && 
                  Object.values(this.linkedWd).some(value => value !== "")) {
                return false;
              }
              this.$refs[detailRef][0].showUserList(data, JSON.parse(data.lookCustomArr), {channel: 'newList'});
            }            
          }
          else{
            let relationUserRef = "relationUserRef_" + data.title;
            let linkedDropDownRef = "linkedDropDownRef_" + data.title;
            const el = this.$refs[relationUserRef][0]
            if(fromBtn && fromBtn === 'defaultSearch'){
              // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
              this.$refs[linkedDropDownRef][0].getList(data, JSON.parse(data.lookCustomArr), {channel: 'newList', parentDiv: el}, '', searchKey);
            }
            else{
              if (this.linkedWd && Object.keys(this.linkedWd).length !== 0 && 
                  Object.values(this.linkedWd).some(value => value !== "")) {
                return false;
              }
              this.$refs[linkedDropDownRef][0].getList(data, JSON.parse(data.lookCustomArr), {channel: 'newList', parentDiv: el});
            }
          }
          return
        }
      } else if (data.lookRMSIsUser == "5") {
        param.isorgs = true;
      } else if (data.lookRMSIsUser == "1" || data.lookRMSIsUser == "2" || data.lookRMSIsOrg == "1") {
        param.JsonDataOrg = { organizationId: 1, pid: -1 };
        param.leafOrg = data.lookRMSIsUser == "1";
      }
      if (data.bindinf) {
        if (data.bindinf.length != 0) {
          param.bindinf = []; //已选用户
          // param.checkedUser = data.bindinf;
          // 角色控件，传name、roleId
          if(data.type == 'organization'){
            data.bindinf.forEach(el => {
              var obj = {
                name: el.name,
                organizationId: el.organizationId,
                looktype: el.looktype || 0,
                type: el.type
              };
              param.bindinf.push(obj);
            });
            param.checkedFlowArr = param.bindinf; //选中
            delete param.showBatch;
          }
          // 角色控件，传name、roleId
          else if(data.type == 'roule'){
            data.bindinf.forEach(el => {
              var obj = {
                name: el.name,
                roleId: el.roleId
              };
              param.bindinf.push(obj);
            });
            param.checkedRoleArr = param.bindinf; //选中
            delete param.showBatch;
          }
          else{
            data.bindinf.forEach(el => {
              var obj = {
                realname: el.realname,
                userId: el.userId,
                orgname: el.orgname
              };
              param.bindinf.push(obj);
            });
            param.checkedUserArr = param.bindinf; //选中
          }
        }
      }
      console.log('判断进入情况', type == 1 || (type == 3 && items), data.dataconfig)
      if (type == 1 || (type == 3 && items)) {
        if (
          data.dataconfig &&
          data.dataconfig.setUpValue == 3 &&
          data.dataconfig.linked &&
          data.dataconfig.linked.conditional
        ) {
          // 条件不需要是必须有
          //  &&
          //  data.dataconfig.linked.conditional.length > 0
          let param = linkedSetEvent(data.dataconfig, this.formdata, {
            index: data.indexs
          }, null, this.customData);
          this.relationUserDataO = data;
          let pargam = {
            radio_: data.singleIsUser ? false : true,
            isorgs: true,
            isrole: true,
            CustomUserArr: [],
            checkedUserArr: []
          };
          
          if (param) {
            if (data.maxCount) pargam.maxCount = data.maxCount
            console.log('添加approvalId和approvingId',this.approvalId,this.approvingId)
            param.approvalId = this.approvalId
            console.log(this.modifyId,this.approvingId)
            if(this.approvingId){
              param.approvingId = this.approvingId
            }
            if(this.modifyId && this.modifyId !== ''){
              param.approvingId = this.modifyId
            }
            // 从空间进入，需要传空间id
            if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
              param.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
            }
            getlinkeddatalist(param).then(res => {
              (pargam.CustomUserArr = res.data[0]),
                (pargam.checkedUserArr = data.bindinf || []);
              console.log('打开1', pargam)
              // 联系人控件-选项联动，勾选数据显示
              if(data.type === 'relation-user' && data.dataShow && fromBtn !== 'orgBtn'){
                  if(Number(data.maxCount) <= data.bindinf.length){
                    this.$message.warning('最多只能选择' + data.maxCount + '人员');
                    return
                  }
                  if(items){
                    let detailRef = this.detailTitle + 'table';
                    if(fromBtn && fromBtn === 'defaultSearch'){
                      // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
                      this.$refs[detailRef][0].showUserList(data, res.data[0], {channel: 'linked'}, searchKey);
                    }
                    else{
                      this.$refs[detailRef][0].showUserList(data, res.data[0], {channel: 'linked'});
                    }
                  }
                  else{
                    let relationUserRef = "relationUserRef_" + data.title;
                    let linkedDropDownRef = "linkedDropDownRef_" + data.title;
                    const el = this.$refs[relationUserRef][0]
                    if(fromBtn && fromBtn === 'defaultSearch'){
                      // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
                      this.$refs[linkedDropDownRef][0].getList(data, res.data[0], {channel: 'linked', parentDiv: el}, '', searchKey);
                    }
                    else{
                      this.$refs[linkedDropDownRef][0].getList(data, res.data[0], {channel: 'linked', parentDiv: el});
                    }
                  }
              }
              else{
                this.$refs.multipleChoiceRef.multipleChoiceMethod(pargam);
              }
            });
          } else {
            console.log('打开2', pargam)
            this.$refs.multipleChoiceRef.multipleChoiceMethod(pargam);
          }
          return false;
        }
      }
      //角色获取
      if (data.lookRMSIsUserRole) {
        param.isLookRole = data.lookRMSIsUserRole;
        //自定义
        if (data.lookRMSIsUserRole == 1) {
          //所在角色
          param.JsonDataRole = { selfrole: 1, pid: -1 };
          param.leafRole = true;
        } else if (data.lookRMSIsUserRole == 3) {
          //如果没有选择自定义角色默认为无
          param.lookCustomArrRole = data.lookCustomArrRole || [];
        } else if (data.lookRMSIsUserRole == 4) {
          param.isrole = true;
        }
      } else {
        param.isrole = true;
      }
      if (data.maxCount) {
        param.maxCount = data.maxCount
      }
      // 组织控件
      if(data.type == 'organization'){
        param.isuser = 'true'
        param.isrole = 'true'
        param.onlyUser = false //只选用户
        param.lookRMSIsOrg = data.lookRMSIsOrg
        delete param.showBatch;
        console.log("data.singleIsOrg",data.singleIsOrg)
        // 组织设置,只能选择一个组织，最大可选数改成1
        if(data.singleIsOrg === 0) param.maxCount = 1
        else param.maxCount = data.maxCount
        // 组织查看范围选择全部组织的时候，传入可选择标签值
        if (data.lookRMSIsOrg === 2) param.orgEqual = true
        else if (data.lookRMSIsOrg === 3 || data.lookRMSIsOrg === 4) param.orgLabel = data.orgLabel
        // 自定义，传入后台已选择的组织，不调接口
        if (data.lookRMSIsOrg === 4) {
          param.lookCustomArr = data.lookCustomArr
        }
      }      
      param.isapiurl = "/openapi";
      console.log('角色获取', param, data)      
      console.log('打开3', param)    
      // 角色控件
      if(data.type == 'roule'){
        let schoolConfigs = localStorage.getItem('schoolConfigs')
        param.isuser = true
        param.isorgs = true
        param.onlyUser = false //只选用户
        param.isShowspace = schoolConfigs.space
        delete param.showBatch;
        // 组织设置,只能选择一个组织，最大可选数改成1
        if(data.singleIsRoule === 0) param.maxCount = 1
        else param.maxCount = data.maxCount
        
      }
      console.log('打开联系人控件情况', data.type == 'roule' && data.lookRMSIsUserRole == 2)
      // 联系人控件-查找优化
      if(data.type === 'relation-user' && data.dataShow && fromBtn !== 'orgBtn'){
        if(Number(data.maxCount) <= data.bindinf.length){
          this.$message.warning('最多只能选择' + data.maxCount + '人员');
          return
        }
        if(items){
          let detailRef = this.detailTitle + 'table';
          if(fromBtn && fromBtn === 'defaultSearch'){
            // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
            this.$refs[detailRef][0].showNewUserList(data, {channel: 'newList'}, searchKey);
          }
          else{
            this.$refs[detailRef][0].showNewUserList(data, {channel: 'newList'});
          }
          
        }
        else{  
          let relationUserRef = "relationUserRef_" + data.title;
          let linkedDropDownRef = "linkedDropDownRef_" + data.title;
          const el = this.$refs[relationUserRef][0]          
          if(fromBtn && fromBtn === 'defaultSearch'){
            // if (searchKey == '') return this.$message.warning('请输入您要搜索的人员！')
            this.$refs[linkedDropDownRef][0].getNewList(data, {channel: 'newList', parentDiv: el}, '', searchKey);            
          }
          else{
            this.$refs[linkedDropDownRef][0].getNewList(data, {channel: 'newList', parentDiv: el});
          }
        }
      }
      // 选择角色控件，并且角色查看范围设置位全部角色（调用平台角色+空间角色弹窗）
      else if(data.type == 'roule' && data.lookRMSIsUserRole == 2){
        delete param.onlyUser
        param.curHigh = this.isSpace ? 3 : 1
        this.$refs.allMultipleChoiceRef.multipleChoiceMethod(param, data);
        this.isMultipleChoice = true;
      }
      else{
        if (Object.prototype.hasOwnProperty.call(data, 'relationMoreTag')) {
          param.relationMoreTag = data.relationMoreTag
        }
        this.$refs.multipleChoiceRef.multipleChoiceMethod(param, data);
        this.isMultipleChoice = true;
      }      
    },
    //联系人控件。组织架构和角色返回
    fromMultipleChoice(param) {
      this.orgChoiceMethod(param);
      this.isMultipleChoice = false;
    },
    //联系人控件快速录入的回调
    userCheckCallback(param){
      this.relationUserDataO = param.data
      const obj = {
        checkedUserArr: param.user
      }
      this.orgChoiceMethod(obj)
      this.linkedWd = {}
    },
    // 明细快速联系人回调
    detailsChoiceUers(param){
      // console.log(param);
      this.relationUserDataO = param.data
      this.relationUserDataO.finx = param.finx
      this.relationUserDataO.indexs = param.indexs
      this.linkedDetailsKey = param
      this.orgChoiceMethod(param)
    },
    //回调
    async orgChoiceMethod(resUser, i) {
      console.log(resUser);
      console.log(this.relationUserDataO);
      // return
      //i =1来源于oaExamineInput重新提交页面渲染1来源于oaExamineInput重新提交页面渲染
      //*********流程设置告知人*********//
      if (!i) {
        let valArr = [];
        // 联系人控件
        if (Object.prototype.hasOwnProperty.call(resUser, 'checkedUserArr')) {
          let moreInfoArr = []
          if (this.relationUserDataO.isMoreInfo && this.relationUserDataO.moreInfoArr.length > 0) { // 是否提交用户更多的信息
            moreInfoArr = this.relationUserDataO.moreInfoArr
          }
          if (resUser.checkedUserArr.length > 0 && moreInfoArr.findIndex(item => { return item.search('部门：') !== -1 }) !== -1) {
            const userIds = resUser.checkedUserArr.map(item => { return item.userId })
            const { code, data } = await getuserbindlistmsg({ userIds: userIds.join(',') })
            if (code === 0) {
              resUser.checkedUserArr = data
            }
          }
          let bindfieldList = Array.from(new Set(this.relationUserDataO.bindfieldList || [])) // 有绑定这个联系人的控件
          resUser.checkedUserArr.forEach(el => {
            let elObj = {
              realname: el.realname,
              userId: el.userId
            };
            // 如果有组织信息
            if (el.orgname || el['部门']) elObj.orgname = el.orgname || el['部门']
            if (el.orglst) elObj.orglst = el.orglst
            moreInfoArr.forEach(key => {
              if (elObj[key] === undefined && el[key] !== undefined) {
                if (key === 'phone') { // 手机的话把真实手机号也提交上来
                  elObj.realphone = el.realphone
                } else if (key === 'type') {
                  elObj.userTip = resUser.userLabel ? resUser.userLabel[el[key]] : {}
                }
                elObj[key] = el[key]
              }
            })
            valArr.push(elObj);
          });
          // 如果存在 finx 说明是明细过来的,finxType 为明细的key，
          if (this.relationUserDataO.finxType) {
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata[this.relationUserDataO.finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[this.relationUserDataO.finxType][this.relationUserDataO.indexs][types] = valArr
          } else if (
            this.relationUserDataO.finx ||
            this.relationUserDataO.finx === 0
          ) {
            let finxList = this.ruleListChild[this.relationUserDataO.finx];
            let finxType = finxList.title + "_" + finxList.type;
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            if (bindfieldList && bindfieldList.length > 0) {
              this.detailsUserSetData(bindfieldList, finxList, resUser.checkedUserArr)
            }
            // this.$set(this.formdata[finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[finxType][this.relationUserDataO.indexs][
              types
            ] = valArr;
          } else {
            if (bindfieldList && bindfieldList.length > 0) {
              this.userSetData(bindfieldList, this.ruleListChild, resUser.checkedUserArr)
            }
            let datas = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata, datas, valArr)
            this.formdata[datas] = valArr;
          }
          //过滤表单外层。明细，单选关联
        }
        // 组织控件
        else if(Object.prototype.hasOwnProperty.call(resUser, 'checkedFlowArr')){
          resUser.checkedFlowArr.forEach(el => {
            let elObj = {
              name: el.name,
              organizationId: el.organizationId,
              looktype: el.looktype || 0,
              type: el.type
            };
            valArr.push(elObj);
          });
          // 如果存在 finx 说明是明细过来的,finxType 为明细的key，
          if (this.relationUserDataO.finxType) {
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata[this.relationUserDataO.finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[this.relationUserDataO.finxType][
              this.relationUserDataO.indexs
            ][types] = valArr;
          } else if (
            this.relationUserDataO.finx ||
            this.relationUserDataO.finx === 0
          ) {
            let finxList = this.ruleListChild[this.relationUserDataO.finx];
            let finxType = finxList.title + "_" + finxList.type;
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata[finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[finxType][this.relationUserDataO.indexs][
              types
            ] = valArr;
          } else {
            let datas = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata, datas, valArr)
            this.formdata[datas] = valArr;
          }
          //过滤表单外层。明细，单选关联
        }
        // 角色控件
        else if(Object.prototype.hasOwnProperty.call(resUser, 'checkedRoleArr')){
          resUser.checkedRoleArr.forEach(el => {
            let elObj = {
              name: el.name,
              roleId: el.roleId
            };
            valArr.push(elObj);
          });
          // 如果存在 finx 说明是明细过来的,finxType 为明细的key，
          if (this.relationUserDataO.finxType) {
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata[this.relationUserDataO.finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[this.relationUserDataO.finxType][
              this.relationUserDataO.indexs
            ][types] = valArr;
          } else if (
            this.relationUserDataO.finx ||
            this.relationUserDataO.finx === 0
          ) {
            let finxList = this.ruleListChild[this.relationUserDataO.finx];
            let finxType = finxList.title + "_" + finxList.type;
            let types = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata[finxType][this.relationUserDataO.indexs], types, valArr)
            this.formdata[finxType][this.relationUserDataO.indexs][
              types
            ] = valArr;
          } else {
            let datas = this.relationUserDataO.title + "_" + this.relationUserDataO.type;
            // this.$set(this.formdata, datas, valArr)
            this.formdata[datas] = valArr;
          }
          //过滤表单外层。明细，单选关联
        }   
      } else {
        this.relationUserDataO = resUser;
      }
      if (this.ruleListChildType == 3) {
        //- 如果是关联单选
        this.$emit("linkageMethEmit", null, this.relationUserDataO, 0);
      } else {
        //- 联系人控件联动功能
        //如果是明细联动，需要走到明细里面去,然后需要循环获取模板，获取当前点击的这个联系人
        if (this.linkedDetailsKey && this.linkedDetailsKey.finxType) {
          let linkedDetailsKey = { ...this.linkedDetailsKey };
          this.linkedDetailsKey = null;
          this.linkageMethEach(
            this.ruleListChild[linkedDetailsKey.finx].list,
            this.relationUserDataO,
            0,
            { key: linkedDetailsKey.finxType, index: linkedDetailsKey.indexs }
          );
        } else {
          if (!i) {
            this.linkageMeth(this.ruleListChild, this.relationUserDataO);
          }
        }
      }
      this.approvalProcess(this.relationUserDataO);
    },
    // 普通的1级控件联系人控件选择回调填值
    userSetData (bindfieldList, filedList, checkedUserArr) {
      const userInfoKeys = {
        '姓名': 'realname',
        '登录名': 'username',
        '联系电话': 'realphone',
        '出生日期': 'birthday',
        '身份证': 'realidcard',
        '性别': 'sex'
      }
      let userInfo = checkedUserArr.length > 0 ? checkedUserArr[0] : {} // 选择的用户要是多个就返回第一人的信息

      bindfieldList.forEach(async item => {
        // 跟绑定的那个控件做个匹配
        const fliedIndex = filedList.findIndex(ruleItem => { return `${ruleItem.title}_${ruleItem.type}` === item})
        if (fliedIndex !== -1) {
          const flied = filedList[fliedIndex]
          // 两边不匹配就返回
          if (flied.bindfieldKey !== `${this.relationUserDataO.title}_${this.relationUserDataO.type}`) return false
          const bindfield = flied.bindfield // 要回填的字段
          // 联动出来的没有该字段 去请求一下
          let looktype = 0
          delete userInfo['部门：班级']
          let resData = {}
          if (userInfo.userId && userInfo[bindfield] === undefined && userInfo[userInfoKeys[bindfield]] === undefined) {
            const res = await getnewuserbindmsg({ userId: userInfo.userId })
            resData = res.data
            const info = JSON.parse(JSON.stringify(res.data))
            for (const key in res.data) {
              if (key === '部门：班级' && res.data[key][0]) {
                looktype = res.data[key][0].looktype
              }
              if (key.includes('部门')) {
                if (res.data[key][0]) {
                  info[key] = res.data[key][0].name
                } else {
                  info[key] = ''
                }
              }
            }
            userInfo = info
          }
          let data = userInfo[bindfield] ? userInfo[bindfield] : userInfo[userInfoKeys[bindfield]] 
          if (bindfield === '性别') {
            data = data === 1 ? '女' : '男'
          }
          if (data && typeof data === 'string' && data.search('userfiles') !== -1) {
            data = this.$url + data.replace('userfiles', 'conflies')
          }
          let bindnewFiled = flied.bindnewFiled
          if (bindnewFiled && bindnewFiled[1] && isStandardClass(data, 'class')) {
            data = getClassInfo(data, bindnewFiled[1], looktype)
          }
          if (item.includes('organization')) {
            data = resData['部门']
          }
          // 针对单行输入框、单选框，只传组织名称
          if (Array.isArray(data) && (item.includes('text') || item.includes('radio'))) {
            data = data[0].name
          }
          // 走这边
          // this.$set(this.formdata, item, data)
          this.formdata[item] = data
          this.linkageInitiali(fliedIndex)
        }
      })
      
    },
    // 明细内的联系人控件选择回调填值
    detailsUserSetData (bindfieldList, details, checkedUserArr) {
      const detailsList = details.list
      const detailsKey = `${details.title}_${details.type}`
      const userInfoKeys = {
        '姓名': 'realname',
        '登录名': 'username',
        '联系电话': 'realphone',
        '出生日期': 'birthday',
        '身份证': 'realidcard',
        '性别': 'sex'
      }
      bindfieldList.forEach(async item => {
        const fliedIndex = detailsList.findIndex(ruleItem => { return `${ruleItem.title}_${ruleItem.type}` === item})
        if (fliedIndex !== -1) {
          const flied = detailsList[fliedIndex]
          // 两边不匹配就返回
          if (flied.bindfieldKey !== `${this.relationUserDataO.title}_${this.relationUserDataO.type}`) return false
          let userInfo = checkedUserArr.length > 0 ? checkedUserArr[0] : {} // 选择的用户要是多个就返回第一人的信息
          const bindfield = flied.bindfield // 要回填的字段
          // 联动出来的没有该字段 去请求一下
          let looktype = 0
          delete userInfo['部门：班级']
          let resData = {}
          if (userInfo.userId && userInfo[bindfield] === undefined && userInfo[userInfoKeys[bindfield]] === undefined) {
            const res = await getnewuserbindmsg({ userId: userInfo.userId })
            const info = JSON.parse(JSON.stringify(res.data))
            resData = res.data
            for (const key in res.data) {
              if (key === '部门：班级' && res.data[key][0]) {
                looktype = res.data[key][0].looktype
              }
              if (key.includes('部门')) {
                if (res.data[key][0]) {
                  info[key] = res.data[key][0].name
                } else {
                  info[key] = ''
                }
              }
            }
            userInfo = info
          }
          let data = userInfo[bindfield] ? userInfo[bindfield] : userInfo[userInfoKeys[bindfield]] 
          if (bindfield === '性别') {
            data = data === 1 ? '女' : '男'
          }
          if (data && data.search('userfiles') !== -1) { // 图片地址全改成conflies去访问
            data = this.$url + data.replace('userfiles', 'conflies') 
          }
          const bindnewFiled = flied.bindnewFiled
          if (bindnewFiled && bindnewFiled[1] && isStandardClass(data, 'class')) {
            data = getClassInfo(data, bindnewFiled[1], looktype)
          }
          if (item.includes('organization')) {
            data = resData['部门']
          }
          if (Array.isArray(data)) {
            data = data[0].name
          }
          // this.$set(this.formdata[detailsKey][this.relationUserDataO.indexs], item, data)
          this.formdata[detailsKey][this.relationUserDataO.indexs][item] = data
        }
      })
    },
    //删除
    handleCloseFlow(res, index, type, linkedDetailsKey) {
      console.log("handleCloseFlow==",res, index, type, linkedDetailsKey)
      // let resData = null;
      if (res.exhibiIs) {
        //展示控件不允许修改
        return false;
      }
      // finx 存在说明是明细过来删除
      if (res.finx || res.finx === 0) {
        let finxType =
          this.ruleListChild[res.finx].title +
          "_" +
          this.ruleListChild[res.finx].type;
        let type = res.title + "_" + res.type;

        this.formdata[finxType][res.indexs][type].splice(index, 1);
        // resData = this.formdata[finxType][res.indexs][type];
        //联系人删除联动
        this.linkageMethEach(this.ruleListChild[res.finx].list, res, 0, {
          key: finxType,
          index: res.indexs
        });
      } else {
        let type = res.title + "_" + res.type;

        this.dataParenTy = type; //区分明细。关联单选控件。
        this.formdata[type].splice(index, 1);
        // resData = this.formdata[type];
        //联系人删除联动
      }
      this.approvalProcess(res);
    },
    // 图片编辑上传
    selectChange (file, fileList, item) {    
      let type = item.title + "_" + item.type;
      const { raw, name } = file;
      this.fileName = name;
      this.clipList = this.formdata[type];
      this.option.autoCropWidth = Number(item.imgSet.width);
      this.option.autoCropHeight = Number(item.imgSet.height)
      this.option.fixedNumber = [Number(item.imgSet.width), Number(item.imgSet.height)]
      if(item.imgSet.radio == "1"){
        this.option.fixedBox = true;
      }
      else{
        this.option.fixedBox = false;
      }
      this.openCropper(raw);
      let uploadRef = "uploadImgSet_" + item.title;
      this.uploadRef = "uploadImgSet_" + item.title;
      this.$refs[uploadRef][0].handleRemove(file)
    },
    openCropper (file) {
      var files = file;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG && !isPNG && !isGIF) {
        this.clipListLength -= 1;
        this.upDataFileImgSet = true;
        this.$message.error("上传图片只能是 jpeg/png/gif 格式!");
        return false;
      }
      if (!isLt2M) {
        this.clipListLength -= 1;
        this.upDataFileImgSet = true;
        this.$message.error("上传图片大小不能超过 5MB!");
        return false;
      }
      var reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        this.option.img = data;
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(files);
      this.clipVisible = true;
    },
    // 关闭图片编辑
    clipClose(){      
      let type = this.ruleListChild[this.indexNumber].title + "_" + this.ruleListChild[this.indexNumber].type;
      console.log("this.indexNumber==",this.indexNumber);
      console.log("type==",type);
      this.formdata[type] = fileListForeach(this.clipList);
      this.clipVisible = false;
      this.upDataFileImgSet = true;
    },
    // 重新选择要编辑的图片
    updateCropper () {
      const uploadComponent = this.$refs[this.uploadRef][0];
      if (uploadComponent && uploadComponent.$el) {
        const fileInput = uploadComponent.$el.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.click();
        }
      }
    },
    // 保存编辑图片
    yesCrop () {
      let self = this;
      self.$refs.cropper.getCropBlob((data) => {
        self.imgBlod = data;
        let formdata1 = new FormData();// 创建form对象
        formdata1.append('file', self.imgBlod, self.fileName);
        let config = {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true
        };
        Axios.post("/userfile/upload?accesstoken="+this.token, formdata1, config).then(res => {
          self.upDataFileImgSet = true;
          //图片裁剪上传成功
          let clipList = []
          if (res.data && res.data !== '') {
            let type = self.ruleListChild[self.indexNumber].title + "_" + self.ruleListChild[self.indexNumber].type;
            console.log(JSON.stringify(self.formdata[type]));
            clipList = self.formdata[type]
            clipList.push({
              name: self.fileName,
              response: res.data,
              url: window.URL.createObjectURL(self.imgBlod)
            });
            self.formdata[type] = fileListForeach(clipList);
            self.clipVisible = false;
            self.clipListLength = self.clipListLength - 1;
            if (self.clipListLength == 0) {
              self.upDataFileImgSet = true;
            }
          }
        }).catch(error => {
          self.upDataFileImgSet = true;
          console.log(error)
        })
      })
    },
    // 限制图片上传数量
    handleExceed(file, fileList, item){
      console.log("fileListfileList==",fileList)
      if (fileList.length >= Number(item.upNumber)) {
        this.$message.error('最多只能上传' + item.upNumber + '张图片！');
        return false;
      }
    },
    //图片上传
    beforeImgUpload(file,item) {
      this.fileListLength += 1;
      this.upDataFile = false;
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGIF = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (item.takePic) {
        this.fileListLength -= 1;
        this.upDataFile = true;
        this.$message.error("无法通过电脑拍照，请通过手机端进行使用");
        return false;
      }
      if (!isJPG && !isPNG && !isGIF) {
        this.fileListLength -= 1;
        this.upDataFile = true;
        this.$message.error("上传图片只能是 jpeg/png/gif 格式!");
      }
      if (!isLt2M) {
        this.fileListLength -= 1;
        this.upDataFile = true;
        this.$message.error("上传图片大小不能超过 5MB!");
      }
      return (isJPG && isLt2M) || (isPNG && isLt2M) || (isGIF && isLt2M);
    },
    //附件上传
    beforeFileUpload(file, config) {
      console.log('上传格式判断', file, config, fileFormatted(file.name, config.fileDocument))
      if (!fileFormatted(file.name, config.fileDocument)) {
        const err = config.fileDocument ? (config.fileDocument === 'video' ? '视频' : config.fileDocument === 'html' ? '展示' : '音频') : '正确的'
        this.$message.error(`请上传${err}格式!`);
        return false;
      }
      const count = file.size / 1024 / 1024
      const upSize = config.maxSize || 200
      if (count > upSize) {
        this.$message.error("上传附件大小不能超过" + upSize + "MB!");
        return false
      }
      // if (file.size / 1024 / 1024 > 200) {
      //   this.$message.error("上传附件大小不能超过200MB!");
      //   return false;
      // }
      this.fileListLength += 1;
      this.upDataFile = false;
    },
    //附件删除
    beforeRemove() {},
    //鼠标经过获取下标值。删除用
    listCliRemo(index) {
      this.removeIndN = index;
    },
    //点击获取当前下表
    listCli(index, config, val) {
      if (this.upDataFile) {
        if (config && config.upNumber <= val.length) {
          this.$message.error('最多只能上传'+ config.upNumber + '个文件！')
          return
        }

        this.indexNumber = index;
      } else {
        this.$message({
          message: "上传中，请稍等...",
          type: "warning"
        });
        return false;
      }
    },
    // 清空签名板
    handleReset () {
      this.$refs.esign.reset()
    },
    // 点击签名
    showSigna(val){
      // 新增：图片上传数量限制
      const type = val.title + '_' + val.type;
      const curList = this.formdata[type] || [];
      if (curList.length >= Number(val.upNumber)) {
        this.$message.error('最多只能上传' + val.upNumber + '张图片！');
        return false;
      }      
      // 调用webSocket
      webSocketClass.url = "wss://user.topeti.com/webmessage";
      webSocketClass.msgCallback = this.websocketMessageHandler.bind(this);
      webSocketClass.connect('立即与服务器通信');      
      this.indexString = val
      this.uploadSignStatus = val.uploadSign
    },
    websocketMessageHandler(e) {      
      if(e.action === "connected"){
        let userAgent
        if (navigator && navigator.userAgent) {
          userAgent = navigator.userAgent;
        }
        this.vueqrval = this.$url + "/cust/sign/index.html?code="+e.msg.token+'&accesstoken='+this.token+'&userAgent='+encodeURIComponent(userAgent)
        this.signaVisible = true
        console.log("this.vueqrval==",this.vueqrval);
      }
      else if(e.action === "upload"){
        let type = this.indexString.title + "_" + this.indexString.type
        let signList = this.formdata[type]
        signList.push({response: e.msg.url})
        this.formdata[type] = fileListForeach(signList)
        this.signaVisible = false
      }
    },
    // 删除签名
    deleteSign(val,item){
      console.log(val,item);
      let type = item.title + "_" + item.type
      let signList = this.formdata[type];
      signList = signList.filter(value => {
        return value.response != val.response
      });
      this.formdata[type] = signList;
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    // 上传签名
    uploadSign() {
      const fileInput = document.getElementById('upload-file');
      const file = fileInput.files[0];
      const fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
      if (fileExtension === 'png') {
        const formData = new FormData()
        formData.append("file", file)
        let url = '/userfile/upload?accesstoken='+this.token
        let config = {
          headers:{
            'Content-Type':'multipart/form-data',
          },
        };
        let type = this.indexString.title + "_" + this.indexString.type
        Axios.post(url, formData, config)
          .then(res => {
            if(res.data){
              let signList = this.formdata[type]
              signList.push({response: res.data})
              this.formdata[type] = fileListForeach(signList)
              this.signaVisible = false
            }
          }).catch(err => {
            console.log('图片上传错误', err)
        })
      } else {
        // 提示用户选择正确格式的文件
        this.$message.error('上传签名图片必须为.png格式')
        return 
      }
    },
    // 签名生成图片
    async upSigna() {        
      this.$refs.esign.generate().then(res => {
        const loading = this.$loading({
          lock: true,
          text: '签名上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.1)'
        });
        const blob = this.base64ImgtoFile(res,'name')
        const name = 'name.png'
        const file = new File([blob], name, {
          type: 'image/png'
        })
        const formData = new FormData()
        formData.append("file", file)
        let url = '/userfile/upload?accesstoken='+this.token
        let config = {
          headers:{
            'Content-Type':'multipart/form-data',
          },
        };
        let type = this.indexString.title + "_" + this.indexString.type

        Axios.post(url, formData, config)
          .then(res => {
            if(res.data){
              // 外网访问不存在token，下列代码会报错，先隐藏
              // this.token = JSON.parse(localStorage.getItem('user')).accesstoken
              let signList = this.formdata[type]
              signList.push({response: res.data})
              this.formdata[type] = fileListForeach(signList)
              this.signaPic = true
              loading.close()
              this.signaVisible = false
              this.$refs.esign.reset()
            }
          }).catch(err => {
            console.log('图片上传错误', err)
        })
      }).catch(err => {
        // 画布没有签字时提示
        this.$message.error('您还没有签名',err)
      })
    },
    //图片上传
    handleProgress(file) {
      // 过滤掉文件名里面的 # 号
      if (file.name) {
        file.name = file.name.replace(/^#+|#|#+$/g, "");
      }
      this.upDataFile = false;
    },
    //图片，附件上传打开本地文件夹
    handlePreview(file) {
      filePreview({url: file.url ? file.url : file.response})
    },
    //图片，附件上传。上传成功
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList)
      let type = this.ruleListChild[this.indexNumber].title + "_" + this.ruleListChild[this.indexNumber].type;
        // console.log('fileList',fileList);
      this.formdata[type] = fileListForeach(fileList);
      //每次上传你在这里砖掉了，这里返回格式正确的是[{url:'',name:'',response:''}] 然后提交的时候，统一处理成['23234','123123'],其实提交你有改格式了
      this.fileListLength = this.fileListLength - 1;
      if (this.fileListLength == 0) {
        this.upDataFile = true;
      }
      // 固定画布的提交和修改有联动修改他表的功能 类似前端公式的等于
      if (this.isFiexdCanvas && this.ruleListChild[this.indexNumber]) {
        this.$emit('updateOtherAppData', this.ruleListChild[this.indexNumber], this.formdata[type])
      }
    },
    //图片,附件删除
    handleRemove(file, fileList) {
      let type =
        this.ruleListChild[this.removeIndN].title +
        "_" +
        this.ruleListChild[this.removeIndN].type;
      this.formdata[type] = fileList;
    },
    handleError() {
      this.fileListLength = this.fileListLength - 1;
      this.upDataFile = true;
    },
    // 返回文件类型
    fileType(item){
      item = JSON.parse(JSON.stringify(item))
      item.url = item.url || item.response
      // 对文件名的特殊字符转码
      let tempUrlList = item.url.split('/')
      let tempUrl = tempUrlList[tempUrlList.length - 1].split('.')
      // 文件类型
      let fileType = tempUrl.pop()
      return fileType
    },
    //附件预览
    file_pvw(item) {
      let type = this.fileType(item)
      console.log(type)
      filePreview(item)
    },
    // 打开新窗口预览文件
    toPreview(item){
      item = JSON.parse(JSON.stringify(item))
      if(!item.url){
        item.url = this.$apiurl + item.response
      }
      // 如果没有路径，就是错误
      if (!item.url) { 
        this.$message.error('文件路径错误，请确认配置信息')
        return 
      }
      const routeUrl = this.$router.resolve({
        path: '/previewFile',
        query: {
          url: item.url
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    //提交数据
    widgetOneLayerPullData(res) {
      //执行了这个方法则表示当前已经点过提交了
      this.isOne = true;
      //res=false是不需要验证的，为1是需要验证的
      let isCheck = 1; //数据校验
      if (res) {
        isCheck = this.ruleListChilDcheckData(
          this.ruleListChild,
          this.modifyId
        );
      }
      // 单选其他，有的话值插入(从这里开始 formdata 另存出来，因为操作赋值的是他)
      let formdata = othersRed(
        this.ruleListChild,
        copyObj(this.formdata),
        this.othersObj
      );
      // 获取关联单选提交后隐藏
      let linkedMessageArr = [];
      for (let i in this.userHide) {
        if (Array.isArray(this.userHide[i])) {
          let userHideArr = this.userHide[i];
          userHideArr.forEach(items => {
            for (let a in items) {
              if (items[a]){
                // 2023.9.15 龙岩教育局bug。新版关联控件，点击关联表单选择数据提交的时候，传的是明细控件的title，谭说这边要传的应该是当前子控件（新版关联）的title，先这么改看看
                if(a !== items[a].title){
                  items[a].title = a
                }
                linkedMessageArr.push(items[a]);
              }
            }
          });
        } else {
          linkedMessageArr.push(this.userHide[i]);
        }
      }
      this.linkedMessageArr = unique(linkedMessageArr, "linkedApprovingId");
      // 提交检查格式
      for (const key in formdata) {
        if ((key.includes('relation-user') || key.includes('organization') || key.includes('roule')) && !formdata[key]) {
          formdata[key] = []
        }
      }
      const param = {
        isCheck: isCheck,
        dataList: formatConversion(
          formdata,
          widgetJs.associationVisibleMassaging(this.associationVisible)
        ), // 提交格式字符串化
        linkedMessageArr: this.linkedMessageArr
      };
      // 是否同步关于我的值计算
      let relWyArr = countRule(this.ruleListChild, this.formdata, []);
      if (relWyArr.length > 0) {
        param.relWyArr = relWyArr;
      }

      //是否同步关于我的
      // if (this.isInformRelWyArr.length > 0) {
      //   param.relWyArr = this.isInformRelWyArr;
      // }
      return param;
    },
    //校验数据
    ruleListChilDcheckData(data, modifyId) {
      //modifyId修改
      let isCheck = 1;
      const dataO = widgetJs.ruleListChilDcheckData({
        date: data,
        formdata: this.formdata,
        othersObj: this.othersObj,
        modifyId: modifyId,
        associationVisible: widgetJs.associationVisibleMassaging(
          this.associationVisible
        )
      });
      console.log('校验数据结果', dataO)
      if (dataO.name) {
        //跳转到未填写位置  scrollIntoView
        try {
          // document.getElementsByClassName(dataO.title)[0].scrollIntoView();
        } catch (error) {
          console.log("位置跳转错误");
        }

        let errText = "";
        if (dataO.errormsg) {
          //- 正则错误显示会走这里
          errText = dataO.errormsg;
        } else if (dataO.cardText) {
          errText = dataO.name + dataO.cardText;
        } else if (
          (dataO.miniunm &&
            dataO.miniunm !== 0 &&
            dataO.valbindinf < dataO.miniunm) ||
          (dataO.miniunm &&
            dataO.miniunm !== 0 &&
            dataO.miniunm !== "-Infinity" &&
            !dataO.valbindinf)
        ) {
          errText = `${dataO.name}不能少于${dataO.miniunm}字`;
        } else if (
          dataO.sizeLimit &&
          dataO.sizeLimit !== 0 &&
          dataO.sizeLimit !== "Infinity" &&
          dataO.valbindinf > dataO.sizeLimit
        ) {
          errText = `${dataO.name}不能大于${dataO.sizeLimit}字`;
        } else {
          errText = `${dataO.name}不能为空`;
        }
        if (errText) {
          if (dataO.errorRow)
            errText = `${dataO.errorTitle} 第${dataO.errorRow}行 ${errText}`;
          this.$message.error(errText);
        }

        isCheck = 2;
      } else {
        isCheck = 1;
      }
      return isCheck;
    },
    //数据提交构造
    ruleListChilDStructure(data, isType) {
      //isType=1外层，2明细，3单选关联，4新关联控件
      var newRel = 1;
      let ruleForm = {};
      let ruleFormKey = [];
      let ruleList = [...data];
      if (isType == 3) {
        const key = data.title + "_" + data.type;
        ruleForm[key] = data.bindinf;
        ruleFormKey.push(key);
        ruleList = [...data.list];
      }
      ruleList.forEach((el) => {
        var data = el.bindinf; //获取结果值
        if (el.type == "checkbox") {
          var checkVal = el.bindinf;
          data = JSON.stringify(checkVal);
          if (isType == 3) {
            data = JSON.parse(data);
          }
        } else if (el.type == "image" || el.type == "file") {
          if (el.bindinf.length > 0) {
            var imgArr = el.bindinf;
            var imgList = [];
            imgArr.forEach(e => {
              imgList.push(e.response);
            });
            data = JSON.stringify(imgList);
          } else {
            data = "[]";
          }
        } else if (el.type == "number") {
          data = el.defaultValue === undefined ? "" : el.defaultValue; //获取结果值
        } else if (el.type == "relation-radio") {
          data = this.ruleListChilDStructure(el, 3);
          if (isType == 1) {
            data = JSON.stringify(data);
          }
        } else if (el.type == "new-rel-radio") {
          let newRelO = {};
          const key = el.title + "_" + el.type;
          newRelO[key] = el.bindinf;
          const dataRet = this.ruleListChilDStructure(el.list, 1);
          data = Object.assign(newRelO, dataRet);
          newRel = 2;
          if (el.datahided == 2 && el.linkedMessageParam) {
            this.linkedMessageArr.push(el.linkedMessageParam);
          }
        } else if (el.type == "relation-user") {
          //是否同步关于我的
          if (el.isInformRelWy == 2 && el.bindinf.length > 0) {
            this.isInformRelWyArr = this.isInformRelWyArr.concat(el.bindinf);
            var obj = {};
            this.isInformRelWyArr = this.isInformRelWyArr.reduce(
              (item, next) => {
                obj[next.userId]
                  ? ""
                  : (obj[next.userId] = true && item.push(next));
                return item;
              },
              []
            );
          }
          if (el.bindinf && el.bindinf.length != 0) {
            var checkValA = el.bindinf;
            if (isType == 1) {
              data = JSON.stringify(checkValA);
            } else {
              data = checkValA;
            }
          }
        } else if (el.type == "details") {
          const dataArrArr = el.list;
          let detailsData = [];
          dataArrArr.forEach((el, index) => {
            const redData = this.ruleListChilDStructure(el, 2);
            if (dataArrArr.length == index + 1) {
              //最后一个把key值也保存起来
              detailsData.push(redData[0]);
              detailsData.push(redData[1]);
            } else {
              detailsData.push(redData[0]);
            }
          });
          data = JSON.stringify(detailsData);
        } else if (el.type == "ready-widget") {
          let detailsData = this.ruleListChilDStructure(el.list, 2);
          data = JSON.stringify(detailsData);
        }
        if (newRel == 2) {
          ruleForm[el.title + "_" + el.type] = data;
          for (let jd in data) {
            ruleForm[jd] = data[jd];
            ruleFormKey.push(jd);
          }
          newRel = 1;
        } else {
          ruleForm[el.title + "_" + el.type] = data;
          ruleFormKey.push(el.title + "_" + el.type);
        }
      });
      if (isType == 3 || isType == 2) {
        let arrData = [];
        arrData.push(ruleForm);
        arrData.push(ruleFormKey);
        return arrData;
      } else {
        return ruleForm;
      }
    },
    //联系人告知
    relCtoArrayCto() {
      const _this = this;
      var _conmiGtyn = _this => {
        var ctoArr = [];
        if (_this.ctoArrayChild.cto.length > 0) {
          _this.ctoArrayChild.cto.forEach(el => {
            if (!el.informRel) {
              ctoArr.push(el);
            }
          });
        }
        _this.ctoArrayChild.cto = [];
        _this.ctoArrayChild.cto = ctoArr.concat(_this.informRelCto);
      };
      var ctoArrLa = [];
      //分条件告知
      if (
        this.ctoArrayChild.workflow &&
        this.ctoArrayChild.workflow.length > 0
      ) {
        this.ctoArrayChild.workflow.forEach(res => {
          if (res.cto.length > 0) {
            var ctoArr = []; //- 获取到默认值
            const oldCto = [...res.cto];
            oldCto.forEach(el3 => {
              if (!el3.informRel) {
                ctoArr.push(el3);
              }
            });
            res.cto = [];
            ctoArrLa = ctoArr.concat(this.informRelCto);
            res.cto = ctoArrLa;
            _conmiGtyn(_this);
          } else {
            ctoArrLa = this.informRelCto;
            res.cto = ctoArrLa;
            _conmiGtyn(_this);
          }
        });
      } else {
        _conmiGtyn(_this);
      }
    },
    //四则运算 0 1 2 3 加减乘除
    arithmetic(item){
      console.log('四则运算', item)
      if(item.dataconfig && (item.type === 'number' || item.type === 'radio')) {
        let tmName = item.title + '_' + item.type
        let targetRes = this.ruleListChild.filter(item1 => item1.dataconfig && item1.dataconfig.formula && (item1.dataconfig.formula.allcontrols === tmName || item1.dataconfig && item1.dataconfig.formula && item1.dataconfig.formula.filterControls === tmName));
        for(let i = 0; i < targetRes.length; i++){
          let formulaRes = targetRes[i].dataconfig.formula
          let resName = targetRes[i].title + '_' + targetRes[i].type
          let oneName = Number(this.formdata[formulaRes.allcontrols]) || 0
          let twoName = Number(this.formdata[formulaRes.filterControls]) || 0
          if(formulaRes.operation === 0){
            this.formdata[resName] = (oneName + twoName).toFixed(4)
          }else if(formulaRes.operation === 1){
            this.formdata[resName] = (oneName - twoName).toFixed(4)
          }else if(formulaRes.operation === 2){
            this.formdata[resName] = (oneName * twoName).toFixed(4)
          }else{
            this.formdata[resName] = (oneName / twoName).toFixed(4)
          }
          this.arithmetic(targetRes[i])
        }
      }
    },
    // 定位控件值回传
    getLocationVal(data){
      this.formdata[data.item.title+'_' + data.item.type] = data.addressInfo
      console.log("this.formdata==",this.formdata)
    },
    // 人脸识别回填联系人控件数据
    faceToUserData(data){
      this.relationUserDataO = data
    },
    // 人脸识别跳过（因联动的时候会填值，如果用户点击跳过，则清空formdata值）
    faceToJump(){
      
    },
  },
  watch: {
    isOnes: {
      handler(val) {
        if (val) {
          this.isOne = true;
        }
      },
      deep: true
    },
    formdata:{
      handler() {
        if (this.isSubmit) {
          if (this.submitTimer) clearTimeout(this.submitTimer)
          this.submitTimer = setTimeout(() => {
            this.$emit('submit')
          }, 2000)
        }
        // 判断formdata中是否存在明细控件的是否填写选项
        for (const key in this.formdata) {
          if (key.endsWith('_fillStatus')) {
            // this.$set(this.fillStatusMap, key, Number(this.formdata[key]));
            this.fillStatusMap[key] = Number(this.formdata[key]);
          }
        }
      },
      deep: true,
      immediate: true
    },
    fillStatusMap: {
      handler(newVal) {
        for (const key in newVal) {
          if (key.endsWith('_fillStatus')) {
            this.formdata[key] = newVal[key];
          }
        }
      },
      deep: true
    },
    informRelCto: {
      handler() {
        this.relCtoArrayCto();
      },
      deep: true
    },
    upDataFile() {
      const param = {
        type: 4,
        upDataFile: this.upDataFile
      };
      this.$emit("widgetOneLayerEmit", param);
    }
  },
  beforeUnmount() {
    clearTimeout(this.restaurantsFun);
    this.restaurantsFun = null;
  }
};
</script>

<style lang="scss">
@import "../../../assets/css/oaExamineInputWidget.scss";
.time-zjy-widget-one-layer {
  .el-date-picker__time-header .el-date-picker__editor-wrap:nth-child(2) {
    display: none;
  }
  .el-picker-panel__footer {
    button:nth-child(1) {
      display: none;
    }
  }
}
.widget-one-layer-row {
  background-color: #ffffff;
  // padding-top: 11px;
  // padding-bottom: 11px;
}
.table-features {
  display: flex;
  align-items: center;
  height: 32px;
  position: relative;
}
.process .orgname span {
  margin-right: 10px;
  background: #eeeeee;
  padding: 4px 10px;
  color: #666;
  font-weight: normal;
  font-size: 12px;
  border-radius: 6px;
}

.label-line {
  // margin-top: 30px;
  margin-bottom: 20px;
  margin-left: -20px;
  margin-right: -20px;
}
.label-line-1 {
  border-bottom-color: #F9F9F9;
  // border-bottom-color: $base-border-bottom-color;
  border-bottom-width: 16px;
  position: relative;
  .label-line-1-t, .label-line-1-r, .label-line-1-b, .label-line-1-l {
    position: absolute;
    width: 10px;
    height: 10px;
    background-color: #F9F9F9;
    &::before {
      content: ' ';
      width: 10px;
      height: 10px;
      background-color: #ffffff;
      display: block;
    }
  }
  .label-line-1-t {
    left: 0;
    top: -10px;
     &::before {
      border-bottom-left-radius: 8px;
    }
  }
  .label-line-1-r {
    right: 0;
    top: -10px;
    &::before {
      border-bottom-right-radius: 8px;
    }
  }
  .label-line-1-b {
    left: 0;
    bottom: -26px;
    &::before {
      border-top-left-radius: 8px;
    }
  }
  .label-line-1-l {
    right: 0;
    bottom: -26px;
    &::before {
      border-top-right-radius: 8px;
    }
  }
}
.details-class .cell {
  margin-bottom: 0 !important;
}
:deep(.widget-one-layer .delClassName) {
  position: relative;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  .el-select__tags {
    align-items: center;
  }
}
.delClassName {
  background: #fff;
}
.widget-one-layer .delClass {
  border: 1px solid red !important;
  display: block;
}
// .widget-one-layer .input-details .el-input input:focus,
// .widget-one-layer .input-details textarea:focus,
// .widget-one-layer .input-details:hover .el-input input,
// .widget-one-layer .input-details .is-focus input:nth-child(1),
// .widget-one-layer .input-details:hover textarea {
//   transition: all 0.3s;
//   border: 1px solid #4e86ff !important;
// }
// vue3 版本
.widget-one-layer .input-details textarea,
.widget-one-layer .input-details .el-input__wrapper,
.widget-one-layer .input-details .el-select__wrapper,
.widget-one-layer .select-details .el-select__wrapper {
  transition: all 0.3s;
}
.widget-one-layer .input-details:hover textarea,
.widget-one-layer .input-details:hover .el-input__wrapper,
.widget-one-layer .input-details:hover .el-select__wrapper,
.widget-one-layer .select-details:hover .el-select__wrapper {
  box-shadow: 0 0 0 1px #4e86ff !important;
}

.el-input--large .el-input__wrapper {
  padding: 1px 10px;
}

.widget-one-layer .input-details textarea {
  padding: 5px 10px;
}

.el-select--large .el-select__wrapper {
  padding: 3px 7px !important;
}

.form-class .el-select .el-tag {
  height: 30px;
}
.form-class .el-select .el-tag .el-tag__close {
  display: none;
}
.form-class .el-upload-list--picture-card .el-upload-list__item {
  width: 80px;
  height: 80px;
  overflow: hidden;
}
.form-class .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.form-class .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 78px;
  background: transparent;
  border: 1px dashed #c0ccda;
  background: transparent;
  overflow: hidden;
  text-align: center;
  // padding-top: 25px;
}

.form-class .el-upload--text {
  width: 100%;
  color: #c7c7c7;
  border-radius: 4px;
  text-align: center;
}

.form-class .el-form-item--label-top .el-form-item__label {
  font-weight: 700;
  color: #333333;
  margin-bottom: 0;
}
.img-file-class .el-upload__text:hover {
  background-color: #f1f8ff;
  border-color: #4e86ff;
  color: #4e86ff;
}

.widget-one-layer .el-tag {
  float: left;
  background-color: #edf3ff;
  border: 1px solid #dce7ff;
  height: 30px !important;
  padding: 0 10px !important;
  margin: 4px 2px 0 !important;
  line-height: 30px !important;
  font-size: 12px !important;
  color: #4e86ff;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
}

/*时间选择框点击效果*/
/*联系人控件*/
.relation-user {
  width: 100%;
  min-height: 40px;
  height: auto;
  display: inline-block;  
  color: #606266;
  border: 1px solid #CCCCCC;
  box-sizing: border-box;
  border-radius: 4px;
}

.relation-user .el-input__wrapper {
  padding: 0 !important;
  box-shadow: none;
}

.relation-user .el-tag {
  background-color: #4e86ff;
  color: white;
}

.relation-user .el-tag:hover {
  color: white;
}

.relation-user .el-tag .el-tag__close {
  background: white;
  color: #666666;
}

.relation-user .el-tag .el-tag__close:hover {
  color: #333333;
  background: #F7F7F7;
}

.relation-org-role {
  padding: 0 5px;
  line-height: 38px;
}

.widget-ti .input-widget {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.el-date-editor .el-range__icon {
  font-size: 14px;
  margin-left: -5px;
  color: #c0c4cc;
  float: left;
  line-height: 32px;
}
.el-date-editor .el-range-input {
  appearance: none;
  border: none;
  outline: none;
  display: inline-block;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 39%;
  text-align: center;
  font-size: 14px;
  color: #606266;
}
.el-date-editor .el-range-separator {
  display: inline-block;
  height: 100%;
  padding: 0 5px;
  margin: 0;
  text-align: center;
  line-height: 32px;
  font-size: 14px;
  width: 5%;
  color: #303133;
}
.el-date-editor .el-range__close-icon {
  font-size: 14px;
  color: #c0c4cc;
  width: 25px;
  display: inline-block;
  float: right;
  line-height: 32px;
}

.select-details .el-select__tags span .el-tag {background-color:rgba(255,255,255,0)!important; visibility: hidden;padding: 0 20px 0 10px;margin-top: 1px;margin-bottom:1px;}
.select-details .demo-tag {display: inline-block;padding: 0 20px 0 10px;border-radius: 4px !important; color: #fff;background: #4e86ff !important;margin-top: 5px; line-height: 32px !important;font-size:12px;margin-top: 1px;margin-bottom:1px;}
.widget-one-layer .select-details .el-input__prefix, .select-details .el-input__prefix{
  right: 30px;
  overflow: hidden;
  padding-left: 1px;
  text-align: left !important;
}
.ridiotagstyle{
  // 浏览器设置80%比例显示不完整
  //max-width: calc(100% - 26px);
  margin-right:10px;
  padding: 0 8px;
  color:#333;
  display: inline-block;
  height: 30px;
  line-height: 30px;
  border-radius: 10px;
  background: #fff;
}
.el-icon-date {
  color: #3DA185;
}
:deep(.form-class .widget-one-layer .el-select__caret) {
  color: #3DA185 !important;
}
.widget-one-layer .is-active input:focus {
  border: 1px solid transparent !important;
}
.widget-one-layer .el-range-editor.is-active {
  border: 1px solid #4e86ff;
}
.widget-one-layer .is-error input:nth-child(1) {
  border: 1px solid #f56c6c !important;
}
.widget-one-layer .input-details .el-tag--light {
  max-width: 100%;
  white-space: inherit;
  height: auto;
  line-height: 20px;
}
.select-text li {
  line-height: 20px;
  white-space: inherit;
  font-size: 14px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.select-text li:hover {
  color: #965500;
  background: #fffdf6;
  font-weight: bold;
}
/*对齐展示模式==不需要就全部删除就行*/
.widget-one-layer .el-form-item__label {
  padding-left: 0 !important;
  padding-bottom: 3px !important;
  position: relative;
}
.widget-one-layer .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
  position:inherit !important;
  left: 0 !important;
}
/*日期**/
// .widget-one-layer .el-input__inner,
// .widget-one-layer .el-textarea__inner {
//   padding-left: 10px;
// }
// .widget-one-layer .el-input--prefix .el-input__inner {
//   padding-left: 10px;
// }
// .widget-one-layer .input-details .el-input--prefix .el-input__inner {
//   padding-left: 10px;
// }

.widget-one-layer .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.widget-one-layer .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  position: absolute;
  top: 3px;
  left: 2px;
}
/*表格增加文字对其使用padding*/
.caozuo {
  padding: 8px 0 !important;
}
/*联系人控件*/

.relationUserStyle {
  line-height: 20px;
  padding: 5px 10px;
  background-color: #4e86ff;
  margin: 4px 2px 0;
  display: inline-block;
  color: white;
  border-radius: 4px;
  font-size: 14px;
}
.query-value1{
  position:relative;
  width:100%;
  padding:0 42px 0 12px;
  height: 40px;
  line-height: 38px;
  font-size: 14px;
  color: #4E86FF;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #4E86FF;
  box-sizing: border-box;
  .icon-right{
    position: absolute;
    right: 6px;
    top: 0;
  }
}
.widget-one-layer {
  .query-value3{
    position:relative;
    .icon-sousuo{
      position:absolute;
      left:12px;
      top:0;
      z-index:3;
      color:#4E86FF;
    }
    .el-input__inner{
      padding-left:32px;
      color:#4E86FF;
    }
  }
}
// 签名板
.signa{
    border-radius: 8px !important;
    overflow: hidden;
    padding: 0 !important;
  .el-dialog__header{
    padding: 0 12px 0 31px;
    height: 52px;    
    background: #f5f5f5;
    .el-dialog__title{
      line-height: 52px;
      font-size: 16px;
      color:#333;
    }
    .el-dialog__headerbtn{
      height: 52px;
    }
  }
  .el-dialog__body{
    padding: 31px 0 31px 31px;
    .sign {
      clear: both;
      overflow: hidden;
      .pc {
        float: left;
        width: 582px;
        position: relative;
        h6 {
          height: 30px;
          line-height: 30px;
          font-weight: normal;
          font-size: 16px;
          color: #333;
          margin-bottom: 16px;
        }
        .box{
          border-radius: 8px;
          background-color: #F6F7F8;
        }
        .clear{
          position: absolute;
          right: 20px;
          bottom: 17px;
        }
      }
      .phone {
        float: right;
        width: 286px;
        text-align: center;
        padding-top: 45px;
        .tip1 {
          font-size: 16px;
          color: #333;
          line-height: 24px;
          padding-bottom: 10px;
        }
        .code {
          width: 198px;
          height: 198px;
          margin:0 auto;
          padding:4px;
          border: 1px solid #e4e4e4;
          border-radius: 8px;
          box-sizing: border-box;
        }
        .upload-sign {
          position: relative;
          width: 198px;
          height: 42px;
          line-height: 42px;
          font-size: 14px;
          color: #4e86ff;
          text-align: center;
          margin: 0 auto;
          border-radius: 4px;
          border: 1px solid #4e86ff;
          cursor: pointer;
          input {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            z-index:3;
            opacity: 0;
            cursor: pointer;
          }
        }
        .tip2 {
          font-size: 12px;
          color: #666;
          line-height: 18px;
          padding: 14px 0;
        }
      }
    }
  }
  .el-dialog__footer{
    padding: 10px 20px 20px;
  }
}
</style>
<style scoped lang="scss">
.no-back {
  background-color: transparent !important;
  padding: 0 !important;
}
.text-link {
  text-decoration: underline;
  color: #4e86ff;
  cursor: pointer;
}
.details-table-al {
  border-left: 1px solid #E0E2E4;
  border-right: 1px solid #E0E2E4;
  border-bottom: 1px solid #E0E2E4;
  border-radius: 6px 6px 4px 4px;
  position: relative;
  .details-table-all {
    margin: 10px;
  }
  .details-table-hr {
    width: 100%;
    height: 0;
    border-bottom: 1px solid #E0E2E4;
  }
  .details-table-he {
    display: flex;
    align-items: center;
    overflow-x: auto;
    margin-bottom: -1px;
    overflow-y: hidden;
    // border-bottom: 1px solid #E0E2E4;
    &::before {
      content: ' ';
      width: 2px;
      height: 45px;
      display: block;
      position: absolute;
      right: -1px;
      top: 0;
      background:#fff;
    }
    .details-table-he-list {
      padding: 15px 16px;
      border-right: 1px solid #E0E2E4;
      border-top: 1px solid #E0E2E4;
      border-bottom: 1px solid #E0E2E4;
      background-color: #F7F7F7;
      color: #333333;
      font-weight: 400;
      font-size: 16px;
      white-space: nowrap;
      cursor: pointer;
      &:nth-child(1) {
        border-top-left-radius: 6px;
      }
      &:last-child {
        border-top-right-radius: 6px;
      }
    }
    .details-table-he-active {
      color: #4E86FF;
      background-color: #fff;
      border-bottom-color: #fff;
    }
  }
}
.time-md-m {
  display: flex;
  align-items: center;
  .time-md {
    width: 30%;
    max-width: 160px;
    min-width: 90px;
    position: relative;
    margin-left: 10px;
    .time-md-text {
      position: absolute;
      top: 0;
      left: 10px;
      pointer-events: none;
    }
  }
}
.time-y-m {
  position: relative;
  width: 100%;
  :deep(.el-input__inner) {
    color: #ffffff;
  }
  .time-y-m-text {
    position: absolute;
    top: 0;
    left: 30px;
    pointer-events: none;
    line-height: 40px;
  }
}
.time-text-color {
  :deep(.el-input__inner) {
    color: #606266;
  }
  .time-y-m-text {
    display: none;
  }
}
.label-file {
  display: flex;
  align-items: flex-start;
  margin-top: 11px;
  margin-bottom: 11px;
  .form-labet-class-text, .label-file-right {
      width: 50%;
  }
  .label-file-label {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding-bottom: 5px;
      &:last-child {
          padding-bottom: 0;
      }
  }
  .file-list-title {
      color: #333333;
      i {
          color: #999999;
          margin-right: 10px;
      }
  }
  .icon-b-shezhi {
      color: #4E86FF;
      cursor: pointer;
  }
}
.label-richTextWid {
  margin-top: 11px;
  margin-bottom: 11px;
  min-height: 16px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #ffffff;
  :deep(.editor-wrapper) {
      border: none;
  }
  :deep(.w-e-text-container) {
      background-color: transparent;
      min-height: 16px !important;
      color: inherit;
  }
  :deep(.w-e-scroll > div) {
      min-height: 16px !important;
  }
}
.file-label {
  position: relative;
  display: inline-block;
}
.file-label-down {
  position: absolute;
  right: 0;
  color: #4e86ff;
  cursor: pointer;
  font-size: 14px;
  font-weight: normal;
}
.r-c-select {
  display: flex;
  align-items: center;
}
:deep(.check-inp) {
  line-height: normal;
  .el-select__prefix {
    width: calc(100% - 20px);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .demo-tag {
      margin-top: 0px;
    }
  }
  .el-select__selection {
    display: none;
  }
}
.r-c-block {
  border-radius: 4px;
  border: 1px solid #F9F9F9;
  background-color: #ffffff;
  .r-c-header {
    display: flex;
    align-items: center;
    background-color: #F9F9F9;
    height: 36px;
    overflow-x: auto;
    overflow-y: hidden;
    .r-c-list {
      color: #999999;
      font-size: 14px;
      padding-left: 25px;
      padding-right: 25px;
      line-height: 36px;
      cursor: pointer;
      white-space: nowrap;
    }
    .r-c-list-active {
      color: #4E86FF;
      background-color: #ffffff;
      border-radius: 4px 0px 0px 0px;
    }
  }
  .r-c-content {
    padding: 16px 0 5px 16px;
    .radio-list-imgs {
      margin-bottom: 10px;
    }
  }
}
.widget-rat {
  margin-top: 36px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px 4px 5px 20px;
  border-radius: 4px;
  background-color: #F9F9F9;
  position: relative;
  .widget-rat-header {
    position: absolute;
    top: -38px;
    background-color: #F9F9F9;
    display: inline-block;
    left: 0;
    padding: 1px;
    .widget-rat-header-list {
      background-color: #FFFFFF;
      border: 1px solid #F9F9F9;
      padding: 8px 12px; 
      line-height: 20px;
      cursor:pointer;
      color: #999999;
    }
    .widget-rat-header-active {
      border-radius: 4px 0px 0px 0px;
      background-color: #F9F9F9;
      color: #4E86FF;
    }
    .widget-rat-header-close {
      font-size: 14px;
    }
  }
  .widget-rat-list {
    width: 99px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    background-color: #FFFFFF;
    border: 1px solid #EDEDED;
    color: #666666;
    font-size: 14px;
    text-align: center;
    margin-right: 16px;
    margin-bottom: 15px;
    cursor:pointer;
  }
  .widget-rat-active {
    background-color: #F1F8FF;
    color: #4E86FF;
  }
  .widget-rat-disp {
    background-color: #EDEDED;
  }
}
.widget-ti {
  position: absolute;
  top: -36px;
  right: 0;
  height: 30px;
  .widget-ti-t {
    display: flex;
    align-items: center;
    color: #666666;
    font-size: 14px;
    i {
      margin-left: 12px;
    }
  }
  .input-widget {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }
}
.widget-b {
  display: flex;
  align-items: center;
  .widget-list {
    border-radius: 4px;
    background-color: #FFFFFF;
    border: 1px solid #EDEDED;
    line-height: 20px;
    color: #666666;
    font-size: 14px;
    text-align: center;
    padding: 8px 14px;
    margin-right: 12px;
    cursor: pointer;
    .widget-list-d {
      min-width: 85px;
    }
  }
  .widget-active {
    background-color: #F1F8FF;
    color: #4E86FF;
  }
}
.pl-button {
  justify-content: left;
  // 不知道哪里有用到这个padding-left，但是明细里因为这个导致按钮不是居左对齐，先注释，后面有问题再核对（hjin 23.12.13）
  // padding-left: 60px;
  .add-button {
    color: #59B97B;
  }
  .add-button-del {
    color: #D44D4D;
  }
}
.widget-one-layer .el-col:nth-child(1) {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.widget-one-layer .el-col:last-of-type {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.widget-one-layer-row {
  :deep(.el-form-item) {
    margin-top: 11px;
    margin-bottom: 11px;
    .el-form-item__content {
      display: block;
      &>span {
        display: block;
        line-height: 20px;
        padding-bottom: 6px;
        font-weight: 700;
        color: #333;
        overflow: hidden;
        width: 100%;
        flex-wrap: wrap;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      // .el-input__wrapper {
      //   padding: 0;
      // }
      // .el-input__inner {
      //   border-radius: 4px;
      //   height: 38px;       
      //   line-height: 38px;
      //   padding: 0 10px;
      //   font-size: 14px;
      //   color: #333;
      //   background-color: #fff;
      //   border: 1px solid #d2d2d2;
      //   box-shadow: none;
      // }
      // .el-textarea__inner {
      //   border-radius: 4px;
      //   padding: 5px 10px;
      //   font-size: 14px;
      //   color: #333;
      //   background-color: #fff;
      //   border: 1px solid #d2d2d2;
      //   box-shadow: none;
      //   &:hover {
      //     box-shadow: none;
      //   }
      // }      
    }
  }
}

.col4 {
  :deep(.el-form-item) {
    .el-form-item__label {
      // min-width: 160px;
      // max-width: 160px;
      width: 100px !important;
      display: inline-block;
      white-space: inherit;
      padding-bottom: 0 !important;
    }
    .el-form-item__content {
      flex: 1;
    }
  }
}

.phonelayout-t {
  :deep(.el-form-item) {
    display: flex;
    align-items: center;
    .el-form-item__label {
      flex: 0 0 120px;
      // min-width: 160px;
      white-space: inherit;
      padding-bottom: 0 !important;
    }
    .el-form-item__content {
      flex: 1;
      min-width: 0;
    }
  }
  .con-row {
    :deep(.el-form-item .el-form-item__label) {
      width: auto !important;
      padding-right: 12px;
      min-width: 50px;
    }
  }
}
.fiexd-canvas {
  :deep(.el-col) {
    display: grid;
  }
}
.layout-l {
  display: flex;
  align-items: center;
  :deep(.el-form-item__label) {
    flex: 0 0 120px;
    // min-width: 160px;
    white-space: inherit;
    padding-bottom: 0 !important;
  }
  :deep(.el-form-item__content) {
    flex: 1;
    min-width: 0;
  }
}
.label-zh {
  :deep(.el-form-item__label) {
    font-size: 16px;
  }
}
:deep(.widget-one-layer .select-details .el-input--prefix .el-input__inner) {
    padding-left: 10px !important;
}

.ready-widget-continue-model {
  display: flex;
  &-item {
    display: flex;
    align-items: center;
    margin-left: auto;
    .model-item-title {
      white-space: nowrap;
      margin-right: 10px;
    }
  }
}

.rel-check {
  padding-top: 20px;
  padding-bottom: 20px;
  border-top: 1px dashed #D8D8D8;
  border-bottom: 1px dashed #D8D8D8;
  margin-bottom: 22px;
  .rel-check-name {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
    padding-bottom: 10px;
    position: relative;
  }
}
.rel-radio-dialog {
  position: absolute;
  left: 0;
  width: 100%;
  .rel-radio-dialog-back {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.36);
    z-index: 9;
  }
  .rel-radio-dialog-new {
    position: relative;
    z-index: 10;
    background-color: #ffff;
    left: -100%;
    transition: 0.3s;
    padding: 20px 20px 0 20px;
    width: calc(100% + 50px);
    // :deep(.el-form-item__label) {
    //   display: none !important;
    // }
    // 先注释，单选关联如果设置了就不显示了
  }
}
.rel-radio-name {
  display: flex;
  align-items: center;
  position: relative;
  .rel-radio-name-name {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
  }
}
.rel-radio-name-button {
  height: 20px;
  line-height: 20px;
  background: #FFFFFF;
  border-radius: 4px;
  border: 1px solid #4e86ff;
  font-size: 12px;
  color: #4e86ff;
  padding-left: 6px;
  padding-right: 6px;
  margin-left: 8px;
  cursor: pointer;
  font-weight: 400;
}
.rel-radio-center {
  // padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 20px;
  // margin-top: 20px;
  :deep(.el-row--flex) {
    display: flex !important;
  }
  .right-block-text {
    background-color: #fcfcfc;
  }
}
.radio-list, .radio-list-view {
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  .radio-list-button {
    padding: 5px 16px;
    border-radius: 4px;
    line-height: 20px;
    border: 1px solid #C0C4CC;
    margin-right: 10px;
    cursor: pointer;
    margin-bottom: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  .radio-list-imgs {
    width: 102px;
    height: 132px;
    margin-right: 10px;
    line-height: 0;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1px solid transparent;
    cursor: pointer;
    .radio-list-img {
      width: calc(100% - 2px);
      height: 100px;
      position: relative;
      padding-left: 1px;
    }
    .radio-list-text {
      width: 100%;
      text-align: center;
      line-height: 32px;
      color: #333333;
    }
    .no-icon {
      position: absolute;
      left: calc(50% - 15px);
      top: calc(50% - 15px);
      font-size: 30px;
      color: #E6E8EB;
    }
  }
}
.radio-list-view {
  .radio-list-imgs {
    margin-bottom: 5px !important;
    margin-top: 5px !important;
    border: none;
    padding: 0 !important;
    .radio-list-img {
      padding-top: 1px;
      border-top-left-radius: 5px;
      border-top-right-radius: 4px;
    }
    .radio-list-text {
      display: block;
      width: calc(100% - 22px);
      background-color: #ffffff;
      line-height: 30px;
      margin-left: 1px;
      padding-left: 10px;
      padding-right: 10px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  .radio-list-button {
    border: none;
  }
}
.annotation-top, .annotation-bottom {
  // padding-left: 10px;
  color: #99A3AD;
  font-size: 12px;
  line-height: 12px;
}
.annotation-bottom {
//   line-height: 22px;
  padding-top:4px;
}
.annotation-top {
  padding-bottom:4px;
}
.file-img-up .el-upload-list, .img-file-class >>> .el-upload-list{
  // display: none !important;
}

.signa-box{
  // display: flex
}
.signaPic{
  float: left;
  position: relative;
  width: 88px;
  height: 88px;
  border: 1px solid #EDEDED;
  border-radius: 3px;
  margin: 0 24px 24px 0;
  display: flex;
  align-items: center;
  text-align: center;
  img {
    display: block;
    max-width: 100%;
    margin:0 auto;
  }
  .btn-delete {
    position: absolute;
    right: -6px;
    top: -4px;
    width: 16px;
    height: 16px;
    background: url("https://bigdata.topeti.com/PCRepository/mainPlatform/icon-delete.png") no-repeat;
    cursor: pointer;
  }
}
.signabtn{
    float: left;
    display: block;
    width: 88px;
    height: 88px;
    font-size: 12px;
    color: #333;
    line-height: 20px;
    padding-top: 51px;
    box-sizing: border-box;
    text-align: center;
    background: #f7f7fa url("https://bigdata.topeti.com/PCRepository/mainPlatform/icon-sign.png") no-repeat 50% 19px;
    border: 1px dashed #EDEDED;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 24px 24px 0;
    transition: all .5s;
    &:hover{
      color: rgb(87, 168, 251);
    }
  }
  .show_imglist {
    width: 100%;
    overflow: hidden;

    li {
      display: flex;
      align-items: center;
      padding: 0 5px 0 4px;
      overflow: hidden;
      height: 26px;
      line-height: 26px;
      &:hover {
        background-color: #f5f7fa;
        transition: color 0.3;
      }
      &:hover i:nth-child(2) {
        display: block !important;
      }
      &:hover span i:nth-child(1) {
        display: none !important;
      }

      &:hover a {
        color: #4e86ff;
      }
      a {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-decoration: none;
        color: #666;
        padding-left: 3px;
        width: 80%;
      }
      .icon_to {
        position: absolute;
        right: 5px;
        i:nth-child(2) {
          display: none;
        }
      }
    }
  }

  .on-show-left {
    background-color: #ffffff !important;
    border-color: #ffffff !important;;
    justify-content: left !important;;
    padding-left: 12px;
  }
  :deep(.el-form-item__content:hover .on-show-left){
    color: #317CDF !important;
    cursor: pointer !important;
  }
  .on-show-pointer {
    :deep(.el-input__inner) {
      cursor: pointer;
    }
  }
.on-show {
  text-align: center;
  color: #4e86ff;
  .on-show-show {
    position:absolute;
    width:calc(100% - 2px);
    top:0;
    left:0;
    z-index:9;
    cursor: pointer;
    background-color:#F1F8FF;
    border: 1px solid #4e86ff;
    border-radius: 4px;
    height: calc(100% - 2px);
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 6px;
    }
  }
  .details-show {
    width: 123px;
    height: 36px;
    position: relative;
  }
  .on-show-close {
    cursor: pointer;
    position: absolute;
    right: 0;
    z-index: 8;
    margin-right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .on-select {
    right: 15px;
  }
}
.time-block {
  display: flex;
  align-items: center;
  .time-week {
    min-width: 64px;
    text-align: center;
    height: 38px;
    background: #F2F2F2;
    border-radius: 2px;
    border-width: 1px;
    border-style: solid;
    border-color: #D8D8D8;
    margin-left: 4px;
    font-size: 14px;
    color: #999999;
  }
}
.a-list-img {
  display: inline-block;
  vertical-align: top;
  width: 70px;
  max-height: 70px;
  background-color: rgb(247, 247, 247);
  overflow: hidden;
  margin-right: 10px;
}
.other-class:focus {
  outline: none;
}
.other-class {
  width: calc(100% - 42px);
  height: 40px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border: 1px solid #d2d2d2;
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 22px;
}
.ready-class {
  background-color: #f7f7f7;
  overflow: hidden;
  padding: 10px;
  border-radius: 4px;
}
.details-title-top {
  position: relative;
  display: flex;
  align-items: flex-end;
  padding-bottom: 5px;
  line-height: 20px;
  padding-left: 10px;
  justify-content: space-between;
  &:after{
    content: "";
    position: absolute;
    left: 0;
    top:3px;
    display: block;
    width: 3px;
    height: 14px;
    background:#4e86ff;
    border-radius: 5px;
  }
}
.no-label:after {
  display: none;
}
.button-details {
  // min-width: 184px;
  display: flex;
  .icon-guanbiyanjing {
    color: #4e86ff;
    cursor: pointer;
    margin-right: 10px;
  }
}
.time-class-top:hover {
  background-color: #fffdf6;
  border-color: #f6e8d0;
  color: #333333;
}
.time-class-top:hover .icon-font-class {
  color: #666666;
}
.time-class-top {
  color: #4284ba;
  padding: 8px 10px;
  text-align: center;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  border-width: 1px;
  border-style: dashed;
  border-color: #e2e0dc;
  cursor: pointer;
}
.icon-font-class {
  font-size: 18px;
  vertical-align: baseline;
  color: #4284ba;
  margin-right: 5px;
}
.icon-del-hover:hover {
  color: #efb518;
}
.color-red {
  color: #d44c4c !important;
}
.cor-7E1 {
  color: #3aa7e1;
}
.icon-bianji {
  color: #3faf67;
}
.textarea-list:hover {
  background: #fffdf6;
  color: #965500;
}
.textarea-list {
  line-height: 20px;
  padding-top: 9px;
  padding-bottom: 11px;
  cursor: pointer;
  color: #666666;
}
// .textarea-rel:after {
//   content: "\e6e1";
//   color: #dcdcdc;
//   font-size: 12px;
//   position: absolute;
//   top: -7px;
//   left: 30px;
// }
// .textarea-rel:before {
//   content: "";
// }
.textarea-rel {
  max-height: 270px;
  position: absolute;
  top: 60px;
  border: 1px solid #dcdcdc;
  z-index: 9999;
  width: calc(100% - 42px);
  font-size: 14px;
  padding: 7px 20px;
  background: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  overflow: hidden;
}
.textarea-right {
  position: absolute;
  right: 0;
  bottom: -20px;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.el-upload__text {
  width: calc(50% - 25px);
}
.img-file-class {
  width: 100%;
}
.icon-img-file-class {
  margin-left: 25px;
  color: #c7c7c7;
}
.right-block-text {
  width: calc(100% - 20px);
  /*line-height: 20px;*/
  background: #f7f7f7;
  padding: 0 10px;
  min-height: 20px;
  display: block;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  /*white-space: nowrap;*/
  /*word-break: break-all;*/
  word-wrap: break-word;
}
.right-block-number{
  display: flex;
  min-height: 40px;
}
/*.new-rel-radio-block {*/
/*  padding: 10px 17px;*/
/*}*/
.right-remark {
  font-size: 14px;
  color: #f45e15;
  padding-top: 10px;
  text-align: center;
}
.hr {
  border-top: 1px dashed #e5ddc8;
  border-bottom: 1px dashed #e5ddc8;
  padding: 15px 0 0;
  margin-bottom: 15px;
  /*overflow: hidden;*/
}
.button-rel {
  position: relative;
  width: 100%;
  display: block;
}

.icon-rel:before {
  position: relative;
  top: 10px;
  left: 20px;
}
.icon-rel:hover {
  color: #965500;
  background-color: #fffdf6;
  border-color: #f6e8d0;
}
.icon-rel {
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  /*padding: 0 10px;*/
  height: 36px;
  width: 56px;
  margin-top: -5px;
  line-height: 100%;
  cursor: pointer;
  z-index: 2;
  color: #999999;
  background-color: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  font-size: 18px;
  border: 1px dashed #e2e0dc;
}
.button-add-icon {
  color: #4e86ff;
  vertical-align: middle;
  margin-right: 5px;
}
.add-button {
  cursor: pointer;
  padding: 0 6px 0 6px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  display: inline-block;
  font-size: 14px;
  color: #333333;
}
.add-button:hover {
  color: #4e86ff;
}
.left-icon {
  font-size: 14px;
  color: #6c3d00;
}
.no-write-radio {
  line-height: 40px;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 10px;
  max-width: 50%;
}
.icon-text,
.icon-text i {
  font-size: 12px;
  margin-left: 5px;
  color: #e2a000;
  cursor: pointer;
}
.icon-text i {
  margin-right: 5px;
}
.no-write {
  background: #f7f7f7;
  padding-left: 10px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  display: flex;
  color: #333333;
  align-items: center;
}
.a-list {
  color: #4e86ff;
  display: block;
  cursor: pointer;
}
.a-list:hover {
  color: #cf7500;
}
.list-block {
  font-weight: normal;
  padding: 8px;
  -webkit-border-radius: 10px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  // border-radius: 10px;
  margin-right: 4px;
  line-height: 1;
  display: inline-block;
}
.list-img {
  width: 100%;
  height: auto;
  margin-right: 10px;
}
/*新增*/
.widget-one-layer {
  width: 80%;
  height: auto;
  padding-top: 24px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 24px;
  // background-color: #F9F9F9;
}
.widget-one-layer-news {
  :deep(.el-form-item__label) {
    display: none;
  }
}
.form-labet-class {
  // min-height: 44px;
  margin-bottom: 18px;
}


.top-annotations {
  margin-bottom: 20px;
}
.bottom-annotations {
  margin-top: 20px;
}
.annotations{
  font-weight: 500;
  color: #4e86ff;
  height: 20px;
  font-size: 14px;
  display: flex !important;
  align-items: center;
  margin-left: -12px;
  &-content {
    position: relative;
    width: fit-content;
    margin-right: 12px;
    &::after {
      content: '';
      width: 66px;
      position: absolute;
      height: 4px;
      background: linear-gradient(270deg, rgba(232,243,255,0) 0%, #4e86ff 100%);
      bottom: -4px;
      left: 0;
    }
  }
  &-right {
    flex: 1;
    height: 1px;
    background-color: #4e86ff;
  }
}

.form-labet-class-text {
  min-height: 20px;
  position: relative;
  display: inline-block;
  line-height: 20px;
  color: #333333;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  position: relative;
  padding-left: 0;
  &::after {
    content: '';
    width: 3px;
    height: 15px;
    background: #4e86ff;
    position: absolute;
    border-radius: 1px;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
  }
}

/*联系人控件*/
.relation-radio {
  cursor: pointer;
  min-height: 38px;
  line-height: 38px;
  font-weight: normal;
  height: auto;
  text-align: center;
  display: block;
  padding-left: 5px;
  border-radius: 4px;
  border: 1px dashed #e2e0dc;
  padding: 8px 20px 9px !important;
  color: #4284ba;
}

.relation-radio i {
  color: #4284ba;
}
.relation-radio:hover {
  border-color: #f6e8d0;
  background-color: #fffdf6;
  color: #333333;
}
.relation-radio:hover i {
  color: #666666;
}
/*预约时间控件*/
.time-class {
  width: 100%;
  height: auto;
  display: inline-block;
  min-height: 40px;
  /*padding: 5px 15px;*/
  box-sizing: border-box;
  /*cursor: pointer;*/
  /*border-radius: 4px;*/
  /*border: 1px dashed #D2D2D2;*/
}
.time-class p {
  line-height: 1.2;
}
.time-class .time-class-wrap {
  // margin-top: 5px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.time-class .time-class-wrap p {
  // width: 48%;
  // margin-top: 5px;
  // margin-left: 5px;
  line-height: 20px;

}
.time-class .time-class-wrap p .date{
  color: #333333;
}
.time-class .time-class-wrap p:nth-child(even) {
  // text-align: right;
}
.time-class .time-class-wrap p span:nth-of-type(1) {
  // color: #666666;
}
.time-class .time-class-wrap p span:nth-of-type(2) {
  // margin-left: 15px;
}

/*容器控件*/
.container-wrap {
  padding-top: 15px;
  .container-title {
    color: #333333;
    font-weight: bold;
    font-size: 14px;
    padding-bottom: 15px;
    padding-left: 10px;
    line-height: 20px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 3px;
      display: block;
      width: 3px;
      height: 14px;
      background: #4e86ff;
      border-radius: 5px;
    }
  }
  .container-cont {
    border-radius: 4px;
    background-color: #F9F9F9;
    padding: 0 15px 0 15px;
  }
  .con-row {
    display: flex;
    align-items: flex-start;
    .container-tt {
      margin-right: 20px;
      // flex: 1;
      &:last-child {
        margin-right: 0;
        flex: 1;
      }
    }
  }
}
// .container-wrap {
//   /deep/ .el-form-item {
//     display: flex;
//     align-items: inherit !important;
//     .el-form-item__label {
//       width: auto;
//       max-width: 160px;
//       // width: 160px;
//       // min-width: 160px;
//       white-space: nowrap;
//       padding-top: 11px;
//       padding-bottom: 0 !important;      
//     }
//     .el-form-item__content {
//       width: 100%;
//       .con-row {
//         display: flex;
//         &>div {
//           margin-right: 20px;
//           &:last-child {
//             margin-right: 0;
//           }
//         }
//         .el-form-item {
//           margin-top: 0;
//         }
//       }
//       .el-form-item .el-form-item {
//         margin: 0; //日期控件会有两个el-form-item，就会有双倍margin
//       }
//     }
//   }
// }


.a-list-block {
  line-height: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.el-dropdown-link,
.a-list-download {
  color: #4e86ff;
  margin-left: 10px;
  text-decoration: none;
  cursor: pointer;
  min-width: 30px;
}
.el-menu-scrollbar__wrap {
  border: 1px solid #eee;
  padding: 5px 0px 5px 10px;
  width: calc(100% - 10px);
  /*height:120px;*/
}
.el-checkbox-group .el-checkbox {
  margin-top: 4px;
}
.el-radio-group .el-radio {
  margin-top: 4px
}
.el-checkbox-group .el-checkbox .checkboxvalue,
.el-radio-group .el-radio .radiovalue {
  padding: 4px 8px;
  border-radius: 10px;
}
.dialog-imgset {
  background:#FAFAFB;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
  .el-dialog__header {
    background: #fff;
    padding: 0;
    border-bottom: none;
    .dialog-title {
      height: 48px;
      width: 100%;
      border-radius: 8px 8px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 16px 0 24px;
      box-sizing: border-box;
      .title {
        font-weight: 600;
        line-height: 26px;
        color: rgba(1, 25, 51, 1);
        font-size: 18px;
      }
      .close {
        width: 24px;
        height: 24px;
        &:hover {
          i {
            color: #4e86ff;
          }
        }
        i {
          display: inline-block;
          transition: 0.3s;
          font-size: 24px;
          color: rgba(52, 71, 92, 1);
          cursor: pointer;
        }
      }
    }
  }
  .el-dialog__body {
    padding: 0;
    .up-img-block {
      padding: 16px;
      text-align: center;
    }
    .up-img-crop {
      width: 800px;
      height: 600px;
      margin: 0 auto;
    }
    .operate{
      padding:16px;
      border-top:1px solid #F5F6F7;
      text-align: right;
      button {
        margin:0 8px;
        padding:0 20px !important;
        height: 32px;
        line-height: 7px;
      }
    }
  }
}
.opensafe {
  padding: 0;
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-right: 0;
  // padding-left: 0;
  // padding-right: 0;
  // width: calc(100% - 80px);
  // margin-left: 40px;
  // margin-right: 20px;
}
.relation-user-wrap {
  position: relative;
  background: #fff;
  .drop-down {
    position: absolute;
    top: 42px;
    width: 100%;
  }
  // :deep(.el-input) {
  //   width: 105px !important;
  // }
  :deep(.el-input__inner) {
    padding: 0 0 0 5px;
    border: none !important;
  }
  .fast-btn {
    display: none;
    position: absolute;
    right: 0;
    top: 0;
    a {
      position: relative;
      float: left;
      display: block;
      width: 38px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #4e86ff;
      cursor: pointer;
      &::after{
        content: "";
        position: absolute;
        top: 9px;
        left: 0;
        width: 1px;
        height: 20px;
        background-color: #ccc;
      }
    }
  }
}
.relation-default {
  .relation-user {
    position: relative;
    padding-right: 77px;
  }
  .fast-btn {
    display: block;
  }
}
</style>
